
export default [
    {
        "id": -3,
        "shikenId": -1,
        "parentNo": 1,
        "no": 1,
        "groupId": 0,
        "answerType": 1,
        "inputType": 1,
        "question1": "次のうち、最も適切なものを選びなさい。",
        "question2": "１＋１は２である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": -2,
        "shikenId": -1,
        "parentNo": 1,
        "no": 2,
        "groupId": 0,
        "answerType": 1,
        "inputType": 1,
        "question1": "次のうち、最も適切なものを選びなさい。",
        "question2": "１＋１＝",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": -1,
        "shikenId": 0,
        "parentNo": 1,
        "no": 1,
        "groupId": 0,
        "answerType": 1,
        "inputType": 1,
        "question1": "次のうち、最も適切なものを選びなさい。",
        "question2": "１＋１は２である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 0,
        "shikenId": 0,
        "parentNo": 1,
        "no": 2,
        "groupId": 0,
        "answerType": 1,
        "inputType": 1,
        "question1": "次のうち、最も適切なものを選びなさい。",
        "question2": "１＋１＝",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1,
        "shikenId": 1,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "税理士資格を有しないファイナンシャル・プランナーが顧客からの要望により確定申告書を作成した場合、それが無償であれば税理士法に抵触しない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 2,
        "shikenId": 1,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "労働者災害補償保険（労災保険）の保険料は、労働者と事業主が折半で負担する。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 3,
        "shikenId": 1,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "公的介護保険の第２号被保険者は、市町村または特別区の区域内に住所を有する65歳以上の者である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 4,
        "shikenId": 1,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "確定拠出年金（個人型）の老齢給付金を一時金で受け取った場合、当該老齢給付金は、退職所得として所得税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 5,
        "shikenId": 1,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国民年金の付加保険料納付済期間を有する者が、老齢基礎年金の繰上げ支給の申出をした場合、付加年金は、老齢基礎年金と同様の減額率によって減額される。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 6,
        "shikenId": 1,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国内銀行の窓口において加入した個人年金保険は、生命保険契約者保護機構による補償の対象とならない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 7,
        "shikenId": 1,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "延長保険とは、一般に、現在加入している生命保険の保険料の払込みを中止し、その時点での解約返戻金を基に、元契約の保険金額を変えずに一時払いの定期保険に変更する制度である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 8,
        "shikenId": 1,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "逓減定期保険は、保険期間の経過に伴い保険料が所定の割合で減少するが、死亡保険金は保険期間を通じて一定である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 9,
        "shikenId": 1,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国内旅行傷害保険では、一般に、国内旅行中に発生した地震や津波によるケガも補償の対象としている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10,
        "shikenId": 1,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "生命保険の保険料は、純保険料および付加保険料で構成されており、このうち純保険料は予定死亡率に基づいて計算され、付加保険料は予定利率や予定事業費率に基づいて計算される。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11,
        "shikenId": 1,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "日経平均株価は、東京証券取引所プライム市場に上場する代表的な225銘柄を対象として算出される株価指標である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 12,
        "shikenId": 1,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国内総生産（ＧＤＰ）は、一定期間内に国内で生産された財やサービスの付加価値の総額を示すものであり、海外で生産された付加価値は含まれない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 13,
        "shikenId": 1,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "短期利付債と長期利付債を比較した場合、他の条件が同じであれば、一般に長期利付債のほうが金利変動に伴う債券価格の変動が大きい。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 14,
        "shikenId": 1,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "証券取引所における株式の売買において、成行注文は指値注文に優先して売買が成立する。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 15,
        "shikenId": 1,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "ＮＩＳＡの「成長投資枠」を利用して上場株式等を購入することができる限度額（非課税投資枠）は、年間240万円である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 16,
        "shikenId": 1,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "税金を負担する者と税金を納める者が異なる税を間接税といい、間接税の例として、消費税や所得税などが挙げられる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 17,
        "shikenId": 1,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "所得税において、2026年中に取得した建物（鉱業用減価償却資産等を除く）に係る減価償却の方法は、定率法である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 18,
        "shikenId": 1,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "納税者の配偶者が青色事業専従者として給与の支払を受けている場合、当該納税者は配偶者控除の適用を受けることができない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 19,
        "shikenId": 1,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "所得税において、事業的規模で行われている賃貸マンションの貸付による所得は、事業所得となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 20,
        "shikenId": 1,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "不動産の登記事項証明書の交付請求は、インターネットを利用してオンラインで行うことができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 21,
        "shikenId": 1,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "不動産登記には公信力が認められていないため、登記記録上の権利者が真実の権利者と異なっている場合に、登記記録を信じて不動産を購入した者は、原則として、その不動産に対する権利の取得について法的に保護されない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 22,
        "shikenId": 1,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "不動産取引において、買主が売主に解約手付を交付したときは、相手方が契約の履行に着手した後であっても、買主はその手付を放棄することで、売主はその倍額を現実に提供することで、それぞれ契約を解除することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 23,
        "shikenId": 1,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "都市計画法の規定によれば、市街化調整区域において行う開発行為で、その規模が1,000㎡未満であるものは、原則として都道府県知事等の許可を受ける必要はない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 24,
        "shikenId": 1,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "アパートやマンションの所有者が、当該建物の賃貸を自ら業として行う場合、宅地建物取引業の免許を取得する必要はない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 25,
        "shikenId": 1,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "都市計画区域内の防火地域内に耐火建築物を建築する場合、建築基準法による建蔽率および容積率の制限について緩和を受けることができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 26,
        "shikenId": 1,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "書面によらない贈与契約は、その履行前であれば、各当事者は契約の解除を申し出ることができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 27,
        "shikenId": 1,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "父からの贈与について相続時精算課税制度の適用を受けている子は、同一年中に母から受けた財産の贈与について暦年課税を選択することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 28,
        "shikenId": 1,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "「配偶者に対する相続税額の軽減」の適用を受けた場合、被相続人の配偶者の相続税の課税価格が、相続税の課税価格の合計額に対する配偶者の法定相続分または１億6,000万円のいずれか多い額までであれば、配偶者の納付すべき相続税額は算出されない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 29,
        "shikenId": 1,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "個人が法人からの贈与により財産を取得した場合、取得した財産は贈与税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 30,
        "shikenId": 1,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "個人間での取引において、時価と比べて著しく低い価額の対価で財産の譲渡が行われた場合、原則として、その譲渡があった時の当該財産の時価と譲渡対価の差額に相当する金額が、贈与税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 31,
        "shikenId": 1,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "利率（年率）３％で複利運用しながら10年後に800万円を得るために、運用開始時点で必要となる元本を試算する際に目標とする額に乗じる係数は、（　　）である。",
        "choice1": "1）現価係数",
        "choice2": "2）資本回収係数",
        "choice3": "3）減債基金係数",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 32,
        "shikenId": 1,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "健康保険の被保険者が、業務外での病気やケガの治療のため、連続して（ ① ）仕事を休んでいる場合に支給される傷病手当金の金額は、原則として、休業１日につき支給開始日の属する月以前12ヵ月間の各月の標準報酬月額の平均額を30で除した金額に、（ ② ）を乗じた額である。",
        "choice1": "1）① ２日以上　　② ２分の１",
        "choice2": "2）① ３日以上　　② ３分の２",
        "choice3": "3）① 10日以上　　② ４分の３",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 33,
        "shikenId": 1,
        "parentNo": 2,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "退職により健康保険の被保険者資格を喪失した者は、資格喪失日から（ ① ）以内に所定の申出をすることで、最長で（ ② ）、健康保険の任意継続被保険者となることができる。",
        "choice1": "1）① 10日　　② １年間",
        "choice2": "2）① 20日　　② ２年間",
        "choice3": "3）① １ヵ月　 ② ３年間",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 34,
        "shikenId": 1,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "住宅ローンの返済方法のうち、元利均等返済は、毎月の返済額が（ ① ）、返済期間の経過とともに毎月の元金の返済額が（ ② ）返済方法である。",
        "choice1": "1）① 減少し　　② 増加する",
        "choice2": "2）① 一定で　　② 減少する",
        "choice3": "3）① 一定で　　② 増加する",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 35,
        "shikenId": 1,
        "parentNo": 2,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "遺族厚生年金の額（中高齢寡婦加算額および経過的寡婦加算額を除く）は、原則として、死亡した者の厚生年金保険の被保険者期間を基礎として計算した老齢厚生年金の報酬比例部分の額の（ ① ）に相当する額となるが、死亡した者が短期要件に該当し、被保険者期間の月数が（ ② ）に満たない場合は、（ ② ）として計算される。",
        "choice1": "1）① ３分の２　　② 240月",
        "choice2": "2）① ４分の３　　② 300月",
        "choice3": "3）① ５分の４　　② 360月",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 36,
        "shikenId": 1,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "定期保険特約付終身保険（更新型）の契約内容を変更せずに自動更新すると、更新後の保険料は、通常、更新前と比較して（　　）。",
        "choice1": "1）変わらない",
        "choice2": "2）高くなる",
        "choice3": "3）安くなる",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 37,
        "shikenId": 1,
        "parentNo": 2,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "変額個人年金保険は、（ ① ）の運用実績に基づいて将来受け取る年金額等が変動するが、一般に、（ ② ）については最低保証がある。",
        "choice1": "1）① 特別勘定　　② 死亡給付金額",
        "choice2": "2）① 特別勘定　　② 解約返戻金額",
        "choice3": "3）① 一般勘定　　② 解約返戻金額",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 38,
        "shikenId": 1,
        "parentNo": 2,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "自動車損害賠償責任保険から支払われる、被害者１人当たりの保険金の限度額は、死亡の場合は（ ① ）、後遺障害の場合は障害の程度に応じて最高（ ② ）となる。",
        "choice1": "1）① 1,000万円　　② 2,500万円",
        "choice2": "2）① 3,000万円　　② 4,000万円",
        "choice3": "3）① 4,000万円　　② 3,000万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 39,
        "shikenId": 1,
        "parentNo": 2,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "個人賠償責任保険（特約）では、（　　）、法律上の損害賠償責任を負うことによって被る損害は、補償の対象とはならない。",
        "choice1": "1）被保険者の子供がボール遊びをしていて、他人の家の窓ガラスを割ってしまい",
        "choice2": "2）被保険者が自転車で走行中に歩行者に衝突し、ケガをさせてしまい",
        "choice3": "3）被保険者が友人から借りていたカメラを落として壊してしまい",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 40,
        "shikenId": 1,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "国内で事業を行う生命保険会社が破綻した場合、原則として、破綻した時点における（ ① ）の（ ② ）までの金額が生命保険契約者保護機構により補償される。",
        "choice1": "1）① 保険金額　　　② 50％",
        "choice2": "2）① 解約返戻金　　② 80％",
        "choice3": "3）① 責任準備金　　② 90％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 41,
        "shikenId": 1,
        "parentNo": 2,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "表面利率（クーポンレート）２％、残存期間４年の固定利付債券を額面100円当たり106円で購入した場合の最終利回り（年率・単利）は（　　）である。なお、税金等は考慮しないものとし、計算結果は表示単位の小数点以下第３位を四捨五入している。",
        "choice1": "1）0.23％",
        "choice2": "2）0.47％",
        "choice3": "3）0.62％",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 42,
        "shikenId": 1,
        "parentNo": 2,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "異なる２資産から構成されているポートフォリオにおいて、２資産間の相関係数が（ ① ）である場合、２つの資産が（ ② ）値動きをするため、分散投資によるリスクの低減効果は最大となる。",
        "choice1": "1）① －１　　② 反対の",
        "choice2": "2）①  ０　　　② 反対の",
        "choice3": "3）①  １　　　② 同じ",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 43,
        "shikenId": 1,
        "parentNo": 2,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "（　　）は、預金保険制度による保護の対象とならない。",
        "choice1": "1）普通預金",
        "choice2": "2）定期預金",
        "choice3": "3）外貨預金",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 44,
        "shikenId": 1,
        "parentNo": 2,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "追加型株式投資信託を基準価格10,000円（１万口当たり）で１万口購入した後、最初の決算期に１万口当たり500円の収益分配金が支払われ、分配落ち後の基準価格が9,700円（１万口当たり）となった場合、受け取った収益分配金のうち、普通分配金は（ ① ）であり、元本払戻金（特別分配金）は（ ② ）である。",
        "choice1": "1）① 500円　　②  0円",
        "choice2": "2）① 200円　　② 300円",
        "choice3": "3）① 300円　　② 200円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 45,
        "shikenId": 1,
        "parentNo": 2,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "元金1,000,000円を、年利３％（１年複利）で３年間運用した場合の元利合計金額は、税金や手数料等を考慮しない場合、（　　）である。",
        "choice1": "1）1,009,000円",
        "choice2": "2）1,060,900円",
        "choice3": "3）1,092,727円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 46,
        "shikenId": 1,
        "parentNo": 2,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "定年退職により退職金を受け取ったことによる退職所得の金額の計算上、収入金額から控除する退職所得控除額は、勤続年数が20年以下の期間については勤続年数に（ ① ）を乗じて計算し、20年を超える期間については１年につき（ ② ）を乗じて計算したものを合算する。",
        "choice1": "1）① 30万円　　②  60万円",
        "choice2": "2）① 40万円　　②  70万円",
        "choice3": "3）① 70万円　　② 100万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 47,
        "shikenId": 1,
        "parentNo": 2,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "Ａさんの2026年分の各種所得の金額が下記の場合、所得税における総所得金額は（　　）となる。<br><br><img src='/img/1_47_1780886165832863_1.png'>",
        "choice1": "1）270万円",
        "choice2": "2）300万円",
        "choice3": "3）570万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 48,
        "shikenId": 1,
        "parentNo": 2,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、2012年１月１日以後に締結した生命保険契約に係る介護医療保険料控除の控除限度額は（ ① ）であり、これに一般の生命保険料控除と個人年金保険料控除の控除額を合わせた控除限度額は（ ② ）である。",
        "choice1": "1）① ３万円　　② ５万円",
        "choice2": "2）① ４万円　　② 12万円",
        "choice3": "3）① ５万円　　② 10万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 49,
        "shikenId": 1,
        "parentNo": 2,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "住宅ローンを利用してマンションを取得し、所得税の住宅借入金等特別控除の適用を受ける場合、借入金の償還期間は（ ① ）以上でなければならず、また、原則として、取得等した家屋の床面積が50㎡以上で、かつ、その（ ② ）以上に相当する部分が専ら自己の居住の用に供されるものでなければならない。",
        "choice1": "1）① 10年　　② ２分の１",
        "choice2": "2）① 10年　　② ３分の２",
        "choice3": "3）① 15年　　② ３分の１",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 50,
        "shikenId": 1,
        "parentNo": 2,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "居住者が2026年中に日本国内において支払を受ける普通預金の利子は、所得税および復興特別所得税と住民税の合計で（　　）の税率による源泉分離課税の対象となる。",
        "choice1": "1）10.21％",
        "choice2": "2）15.315％",
        "choice3": "3）20.315％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 51,
        "shikenId": 1,
        "parentNo": 2,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税の計算において、個人が土地や建物等を譲渡したことによる譲渡所得が長期譲渡所得に区分されるためには、当該土地や建物を譲渡した年の１月１日における所有期間が（　　）を超えていなければならない。",
        "choice1": "1）３年",
        "choice2": "2）５年",
        "choice3": "3）10年",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 52,
        "shikenId": 1,
        "parentNo": 2,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "個人が自宅の土地および建物を2026年中に譲渡し、「居住用財産を譲渡した場合の長期譲渡所得の課税の特例」（軽減税率の特例）の適用を受けた場合、当該譲渡に係る課税長期譲渡所得金額のうち、6,000万円以下の部分については、所得税（ ① ）、住民税４％の税率で課税され、6,000万円を超える部分については所得税（ ② ）、住民税５％の税率で課税される。なお、復興特別所得税は考慮しないものとする。",
        "choice1": "1）① ５％　　② 10％",
        "choice2": "2）① 10％　　② 15％",
        "choice3": "3）① 15％　　② 20％",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 53,
        "shikenId": 1,
        "parentNo": 2,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "投資総額１億円で購入した賃貸用不動産の年間収入の合計額が2,500万円、年間費用の合計額が2,000万円であった場合、この賃貸用不動産の純利回り（ＮＯＩ利回り）は、（　　）である。",
        "choice1": "1）２％",
        "choice2": "2）４％",
        "choice3": "3）５％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 54,
        "shikenId": 1,
        "parentNo": 2,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "宅地建物取引業法によると、宅地建物取引業者が依頼人と締結する宅地または建物の売買の媒介契約のうち、専任媒介契約の有効期間は最長で（　　）である。",
        "choice1": "1）１ヵ月",
        "choice2": "2）３ヵ月",
        "choice3": "3）６ヵ月",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 55,
        "shikenId": 1,
        "parentNo": 2,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "区分建物（マンションなど）に係る登記記録に記載されている区分建物の床面積は、壁その他の区画の内側線で囲まれた部分の（　　）によって算出される。",
        "choice1": "1）水平面積",
        "choice2": "2）内法面積",
        "choice3": "3）壁芯面積",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 56,
        "shikenId": 1,
        "parentNo": 2,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "下記の＜親族関係図＞において、Ａさんの相続における父Ｄさんの法定相続分は（ ① ）であり、妻Ｂさんの法定相続分は（ ② ）である。<br><br><img src='/img/1_56_1780886167425588_2.png'>",
        "choice1": "1）① ３分の１　　② ３分の２",
        "choice2": "2）① ４分の１　　② ４分の３",
        "choice3": "3）① ２分の１　　② ２分の１",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 57,
        "shikenId": 1,
        "parentNo": 2,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "2026年３月16日に死亡したＡさんが所有していた上場株式Ｘを相続により取得した場合の１株当たりの相続税評価額は、下記の〈資料〉によると（　　）である。<br><br><img src='/img/1_57_1780886167847473_3.png'>",
        "choice1": "1）420円",
        "choice2": "2）417円",
        "choice3": "3）400円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 58,
        "shikenId": 1,
        "parentNo": 2,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "相続において相続人が取得した宅地が「小規模宅地等についての相続税の課税価格の計算の特例」における特定事業用宅地等に該当する場合、その宅地のうち（ ① ）までを限度面積として、評価額の（ ② ）相当額を減額した金額を、相続税の課税価格に算入すべき価額とすることができる。",
        "choice1": "1）① 200㎡　　② 50％",
        "choice2": "2）① 330㎡　　② 80％",
        "choice3": "3）① 400㎡　　② 80％",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 59,
        "shikenId": 1,
        "parentNo": 2,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "年の中途で死亡した者が、その年分の所得税について確定申告を要する場合、その相続人は、相続の開始があったことを知った日の翌日から（　　）以内に、死亡した者に代わって確定申告をしなければならない。",
        "choice1": "1）３ヵ月",
        "choice2": "2）４ヵ月",
        "choice3": "3）10ヵ月",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 60,
        "shikenId": 1,
        "parentNo": 2,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "被相続人の（　　）が相続により財産を取得した場合、その者は相続税額の２割加算の対象となる。",
        "choice1": "1）兄弟姉妹",
        "choice2": "2）父母",
        "choice3": "3）孫（子の代襲相続人）",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 101,
        "shikenId": 1,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ｍさんは、〈Ａさんおよび妻Ｂさんに関する資料〉に基づき、Ａさんの老齢基礎年金の年金額（2026年度評価額）を試算した。Ａさんが60歳から老齢基礎年金の支給繰上げを請求する場合、受給できる金額の計算式として最も適切なものはどれか。",
        "choice1": "<img style='margin-top: -20px; margin-bottom:25px;' src=\"/img/question/1_1_1780886554292214_1.png\" class=\"question-img\" />",
        "choice2": "<img style='margin-top: -23px;margin-bottom: 25px;'  src=\"/img/question/1_1_1780886554699957_2.png\" class=\"question-img\" />",
        "choice3": "<img style='margin-top: -25px;margin-bottom: 25px;' src=\"/img/question/1_1_1780886554943433_3.png\" class=\"question-img\" />",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "3q-kojin-a-1.png"
    },
    {
        "id": 102,
        "shikenId": 1,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんおよび妻Ｂさんが受給することができる公的年金制度の老齢給付について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんには特別支給の老齢厚生年金は支給されませんが、妻のＢさんには特別支給の老齢厚生年金が支給されます」",
        "choice2": "「Ａさんが65歳から受給することができる老齢厚生年金の額には、配偶者の加給年金額は加算されません」",
        "choice3": "「妻Ｂさんが65歳から老齢基礎年金を受給する場合、老齢基礎年金の額に振替加算額が加算されます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-kojin-a-1.png"
    },
    {
        "id": 103,
        "shikenId": 1,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "最後に、Ｍさんは、公的介護保険（以下、「介護保険」という）の保険給付について説明した。<br>ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「介護保険の保険者（運営主体）は市区町村であるため、介護保険の保険給付を受けるためには、市町村（特別区を含む）から要介護認定または要支援認定を受ける必要があります」",
        "choice2": "「介護保険の第２号被保険者であるＡさんが介護サービスの提供を受けた場合、原則として、実際にかかった費用の２割または３割を自己負担する必要があります」",
        "choice3": "「40歳以上65歳未満の第２号被保険者は、要介護状態または要支援状態となった原因が、初老期における認知症、脳血管疾患などの加齢に伴う特定疾病である場合に限り、介護給付または予防給付を受けることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-kojin-a-1.png"
    },
    {
        "id": 104,
        "shikenId": 1,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "はじめに、Ｍさんは、ＮＩＳＡの「つみたて投資枠」の概要について説明した。ＭさんがＡさんに対して説明した以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/1_4_1780886555223893_4.png\" class=\"question-img\" />",
        "choice1": "① ＥＴＦ     ② 120万円  ③ 無期限",
        "choice2": "① Ｊ-ＲＥＩＴ  ②  40万円  ③ 最長10年間",
        "choice3": "① ＥＴＦ     ② 120万円  ③ 最長５年間",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-kojin-a-2.png"
    },
    {
        "id": 105,
        "shikenId": 1,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "次に、Ｍさんは、ＮＩＳＡを利用して購入した投資信託に係る課税関係について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「ＮＩＳＡを利用して購入した株式投資信託を解約した際に損失が生じた場合、その損失の金額は、特定口座で保有する上場株式等の譲渡益と損益通算することができません」",
        "choice2": "「ＮＩＳＡを利用して購入した株式投資信託の普通分配金は、非課税の対象とならず、20.315％相当額が源泉徴収等されます」",
        "choice3": "「ＮＩＳＡを利用して購入した株式投資信託を、購入した年に解約した場合、当該譲渡益は非課税となります」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-kojin-a-2.png"
    },
    {
        "id": 106,
        "shikenId": 1,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "最後に、Ｍさんは、Ｘ社株式の投資指標について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「株価の相対的な割高・割安を判断する指標として、ＰＥＲがあります。〈Ｘ社に関する資料〉から算出されるＸ株式のＰＥＲ（株価収益率）は16倍です」",
        "choice2": "「株価の相対的な割高・割安を判断する指標として、ＰＢＲがあります。〈Ｘ社に関する資料〉から算出されるＸ株式のＰＢＲ（株価純資産倍率）は1.6倍です」",
        "choice3": "「株価に対する１株当たりの年間配当金の割合を示す指標を配当利回りといいます。〈Ｘ社に関する資料〉から算出されるＸ株式の配当利回りは４％です」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3q-kojin-a-2.png"
    },
    {
        "id": 107,
        "shikenId": 1,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における医療費控除に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「Ａさんが、2026年中に支払った医療費について医療費控除の適用を受けるためには、確定申告をする必要があります」",
        "choice2": "「生命保険契約から支払われた入院給付金や健康保険から支給を受けた高額療養費がある場合、支払った医療費の総額からそれらの金額を控除する必要があります」",
        "choice3": "「Ａさんが2026年中に支払った医療費の金額の合計額が20万円を超えていない場合、医療費控除額は算出されません」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-kojin-a-3.png"
    },
    {
        "id": 108,
        "shikenId": 1,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における総所得金額は、次のうちどれか。なお、Ａさんは青色申告者ではないものとする。<br><img src=\"/img/question/1_8_1780886555836578_5.png\" class=\"question-img\" />",
        "choice1": "680万円",
        "choice2": "620万円",
        "choice3": "586万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3q-kojin-a-3.png"
    },
    {
        "id": 109,
        "shikenId": 1,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における所得控除に関する以下の文章の空欄①～③に入る語句の組合せとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/1_9_1780886556396599_6.png\" class=\"question-img\" />",
        "choice1": "① 26万円  ② 38万円  ③ 社会保険料控除",
        "choice2": "① 38万円  ② 38万円  ③ 小規模企業共済等掛金控除",
        "choice3": "① 38万円  ② 63万円  ③ 社会保険料控除",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-kojin-a-3.png"
    },
    {
        "id": 110,
        "shikenId": 1,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "甲土地に耐火建築物を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "① 400㎡　　② 2,560㎡",
        "choice2": "① 400㎡　　② 1,600㎡",
        "choice3": "① 320㎡　　② 1,280㎡",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-kojin-a-4.png"
    },
    {
        "id": 111,
        "shikenId": 1,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "事業用定期借地権方式に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「事業用定期借地権方式とは、Ｘ社が甲土地を契約で一定期間賃借し、Ｘ社が建物を建設する手法です。Ａさんは土地を手放さずに安定した地代収入を得ることができ、契約期間満了時には土地が更地で返還されます」",
        "choice2": "「事業用定期借地権方式によりＡさんが甲土地をＸ社に賃貸した後にＡさんの相続が開始した場合、相続税の課税価格の計算上、甲土地は貸家建付地として評価されますので、相続税額の軽減効果があります」",
        "choice3": "「事業用定期借地権の設定契約は、公正証書により行わなければなりません」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-kojin-a-4.png"
    },
    {
        "id": 112,
        "shikenId": 1,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "不動産の価格に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「《設例》の図では相続税路線価が表示されていますが、この道路に示された「200Ｄ」とは、１㎡当たりの価額が20万円、借地権割合が60％であることを示しています」",
        "choice2": "「土地の価格には、『実勢価格（取引価格）』『公示価格』『基準地標準価格』『相続税路線価』『固定資産税評価額』の５つがあるといわれ、このうち相続税路線価は公示価格の６割程度に設定されています」",
        "choice3": "「公示価格は、毎年１月１日を基準日として、国土交通省の土地鑑定委員会が判定し、３月に公表されます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-kojin-a-4.png"
    },
    {
        "id": 113,
        "shikenId": 1,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が8,200万円であった場合の相続税の総額は、次のうちどれか。<br><img src=\"/img/question/1_13_1780886557010405_7.png\" class=\"question-img\" />",
        "choice1": "905万円",
        "choice2": "1,135万円",
        "choice3": "1,435万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-kojin-a-5.png"
    },
    {
        "id": 114,
        "shikenId": 1,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "「小規模宅地等についての相続税の課税価格の計算の特例」（以下、「本特例」という）に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Ｂさんが自宅の敷地および建物を相続により取得し、当該敷地の全部について本特例の適用を受けた場合、限度面積330㎡までの部分については、評価額を80％減額することができます」",
        "choice2": "「妻Ｂさんが自宅の敷地および建物を相続により取得した場合でも、その後相続税の申告期限まで当該建物に居住していなければ、妻Ｂさんは本特例の適用を受けることができません」",
        "choice3": "「長女Ｄさんが自宅の敷地および建物を相続により取得した場合、その後相続税の申告期限まで当該敷地を所有していれば、居住していなくても本特例の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-kojin-a-5.png"
    },
    {
        "id": 115,
        "shikenId": 1,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの相続に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Ｂさんが『配偶者に対する相続税額の軽減』の適用を受けた場合、妻Ｂさんの相続税の課税価格が、相続税の課税価格の合計額に対する配偶者の法定相続分相当額と１億6,000万円とのいずれか多い金額までであれば、原則として、妻Ｂさんが納付すべき相続税額は算出されません」",
        "choice2": "「Ａさんが2026年分の所得税および復興特別所得税について確定申告書を提出しなければならない者に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から10ヵ月以内に準確定申告書を提出しなければなりません」",
        "choice3": "「相続税の申告書は、原則として、相続人が相続の開始があったことを知った日の翌日から２年以内に被相続人であるＡさんの死亡時の住所地を所轄する税務署長に提出しなければなりません」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-kojin-a-5.png"
    },
    {
        "id": 201,
        "shikenId": 1,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "はじめに、Ｍさんは、《設例》に基づき、Ａさんが老齢基礎年金の受給を65歳から開始し<br>た場合の年金額（2026年度価額）を試算した。Ｍさんが試算した老齢基礎年金の年金額の計<br>算式として、次のうち最も適切なものはどれか。",
        "choice1": "<img style='margin-top: -23px;margin-bottom: 80px;' src=\"/img/question/1_1_1780886609228622_1.png\" class=\"question-img\" />",
        "choice2": "<img style='margin-top: -80px;margin-bottom: 80px;' src=\"/img/question/1_1_1780886609509513_2.png\" class=\"question-img\" />",
        "choice3": "<img style='margin-top: -75px;' src=\"/img/question/1_1_1780886609803933_3.png\" class=\"question-img\" />",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "3q-hoken-a-1.png"
    },
    {
        "id": 202,
        "shikenId": 1,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "次に、Ｍさんは、公的介護保険（以下、「介護保険」という）について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「介護保険の被保険者が保険給付を受けるためには、都道府県から要介護認定または要支援認定を受ける必要があります」",
        "choice2": "「介護保険の第２号被保険者であるＡさんは、原因を問わず要介護状態または要支援状態となった場合に保険給付を受けることができます」",
        "choice3": "「介護保険の第２号被保険者が保険給付を受けた場合、原則として実際にかかった費用（食費、居住費等を除く）の１割を自己負担する必要があります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-a-1.png"
    },
    {
        "id": 203,
        "shikenId": 1,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "最後に、Ｍさんは、ＡさんがＸ社を退職した後、老後の年金収入を増やすことができる方法や各種制度について説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る語句および数値の組合せとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/1_3_1780886610111928_4.png\" class=\"question-img\" />",
        "choice1": "① 確定  ② 10  ③ 24,000",
        "choice2": "① 終身  ② 10  ③ 36,000",
        "choice3": "① 終身  ② 20  ③ 48,000",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-hoken-a-1.png"
    },
    {
        "id": 204,
        "shikenId": 1,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、現在加入している生命保険の保障内容等について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「Ａさんが現時点で病気を原因として亡くなった場合、死亡保険金として3,500万円を受け取ることができます」",
        "choice2": "「遺族に必要な生活資金等の総額から遺族の収入金額等を差し引いた金額が、必要保障額として死亡保険金額を設定する目安となります。通常、必要保障額はお子様の成長とともに逓減するため、収入保障保険や逓減定期保険への加入も検討してはいかがでしょう」",
        "choice3": "「Ａさんが加入している生命保険には、リビング・ニーズ特約が付加されていますので、Ａさんが余命１年以内と診断された場合、生前給付金を受け取ることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3q-hoken-a-2.png"
    },
    {
        "id": 205,
        "shikenId": 1,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "次に、Ｍさんは、生命保険の見直しについて説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「現在加入している定期保険特約の契約変更を行うことで保険金額を減額させ、その分を必要性の高い介護保険などの保険料に充てることも検討事項の１つです」",
        "choice2": "「現在加入している生命保険を払済終身保険に変更した場合、死亡保険金額は減少しますが、現在付加されている入院特約は残り、月々の保険料負担は軽減されます」",
        "choice3": "「介護保障を検討する際には、公的介護保険等の社会保障制度と連動しているものか、保険金の支払事由が保険会社独自のものか、どのような場合に保険金や給付金が支払われるか、加入前に確認しておくことが重要です」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-hoken-a-2.png"
    },
    {
        "id": 206,
        "shikenId": 1,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "最後に、Ｍさんは、全国健康保険協会管掌健康保険の高額療養費制度について説明した。<br>Ｍさんが、Ａさんに対して説明した次のうち最も適切なものはどれか。",
        "choice1": "「Ａさんに係る医療費の一部負担金の割合は、原則として１割となります」",
        "choice2": "「同一年内に、医療機関等に支払った医療費の一部負担金等の額が自己負担限度額を超えた場合、所定の手続により、自己負担限度額を超えた額が高額療養費として支給されます」",
        "choice3": "「一部負担金等の合計には、差額ベッド代、入院時の食事代、先進医療に係る費用等は含まれず、70歳未満の者の場合、原則として、医療機関ごとに、入院・外来、医科・歯科別に一部負担金等が21,000円以上のものが計算対象となります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-a-2.png"
    },
    {
        "id": 207,
        "shikenId": 1,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "仮に、Ｘ社がＡさんに役員退職金7,000万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、Ａさんの役員在任期間（勤続年数）を40年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "1,400万円",
        "choice2": "2,200万円",
        "choice3": "2,400万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3q-hoken-a-3.png"
    },
    {
        "id": 208,
        "shikenId": 1,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "《設例》の終身保険の第１回保険料払込時の経理処理（仕訳）として、次のうち最も適切なものはどれか。",
        "choice1": "<img src=\"/img/question/1_8_1780886610827216_5.png\" class=\"question-img\" />",
        "choice2": "<img src=\"/img/question/1_8_1780886611192352_6.png\" class=\"question-img\" />",
        "choice3": "<img src=\"/img/question/1_8_1780886611582289_7.png\" class=\"question-img\" />",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-hoken-a-3.png"
    },
    {
        "id": 209,
        "shikenId": 1,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ｍさんは、《設例》の終身保険について説明した。ＭさんのＢさんに対する説明として、<br>次のうち最も不適切なものはどれか。",
        "choice1": "「当該終身保険は、保険料払込期間における解約返戻金額を抑えることで、低解約返戻金型ではない終身保険と比較して保険料が割安となっています」",
        "choice2": "「Ｂさんが所定の高度障害状態になった場合、高度障害保険金6,000万円がＸ社に支払われます。さらに、その後Ｂさんが死亡した場合には、死亡保険金6,000万円がＸ社に支払われます」",
        "choice3": "「急な資金需要の発生により、Ｘ社が契約者貸付制度を利用した場合、借入金として経理処理します」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-hoken-a-3.png"
    },
    {
        "id": 210,
        "shikenId": 1,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "2026年分の所得税における青色申告に関する以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/1_10_1780886611985086_8.png\" class=\"question-img\" />",
        "choice1": "① 10　　② 55　　③ ５",
        "choice2": "① 55　　② 65　　③ ３",
        "choice3": "① 55　　② 65　　③ ５",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-hoken-a-4.png"
    },
    {
        "id": 211,
        "shikenId": 1,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における所得および所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんが解約した一時払変額個人年金保険（10年確定年金）の解約返戻金は、税務上、雑所得として所得税の課税対象になります」",
        "choice2": "「妻Ｂさんが青色事業専従者として給与の支払いを受けている場合であっても、Ａさんは、妻Ｂさんについて配偶者控除の適用を受けることができます」",
        "choice3": "「Ａさんが適用を受けることができる長男Ｃさんに係る扶養控除の額は、63万円です」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-a-4.png"
    },
    {
        "id": 212,
        "shikenId": 1,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における総所得金額は、次のうちどれか。",
        "choice1": "600万円",
        "choice2": "625万円",
        "choice3": "700万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-hoken-a-4.png"
    },
    {
        "id": 213,
        "shikenId": 1,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの相続に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/1_13_1780886612641154_9.png\" class=\"question-img\" />",
        "choice1": "① 4,800  ② 10ヵ月  ③ 2,500",
        "choice2": "① 4,800  ② 12ヵ月  ③ 2,500",
        "choice3": "① 5,400  ② 12ヵ月  ③ 2,000",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-hoken-a-5.png"
    },
    {
        "id": 214,
        "shikenId": 1,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの相続に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「妻Ｂさんが自宅の敷地を相続により取得し、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、自宅の敷地（相続税評価額9,000万円）について、相続税の課税価格に算入すべき価額を1,800万円とすることができます」",
        "choice2": "「自筆証書遺言は、所定の手続により、法務局（遺言書保管所）に保管することができます。法務局（遺言書保管所）に保管された自筆証書遺言は、相続開始時、家庭裁判所の検認が不要となります」",
        "choice3": "「妻Ｂさんが『配偶者に対する相続税額の軽減』の適用を受けるためには、Ａさんの相続開始時において、Ａさんとの婚姻期間が10年以上でなければなりません」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-a-5.png"
    },
    {
        "id": 215,
        "shikenId": 1,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの相続に係る課税遺産総額（「課税価格の合計額－遺産に係る基礎控除額」）が２億4,000万円であった場合の相続税の総額として、次のうち最も適切なものはどれか。<br><img src=\"/img/question/1_15_1780886613268815_10.png\" class=\"question-img\" />",
        "choice1": "1,200万円",
        "choice2": "5,300万円",
        "choice3": "7,400万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-hoken-a-5.png"
    },
    {
        "id": 301,
        "shikenId": 1,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "ファイナンシャル・プランニング業務を行うに当たっては、関連業法を遵守することが重要である。ファイナンシャル・プランナー（以下「ＦＰ」という）の行為に関する次の記述のうち、最も適切なものはどれか。なお、記載のない資格の登録等については考慮しないこととする。",
        "choice1": "投資助言・代理業の登録をしていないＦＰが、顧客からの質問を受け、ＮＩＳＡ（少額投資非課税制度）の仕組みと特徴について説明した。",
        "choice2": "税理士資格を有していないＦＰが、無料相談会において、相談者の持参した資料に基づき、相談者が納付すべき相続税の具体的な税額計算を行った。",
        "choice3": "弁護士資格を有しないＦＰが、遺産分割に係る紛争中の顧客の依頼を受け、法律相談に基づく和解交渉を行い報酬を得た。",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 302,
        "shikenId": 1,
        "parentNo": 1,
        "no": 2,
        "groupId": 2,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記は、田中家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表に関する次の記述のうち、正しいものはどれか。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用することとし、計算結果は万円未満を四捨五入することとする。<br><img src=\"/img/question/1_2_1780886431311208_1.png\" class=\"question-img\" />",
        "choice1": "空欄（ア）に入る数値とその求め方：「520×（１＋0.01)<sup>2</sup>＝530」",
        "choice2": "空欄（イ）に入る数値とその求め方：「696－742＝▲46」",
        "choice3": "空欄（ウ）に入る数値とその求め方：「（520－102）×（１＋0.01）＝422」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 303,
        "shikenId": 1,
        "parentNo": 1,
        "no": 3,
        "groupId": 3,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "永井家の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく永井家のバランスシートの空欄（ア）に当てはまる金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないものとする。<br><img src=\"/img/question/1_3_1780886432433321_2.png\" class=\"question-img\" /><br><img src=\"/img/question/1_3_1780886432836714_3.png\" class=\"question-img\" />",
        "choice1": "2,080（万円）",
        "choice2": "3,620（万円）",
        "choice3": "5,700（万円）",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 304,
        "shikenId": 1,
        "parentNo": 1,
        "no": 4,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "榊さんは、今後15年間で毎年36万円ずつ積立貯蓄をして、老後の資金準備をしたいと考えている。積立期間中に年利2.0％で複利運用できるものとした場合、15年後の積立金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、解答に当たっては、万円未満を四捨五入することとする。また、記載のない事項については一切考慮しないこととする。<br><img src=\"/img/question/1_4_1780886433453507_4.png\" class=\"question-img\" />",
        "choice1": "623万円",
        "choice2": "463万円",
        "choice3": "49万円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 305,
        "shikenId": 1,
        "parentNo": 1,
        "no": 5,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の岸田明夫さんは、将来両親の介護が必要になり仕事を休んだ場合、雇用保険ではどのような給付があるのか、ＦＰの大川さんに質問をした。大川さんが行った雇用保険の介護休業給付金に関する次の説明のうち、最も適切なものはどれか。",
        "choice1": "介護休業給付金の支給日数１日当たりの支給額は、休業中に賃金が支払われない場合、休業開始時賃金日額の80％相当額となります。",
        "choice2": "介護休業給付金は、同一の対象家族について通算して93日を限度に支給されます。",
        "choice3": "介護休業給付金は、同一の対象家族について５回まで分割して取得することが可能です。",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 306,
        "shikenId": 1,
        "parentNo": 1,
        "no": 6,
        "groupId": 5,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記＜資料＞は、ＴＹ銀行の顧客配布用・投資信託ガイドの「投資信託に関するリスク」のページの一部（抜粋）である。＜資料＞に関する次の記述のうち、最も適切なものはどれか。<br><img src=\"/img/question/1_6_1780886433983785_5.png\" class=\"question-img\" />",
        "choice1": "空欄（ア）に入る語句は、「信用リスク」である。",
        "choice2": "空欄（イ）に入る語句は、「為替変動リスク」である。",
        "choice3": "空欄（ウ）に入る語句は、「流動性リスク」である。",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 307,
        "shikenId": 1,
        "parentNo": 1,
        "no": 7,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "個人向け国債（2027年１月発行分からは個人向け国債プラス）に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src=\"/img/question/1_7_1780886434866379_6.png\" class=\"question-img\" />",
        "choice1": "（ア）１万円  （イ）0.03％  （ウ）２年",
        "choice2": "（ア）１万円  （イ）0.05％  （ウ）１年",
        "choice3": "（ア）５万円  （イ）0.05％  （ウ）２年",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 308,
        "shikenId": 1,
        "parentNo": 1,
        "no": 8,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記＜資料＞に基づくＫＸ株式とＫＹ株式の投資指標に関する次の記述の空欄（ア）、（イ）にあてはまる数値または語句の組み合わせとして、最も適切なものはどれか。なお、空欄（ア）の解答に当たっては、小数点以下第３位を四捨五入すること。<br><img src=\"/img/question/1_8_1780886435540515_7.png\" class=\"question-img\" /><br><img src=\"/img/question/1_8_1780886435948805_8.png\" class=\"question-img\" />",
        "choice1": "（ア）1.40  （イ）ＫＹ",
        "choice2": "（ア）1.60  （イ）ＫＸ",
        "choice3": "（ア）1.60  （イ）ＫＹ",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 309,
        "shikenId": 1,
        "parentNo": 1,
        "no": 9,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "建築基準法に基づき、下記＜資料＞の土地に建築物を建築する場合、その土地に対する建築物の建築面積の最高限度（ア）と延べ面積（床面積の合計）の最高限度（イ）の組み合わせとして、最も適切なものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src=\"/img/question/1_9_1780886436438865_9.png\" class=\"question-img\" />",
        "choice1": "（ア）180㎡  （イ）480㎡",
        "choice2": "（ア）180㎡  （イ）600㎡",
        "choice3": "（ア）300㎡  （イ）600㎡",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 310,
        "shikenId": 1,
        "parentNo": 1,
        "no": 10,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "借地借家法に基づく定期借地権に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "事業の用に供する建物の所有を目的とする場合、一般定期借地権を設定することはできない。",
        "choice2": "従業員の社宅として利用する建物の所有を目的として、事業用定期借地権等の設定契約をすることができる。",
        "choice3": "一般定期借地権の存続期間は50年以上とされており、契約は公正証書等の書面または電磁的記録によって締結しなければならない。",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 311,
        "shikenId": 1,
        "parentNo": 1,
        "no": 11,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "土地の登記記録において、権利部のうちの甲区（ア）、乙区（イ）に記録される事項の組み合わせとして、誤っているものはどれか。",
        "choice1": "（ア）抵当権設定登記  （イ）所有権保存登記",
        "choice2": "（ア）所有権移転登記  （イ）抵当権設定登記",
        "choice3": "（ア）所有権移転登記  （イ）地上権設定登記",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 312,
        "shikenId": 1,
        "parentNo": 1,
        "no": 12,
        "groupId": 8,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "石川雄一郎さんが加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）、（イ）にあてはまる金額の組合せとして、最も適切なものはどれか。なお、保険金および給付金の支払事由が生じたときにおいて、特約を含む保険契約は有効に継続しているものとし、雄一郎さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。<br><img src=\"/img/question/1_12_1780886437232128_10.png\" class=\"question-img\" /><br><img src=\"/img/question/1_12_1780886438274931_11.png\" class=\"question-img\" />",
        "choice1": "（ア）1,700万円  （イ）300万円",
        "choice2": "（ア）2,000万円  （イ）500万円",
        "choice3": "（ア）2,000万円  （イ）300万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 313,
        "shikenId": 1,
        "parentNo": 1,
        "no": 13,
        "groupId": 9,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記の（ア）～（ウ）のイメージ図は、定期保険、終身保険、養老保険のいずれかを表したものである。下記のイメージ図に関する次の記述のうち、最も適切なものはどれか。<br><img src=\"/img/question/1_13_1780886438643958_12.png\" class=\"question-img\" />",
        "choice1": "（ア）は「終身保険」に関するイメージ図である。",
        "choice2": "（イ）は「定期保険」に関するイメージ図である。",
        "choice3": "（ウ）は「養老保険」に関するイメージ図である。",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 314,
        "shikenId": 1,
        "parentNo": 1,
        "no": 14,
        "groupId": 9,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "損害保険の種類と事故の内容に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "国内旅行中に発生した地震や津波によるケガは、国内旅行傷害保険の補償の対象となる。",
        "choice2": "草野球の試合中にボールが右指を直撃し、被保険者が骨折した場合のケガは、普通傷害保険の補償の対象となる。",
        "choice3": "被保険者が業務の遂行中に自転車で誤って歩行者と接触し、ケガをさせたことにより損害賠償責任が生じた場合、個人賠償責任保険の補償の対象となる。",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 315,
        "shikenId": 1,
        "parentNo": 1,
        "no": 15,
        "groupId": 10,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "Ｋ株式会社の会社員である竹市さんが2026年中に支払った医療費等が下記＜資料＞のとおりである場合、竹市さんの2026年分の所得税の確定申告における医療費控除の金額として、最も適切なものはどれか。なお、竹市さんの2026年分の所得は給与所得600万円のみであり、竹市さんは妻と生計を一にしている。また、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）については考慮しないものとする。<br><img src=\"/img/question/1_15_1780886439445761_13.png\" class=\"question-img\" />",
        "choice1": "290,000円",
        "choice2": "390,000円",
        "choice3": "450,000円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 316,
        "shikenId": 1,
        "parentNo": 1,
        "no": 16,
        "groupId": 11,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の山川さんは、2026年中に勤務先を定年退職した。山川さんの退職に係るデータが下記＜資料＞のとおりである場合、山川さんの所得税に係る退職所得の金額として、正しいものはどれか。<br><img src=\"/img/question/1_16_1780886440055818_14.png\" class=\"question-img\" />",
        "choice1": "1,280万円",
        "choice2": "1,220万円",
        "choice3": "640万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 317,
        "shikenId": 1,
        "parentNo": 1,
        "no": 17,
        "groupId": 12,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "給与所得者である杉田さんは、2026年中にマンションを購入し、直ちに居住を開始した。杉田さんは、住宅借入金等特別控除（以下「住宅ローン控除」という）の適用を受けたいと考えており、ＦＰで税理士でもある村瀬さんに相談をした。村瀬さんの住宅ローン控除に関する次の説明のうち、最も適切なものはどれか。",
        "choice1": "「住宅ローン控除の毎年の控除額は、『住宅借入金等の年末残高等×0.7％』の式で計算されます」",
        "choice2": "「一般的に、住宅ローン控除の適用を受けるためには、対象となる住宅の床面積が55㎡以上でなければなりません」",
        "choice3": "「住宅ローン控除は、その年分の合計所得金額が3,000万円以下でなければ適用を受けることができません」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 318,
        "shikenId": 1,
        "parentNo": 1,
        "no": 18,
        "groupId": 12,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "小柳隆二さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、最も適切なものはどれか。なお、記載のない条件については、一切考慮しないこととする。<br><img src=\"/img/question/1_18_1780886440862656_15.png\" class=\"question-img\" />",
        "choice1": "真琴 １/２　　順一 １/４　　祥子 １/４",
        "choice2": "真琴 ２/３　　法子 １/３",
        "choice3": "真琴 １/２　　順一 １/２",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 319,
        "shikenId": 1,
        "parentNo": 1,
        "no": 19,
        "groupId": 13,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "村西さん（30歳）が2026年中に贈与を受けた財産の価額と贈与者は以下のとおりである。村西さんの2026年分の贈与税額として、正しいものはどれか。なお、2026年中において、村西さんはこれ以外の財産の贈与を受けておらず、その他記載のない事項については一切考慮しないこととする。<br><img src=\"/img/question/1_19_1780886441641234_16.png\" class=\"question-img\" />",
        "choice1": "88万円",
        "choice2": "112万円",
        "choice3": "120万円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 320,
        "shikenId": 1,
        "parentNo": 1,
        "no": 20,
        "groupId": 14,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "長谷川信子さんは、夫から居住用不動産の贈与を受けた。信子さんは、この居住用不動産の贈与について、贈与税の配偶者控除の適用を受けることを検討しており、ＦＰで税理士でもある八代さんに相談をした。この相談に対する次の回答のうち、最も不適切なものはどれか。",
        "choice1": "「贈与税の配偶者控除の対象となる財産については、居住用不動産である家屋およびその敷地のほか、それらを取得するための資金も含まれます」",
        "choice2": "「贈与税の配偶者控除の適用を受けた場合、贈与税の計算上、贈与税の課税価額から基礎控除額110万円のほかに最高2,500万円の控除を受けることができます」",
        "choice3": "「贈与税の配偶者控除は、贈与を受けた日において、婚姻期間が20年以上ある配偶者から受けた贈与でなければ、適用を受けることができません」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 1000,
        "shikenId": 20,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、関連法規に照らし、最も不適切なものはどれか。",
        "choice1": "金融商品取引業の登録を受けていないＦＰのＡさんは、顧客から確定拠出年金の個人型年金（iDeCo）について相談を受け、iDeCoの運用商品の特徴について説明した。",
        "choice2": "社会保険労務士の資格を有しないＦＰのＢさんは、顧客から公的年金の老齢給付の繰上げ受給について相談を受け、顧客の「ねんきん定期便」の年金受取見込額を基に、繰り上げた場合の年金額を試算した。",
        "choice3": "司法書士の資格を有しないＦＰのＣさんは、住宅ローンを完済した顧客から、抵当権の抹消登記について相談を受け、申請書を作成して登記手続を代行した。",
        "choice4": "税理士の資格を有しないＦＰのＤさんは、顧客からふるさと納税について相談を受け、寄附金控除の仕組みについて説明した。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1001,
        "shikenId": 20,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ライフプランニングにおけるライフステージ別の一般的な資金の活用等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "Ａさん（60歳）は、退職金と預貯金のうち、今後の生活資金を確保した残りの余裕資金から、子が住宅を取得するための頭金として、税務上非課税となる範囲で現金を贈与することとした。",
        "choice2": "Ｂさん（25歳）は、子の教育資金を準備するため、金融機関のカードローンで資金を借り入れ、高リスクだが、高い収益が見込める金融商品を購入して積極的な運用を図ることとした。",
        "choice3": "Ｃさん（70歳）は、相続対策として、相続人がもめないように、遺言執行者として弁護士を指定した自筆証書遺言を作成し、法務局（遺言書保管所）に保管の申請をすることとした。",
        "choice4": "Ｄさん（40歳）は、老後の生活資金を充実させるために、確定拠出年金の個人型年金（iDeCo）を利用して余裕資金を運用することとした。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1002,
        "shikenId": 20,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "労働者災害補償保険（以下「労災保険」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "業務上の負傷または疾病が治癒したときに身体に一定の障害が残り、その障害の程度が労働者災害補償保険法に規定する障害等級に該当する場合、障害補償給付が受けられる。",
        "choice2": "労災保険の適用を受ける労働者には、雇用形態がアルバイトやパートタイマーである者も含まれる。",
        "choice3": "労災保険の保険料を計算する際に用いる保険料率は、適用事業所の事業の種類により異なる。",
        "choice4": "労災保険の適用事業所の事業主は、その営む事業において使用する労働者数の多寡にかかわらず、労災保険の特別加入の対象となる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1003,
        "shikenId": 20,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "雇用保険法に基づく育児休業給付および介護休業給付に関する次の記述のうち、最も適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
        "choice1": "育児休業給付金に係る支給単位期間において、一般被保険者や高年齢被保険者に対して支払われた賃金額が、休業開始時賃金日額に支給日数を乗じて得た額の60％相当額以上である場合、当該支給単位期間について育児休業給付金は支給されない。",
        "choice2": "一般被保険者や高年齢被保険者の父母および配偶者の父母は、介護休業給付金の支給対象となる家族に該当しない。",
        "choice3": "一般被保険者や高年齢被保険者が、一定の状態にある家族を介護するために休業する場合、同一の対象家族について、通算３回かつ180日の介護休業を限度とし、介護休業給付金が支給される。",
        "choice4": "一般被保険者や高年齢被保険者が、原則として、１歳に満たない子を養育するために休業する場合、育児休業給付金が支給される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1004,
        "shikenId": 20,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "産前産後休業を取得している厚生年金保険の被保険者の厚生年金保険料は、所定の手続きにより、被保険者負担分と事業主負担分がいずれも免除される。",
        "choice2": "老齢厚生年金の受給権者が老齢厚生年金の繰下げ支給の申出をする場合、老齢基礎年金の繰下げ支給の申出を同時に行わなければならない。",
        "choice3": "老齢厚生年金の額に加給年金額が加算されるためには、原則として、厚生年金保険の被保険者期間が10年以上であり、かつ、その受給権者によって生計を維持されている一定の要件を満たす配偶者または子がいる必要がある。",
        "choice4": "国民年金の第１号被保険者は、日本国内に住所を有する20歳以上60歳未満の自営業者や学生などのうち、日本国籍を有する者のみが該当する。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1005,
        "shikenId": 20,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "国民年金基金、小規模企業共済および中小企業退職金共済に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "国民年金基金には、国民年金の第３号被保険者は加入することができない。",
        "choice2": "国民年金基金には、国内に住所を有する60歳以上65歳未満の国民年金の任意加入被保険者も加入することができる。",
        "choice3": "小規模企業共済に加入した場合、支払った掛金額の全額が小規模企業共済等掛金控除として所得税の所得控除の対象となる。",
        "choice4": "中小企業退職金共済に新規で加入する事業主は、加入月から１年間、掛金月額の２分の１相当額（従業員ごとに5,000円が上限）について国の助成を受けることができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1006,
        "shikenId": 20,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "障害基礎年金と遺族厚生年金の受給権を有している者は、65歳以降、障害基礎年金と遺族厚生年金を同時に受給することができない。",
        "choice2": "障害基礎年金と老齢厚生年金の受給権を有している者は、65歳以降、障害基礎年金と老齢厚生年金を同時に受給することができない。",
        "choice3": "同一の事由により、障害厚生年金と労働者災害補償保険法に基づく障害補償年金が支給される場合、障害補償年金は全額支給され、障害厚生年金は所定の調整率により減額される。",
        "choice4": "健康保険の傷病手当金の支給を受けるべき者が、同一の疾病または負傷およびこれにより発した疾病について障害厚生年金の支給を受けることができる場合、障害厚生年金の支給が優先される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1007,
        "shikenId": 20,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "住宅金融支援機構と金融機関が提携した住宅ローンであるフラット35（買取型）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "フラット35Ｓは、省エネルギー性、耐震性など一定の技術基準を満たした住宅を取得する場合に、借入金利を一定期間引き下げる制度である。",
        "choice2": "フラット35の利用者向けインターネットサービスである「住・My Note」を利用して繰上げ返済する場合、一部繰上げ返済の最低返済額は10万円である。",
        "choice3": "店舗付き住宅などの併用住宅を建築する際に、フラット35を利用することはできない。",
        "choice4": "住宅金融支援機構は、融資を実行する金融機関から住宅ローン債権を買い取り、対象となる住宅の第１順位の抵当権者となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1008,
        "shikenId": 20,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "リタイアメントプランニング等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "金融機関のリバースモーゲージには、一般に、利用者が死亡し、担保物件の売却代金により借入金を返済した後も債務が残った場合に、利用者の相続人がその返済義務を負う「ノンリコース型」と、返済義務を負わない「リコース型」がある。",
        "choice2": "高齢者の居住の安定確保に関する法律に定める「サービス付き高齢者向け住宅」に入居した者は、「状況把握サービス」や「生活相談サービス」を受けることができる。",
        "choice3": "将来、本人の判断能力が不十分になった場合に備えて、あらかじめ本人が選任した者と締結する任意後見契約は、公正証書によらない場合であっても有効である。",
        "choice4": "確定拠出年金の加入者が、老齢給付金を60歳から受給するためには、通算加入者等期間が５年以上なければならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1009,
        "shikenId": 20,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "クレジットカード会社（貸金業者）が発行するクレジットカードの一般的な利用に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "クレジットカードで商品を購入（ショッピング）した場合の返済方法の一つである定額リボルビング払い方式は、クレジットの利用金額・件数にかかわらず、あらかじめ設定した一定の金額を支払う方式である。",
        "choice2": "クレジットカードで無担保借入（キャッシング）をする行為は、貸金業法上、総量規制の対象となる。",
        "choice3": "クレジットカード会員規約では、原則としてクレジットカードは他人へ貸与することが禁止されているが、クレジットカード会員が生計を維持している親族に対しては貸与することができる。",
        "choice4": "クレジットカード会員の信用情報は、クレジットカード会社が加盟する指定信用情報機関により管理されており、会員は自己の信用情報について所定の手続きにより開示請求をすることができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1010,
        "shikenId": 20,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "個人年金保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、契約者（＝保険料負担者）、被保険者および年金受取人は同一人とする。",
        "choice1": "外貨建て個人年金保険では、円換算支払特約を付加することで、契約時点の為替レートで円換算した年金を受け取ることができる。",
        "choice2": "個人年金保険では、被保険者が保険料払込期間中に所定の高度障害状態に該当すると、以後の保険料の払込みが免除され、直ちに年金を受け取ることができる。",
        "choice3": "個人年金保険（保証期間付終身年金）では、保証期間中に被保険者が死亡した場合、死亡給付金受取人が、既払込保険料相当額からすでに支払われた年金額を差し引いた金額を死亡給付金として受け取ることができる。",
        "choice4": "生存保障重視型の個人年金保険では、他の契約条件が同一で生存保障重視型ではない個人年金保険と比較して、保険料払込期間中の死亡給付金や解約返戻金の額が低く設定され、将来受け取る年金額が高く設定されている。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1011,
        "shikenId": 20,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "養老保険では、被保険者に高度障害保険金が支払われた場合であっても、その被保険者が保険期間満了まで生存したときには満期保険金が支払われる。",
        "choice2": "収入保障保険の死亡保険金を年金形式で受け取る場合の受取総額は、一時金で受け取る場合の受取額と同額である。",
        "choice3": "変額保険（終身型）の死亡保険金については、運用実績に応じて保険金額が変動するが、契約時に定めた保険金額（基本保険金額）は保証される。",
        "choice4": "こども保険（学資保険）では、契約者が死亡した場合、あらかじめ指定された受取人に死亡給付金が支払われる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1012,
        "shikenId": 20,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険料控除に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "養老保険の保険料は、介護医療保険料控除の対象となる。",
        "choice2": "少額短期保険の保険料は、その保険契約が被保険者の死亡時に死亡保険金が支払われるものである場合、一般の生命保険料控除の対象となる。",
        "choice3": "終身保険の月払保険料のうち、2027年１月に払い込まれた2026年12月分の保険料は、2026年分の一般の生命保険料控除の対象となる。",
        "choice4": "変額個人年金保険の保険料は、個人年金保険料控除の対象とはならず、一般の生命保険料控除の対象となる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1013,
        "shikenId": 20,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "個人年金保険の税金に関する次の記述のうち、最も不適切なものはどれか。なお、いずれも契約者（＝保険料負担者）は個人であるものとする。",
        "choice1": "契約者と被保険者が異なる個人年金保険において、年金支払開始前に被保険者が死亡して契約者が受け取った死亡給付金は、所得税の課税対象となる。",
        "choice2": "契約者と年金受取人が異なる個人年金保険において、年金支払開始時に年金受取人が取得した年金受給権は、贈与税の課税対象となる。",
        "choice3": "契約者と年金受取人が同一人である個人年金保険（保証期間付終身年金）において、保証期間中に年金受取人が死亡して遺族が取得した残りの保証期間の年金受給権は、相続税の課税対象となる。",
        "choice4": "契約者と年金受取人が同一人である個人年金保険において、年金受取人が毎年受け取る年金は、雑所得として公的年金等控除の対象となる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1014,
        "shikenId": 20,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人を契約者（＝保険料負担者）とする生命保険に係る保険料の経理処理に関する次の記述のうち、最も適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、2026年10月に締結したものとする。",
        "choice1": "被保険者が役員および従業員全員、死亡保険金受取人が被保険者の遺族、満期保険金受取人が法人である養老保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice2": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を損金に計上する。",
        "choice3": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が60％である定期保険（保険期間20年、年払保険料100万円）の支払保険料は、保険期間の前半100分の40相当期間においては、その40％相当額を限度に資産の額に算入する。",
        "choice4": "被保険者が役員、給付金受取人が法人である解約返戻金のない医療保険の支払保険料は、資産の額に算入する。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1015,
        "shikenId": 20,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。<br>なお、記載のない事項については考慮しないものとする。",
        "choice1": "対物賠償保険では、被保険自動車を運転中に、父の自宅の車庫に誤って衝突して車庫を損壊させた場合、補償の対象となる。",
        "choice2": "対人賠償保険では、被保険自動車を運転中に、対人事故を起こした被保険者が法律上の損害賠償責任を負った場合、自動車損害賠償責任保険等によって補償される部分を除いた額が補償の対象となる。",
        "choice3": "人身傷害保険では、被保険者が被保険自動車を運転中に起こした交通事故で死傷した場合、被保険者の過失割合にかかわらず、当該損害額が保険金額を限度として補償の対象となる。",
        "choice4": "一般条件の車両保険では、被保険自動車が洪水で水没した場合、補償の対象となる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1016,
        "shikenId": 20,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "住宅用建物および家財を保険の対象とする火災保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、特約については考慮しないものとする。",
        "choice1": "火災保険の保険料は、対象となる住宅用建物の構造により、Ｍ構造、Ｔ構造、Ｈ構造の３つに区分されて算定される。",
        "choice2": "保険金額が2,000万円（保険価額と同額）の火災保険に加入した後、火災により住宅用建物が損害を被り、損害保険金1,000万円が支払われた場合、保険契約は継続するが、保険期間満了日までの保険金額が1,000万円に減額される。",
        "choice3": "火災保険では、隣家の火災の消火活動により住宅用建物に収容されている家財が損壊した場合、補償の対象とならない。",
        "choice4": "火災保険では、雪災により住宅用建物の屋根が損壊して100万円の損害が発生した場合、補償の対象とならない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1017,
        "shikenId": 20,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "医療保険等の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "がん保険の入院給付金は、１回の入院における支払日数および通算の支払日数に制限はない。",
        "choice2": "先進医療特約で先進医療給付金の支払対象とされている先進医療は、契約時点において厚生労働大臣によって定められているものである。",
        "choice3": "１泊２日の入院検査（人間ドック検診）で異常が認められ、治療を目的とした入院を医師から指示された場合、その追加の入院については医療保険の入院給付金の支払対象とならない。",
        "choice4": "特定（三大）疾病保障定期保険では、被保険者が特定疾病に罹患し、特定疾病保険金を受け取った場合でも、その後被保険者が死亡した際には死亡保険金が支払われる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1018,
        "shikenId": 20,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "第三分野の保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
        "choice1": "所得補償保険では、ケガや病気によって就業不能となった場合であっても、所定の医療機関に入院しなければ、補償の対象とならない。",
        "choice2": "生命保険会社が取り扱う介護保険は、公的介護保険の加入年齢である40歳から加入可能となり、保険期間は65歳までとされる。",
        "choice3": "限定告知型の医療保険では、他の契約条件が同一で限定告知型ではない医療保険と比較して、割高な保険料が設定されている。",
        "choice4": "がん保険では、180日間または６ヵ月間の免責期間が設けられており、その期間中にがんと診断されても、がん診断給付金は支払われない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1019,
        "shikenId": 20,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "損害保険を利用した事業活動のリスク管理に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "家庭用品を製造する事業者が、製造した製品が原因で、当該製品を使用した顧客がケガをして法律上の損害賠償責任を負うリスクに備えて、生産物賠償責任保険（ＰＬ保険）を契約した。",
        "choice2": "ボウリング場を経営する事業者が、施設の管理不備により、来場者がケガをして法律上の損害賠償責任を負うリスクに備えて、受託者賠償責任保険を契約した。",
        "choice3": "建設業を営む事業者が、従業員が業務中の事故によりケガをする場合に備えて、労働者災害補償保険（政府労災保険）の上乗せとして企業費用・利益総合保険を契約した。",
        "choice4": "事業用ビルの賃貸業を営む事業者が、賃貸ビルに設置した機械設備が火災により損害を被る場合に備えて、機械保険を契約した。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1020,
        "shikenId": 20,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預貯金の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "決済用預金は、「無利息」「要求払い」「決済サービスを提供できること」という３つの条件を満たした預金である。",
        "choice2": "当座預金は、株式の配当金の自動受取口座として利用することができる。",
        "choice3": "スーパー定期預金は、預入期間が３年以上の場合、単利型と半年複利型があるが、半年複利型を利用することができるのは法人に限られる。",
        "choice4": "大口定期預金は、最低預入金額が1,000万円に設定された固定金利型の定期預金である。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1021,
        "shikenId": 20,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預金の一般的な商品性等に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、「民間公益活動を促進するための休眠預金等に係る資金の活用に関する法律」を休眠預金等活用法という。",
        "choice1": "オプション取引などのデリバティブを組み込んだ仕組預金には、金融機関の判断によって満期日が繰り上がるものがある。",
        "choice2": "ゆうちょ銀行の預入限度額は、通常貯金と定期性貯金（財形貯金各種を除く）のそれぞれについて1,300万円となっている。",
        "choice3": "期日指定定期預金は、据置期間経過後から最長預入期日までの間で、金融機関が指定した日が満期日となる。",
        "choice4": "2009年１月１日以降、取引がないまま10年が経過した預金等は、休眠預金等活用法に基づく「休眠預金等」に該当する。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1022,
        "shikenId": 20,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "株式投資信託の運用手法および運用スタイルに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "株価が現在の資産価値や利益水準などから割安と評価される銘柄に投資する手法は、グロース投資と呼ばれる。",
        "choice2": "ベンチマークを上回る運用成果を目指す株式投資信託の運用手法は、パッシブ運用と呼ばれる。",
        "choice3": "「ブル型」「ベア型」と呼ばれる特殊型の投資信託のうち、「ベア型」は、ベンチマークが上昇すると基準価額が上昇するように設計されている。",
        "choice4": "マクロ的な環境要因等を基に国別組入比率や業種別組入比率などを決定し、その比率に応じて、個別銘柄を組み入れてポートフォリオを構築する手法は、トップダウン・アプローチと呼ばれる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1023,
        "shikenId": 20,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "固定利付国債の利回り（単利・年率）と市場金利の変動との関係を説明した次の記述の空欄（ア）、（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとし、国債のイールドカーブは順イールド（期間が長いものほど利回りが高い）の状況にあるものとする。<br><br><img src='/img/20_24_1780886316338003_1.png'>",
        "choice1": "（ア）上回り   （イ）よりも高くなる",
        "choice2": "（ア）下回り   （イ）で変わらない",
        "choice3": "（ア）上回り   （イ）で変わらない",
        "choice4": "（ア）下回り   （イ）よりも低くなる",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1024,
        "shikenId": 20,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "下記＜Ｘ社のデータ＞に基づき算出される投資指標等に関する次の記述のうち、最も適切なものはどれか。<br><br><br>＜Ｘ社のデータ＞<br><br><img src='/img/20_25_1780886326847529_2.png'>",
        "choice1": "１株当たり当期純利益は、50円である。",
        "choice2": "ＲＯＥ（自己資本当期純利益率）は、40.0％である。",
        "choice3": "ＰＢＲ（株価純資産倍率）は、4.0倍である。",
        "choice4": "配当利回りは、7.5％である。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1025,
        "shikenId": 20,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "株式の信用取引の一般的な仕組みに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "信用取引では、現物株式を所有していない場合、その株式の「売り」から取引を開始することはできない。",
        "choice2": "制度信用取引の建株を一般信用取引の建株に変更することはできるが、一般信用取引の建株を制度信用取引の建株に変更することはできない。",
        "choice3": "信用取引では、売買が成立した後に相場が変動して証券会社が定める最低委託保証金維持率を下回った場合、追加保証金を差し入れるなどの方法により、委託保証金の不足を解消しなければならない。",
        "choice4": "金融商品取引法では、株式の信用取引を行う際の委託保証金の額は20万円以上であり、かつ、当該取引に係る株式の時価に100分の20を乗じた金額以上でなければならないとされている。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1026,
        "shikenId": 20,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融派生商品に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "金融派生商品を利用する場合、現物取引を行った場合と同等の投資効果を得るには、現物取引よりも多額の資金を投入する必要がある。",
        "choice2": "現物価格の変動による利益と同額の利益が発生するように、現物と同じポジションの先物を保有することなどにより、価格変動リスク等を回避または軽減することを狙う取引を、ヘッジ取引という。",
        "choice3": "現物価格と当該現物を原資産とする先物の理論価格との間で価格差が生じた場合、割安な方を売り、割高な方を買うポジションを組み、その価格差を利益として得ることを狙う取引を、裁定取引という。",
        "choice4": "先物の将来の価格を予想してポジションを取り、予想どおりの方向に変動したときに反対売買を行って利益を確定することを狙う取引を、スペキュレーション取引という。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1027,
        "shikenId": 20,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "下記＜資料＞に基づくファンドＡとファンドＢの過去３年間の運用パフォーマンスの比較評価に関する次の記述の空欄（ア）～（ウ）にあてはまる語句または数値の組み合わせとして、最も適切なものはどれか。<br><br><img src='/img/20_28_1780886327367706_3.png'><br><br><img src='/img/20_28_1780886328082313_4.png'>",
        "choice1": "（ア）0.95   （イ）0.69   （ウ）ファンドＡ",
        "choice2": "（ア）0.95   （イ）0.69   （ウ）ファンドＢ",
        "choice3": "（ア）0.80   （イ）0.60   （ウ）ファンドＡ",
        "choice4": "（ア）0.80   （イ）0.60   （ウ）ファンドＢ",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1028,
        "shikenId": 20,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "わが国における個人による金融商品取引に係るセーフティネットに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "確定拠出年金の加入者が運用の方法として選択した定期預金は、加入者の預金として、預金保険制度による保護の対象となる。",
        "choice2": "日本国内で事業を行う生命保険会社が破綻した場合、生命保険契約者保護機構による補償の対象となる保険契約については、高予定利率契約を除き、原則として、破綻時点の責任準備金等の80％まで補償される。",
        "choice3": "証券会社が破綻し、分別管理が適切に行われていなかったために、一般顧客の資産の一部または全部が返還されない事態が生じた場合、日本投資者保護基金により、補償対象債権に係る顧客資産について一般顧客１人当たり1,000万円を上限として補償される。",
        "choice4": "銀行で購入した投資信託は、日本投資者保護基金による保護の対象とならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1029,
        "shikenId": 20,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融商品の取引等に係る各種法令に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、「金融サービスの提供及び利用環境の整備等に関する法律」を金融サービス提供法という。",
        "choice1": "金融サービス提供法において、金融サービス仲介業の登録を受けた事業者は、銀行業・金融商品取引業・保険業・貸金業に係る金融サービスのうち、顧客に対し高度に専門的な説明を必要とする金融サービスを仲介することが認められている。",
        "choice2": "金融商品取引法において、金融商品取引業者等が顧客と金融商品取引契約を締結するときは、原則として、契約後すみやかに重要事項を記載した契約締結前交付書面を交付することが義務付けられている。",
        "choice3": "大阪取引所における金、白金などのコモディティを対象とした市場デリバティブ取引は、金融商品取引法の適用対象とならない。",
        "choice4": "消費者契約法において、消費者が事業者の一定の行為により誤認または困惑し、それによって消費者契約の申込みまたは承諾の意思表示をしたときは、消費者はこれを取り消すことができるとされている。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1030,
        "shikenId": 20,
        "parentNo": 1,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税の基本的な仕組みに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "所得税では、原則として、納税者本人の申告により納付すべき税額が確定し、この確定した税額を納付する申告納税制度が採用されている。",
        "choice2": "所得税の納税義務を負うのは居住者のみであり、非居住者が所得税の納税義務を負うことはない。",
        "choice3": "所得税では、課税対象となる所得を10種類に区分し、それぞれの所得の種類ごとに定められた計算方法により所得の金額を計算する。",
        "choice4": "所得税額の計算において課税総所得金額に乗じる税率は、課税総所得金額が大きくなるにつれて段階的に税率が高くなる超過累進税率が採用されている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1031,
        "shikenId": 20,
        "parentNo": 1,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における各種所得に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "老齢基礎年金の受給者の公的年金等に係る雑所得以外の所得に係る合計所得金額が1,000万円を超える場合、雑所得の金額の計算上、老齢基礎年金に係る収入金額から公的年金等控除額は控除されない。",
        "choice2": "不動産の貸付けをしたことに伴い敷金の名目により収受した金銭の額のうち、その全部または一部について、返還を要しないことが確定した金額は、その確定した日の属する年分の不動産所得の金額の計算上、総収入金額に算入する。",
        "choice3": "2026年中に退職一時金を受け取った退職者が、「退職所得の受給に関する申告書」を提出していない場合、所得税および復興特別所得税として、退職一時金の支給額の20.42％が源泉徴収される。",
        "choice4": "為替予約を締結していない外貨定期預金を満期時に円貨で払い戻した結果生じた為替差益は、雑所得として総合課税の対象となる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1032,
        "shikenId": 20,
        "parentNo": 1,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における各種所得の金額の計算上生じた次の損失の金額のうち、給与所得の金額と損益通算することができるものはどれか。",
        "choice1": "上場株式等に係る譲渡所得の金額の計算上生じた損失の金額",
        "choice2": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき業務の用に供する土地の取得に要した負債の利子の額に相当する部分の金額",
        "choice3": "公的年金等以外の雑所得の金額の計算上生じた損失の金額",
        "choice4": "物品販売業による事業所得の金額の計算上生じた損失の金額",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1033,
        "shikenId": 20,
        "parentNo": 1,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における所得控除等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "控除対象扶養親族のうち、その年の12月31日時点の年齢が19歳以上23歳未満の者を特定扶養親族といい、その者に係る扶養控除の額は63万円である。",
        "choice2": "合計所得金額が900万円以下の納税者と生計を一にする配偶者（青色申告者の事業専従者として給与の支払いを受ける人および白色申告者の事業専従者である人を除く）の合計所得金額が62万円以下の場合、納税者が適用を受けることができる配偶者控除の額は38万円である。",
        "choice3": "納税者の合計所得金額が2,500万円を超える場合、基礎控除の額は58万円である。",
        "choice4": "給与所得控除額は、給与等の収入金額に応じて計算されるが、収入金額が850万円を超える場合は195万円となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1034,
        "shikenId": 20,
        "parentNo": 1,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税の青色申告に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "青色申告の適用を受けることができる者は、不動産所得、事業所得、山林所得を生ずべき業務を行う者で、納税地の所轄税務署長の承認を受けた者である。",
        "choice2": "前年からすでに業務を行っている者が、本年分から新たに青色申告の適用を受けようとする場合、その承認を受けようとする年の３月31日までに「青色申告承認申請書」を納税地の所轄税務署長に提出しなければならない。",
        "choice3": "青色申告を取りやめようとする者は、その年の翌年３月15日までに「青色申告の取りやめ届出書」を納税地の所轄税務署長に提出しなければならない。",
        "choice4": "前年からすでに業務を行っている者が、本年分から新たに青色申告の適用を受けるために青色申告の承認の申請を行ったが、その年の12月31日までに、その申請につき承認または却下の処分がなかったときは、その日において承認があったものとみなされる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1035,
        "shikenId": 20,
        "parentNo": 1,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における住宅借入金等特別控除（以下「住宅ローン控除」という）に関する次の記述のうち、最も適切なものはどれか。なお、記載されたもの以外の要件はすべて満たしているものとする。",
        "choice1": "住宅ローン控除の対象となる家屋は、納税者がもっぱら居住の用に供する家屋に限られ、店舗併用住宅は対象とならない。",
        "choice2": "住宅ローン控除の適用を受けるためには、その対象となる家屋を取得等した日から３ヵ月以内に自己の居住の用に供さなければならない。",
        "choice3": "給与所得者が住宅ローン控除の適用を受けようとする場合、最初の年分については年末調整の対象者であっても確定申告しなければならない。",
        "choice4": "住宅ローン控除の適用を受けていた者が、転勤等のやむを得ない事由により転居したため、取得した住宅を居住の用に供さなくなった場合、翌年以降はいかなる場合も当該住居に係る住宅ローン控除の適用を受けることができない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1036,
        "shikenId": 20,
        "parentNo": 1,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人税の損金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "2016年４月１日以後に取得した建物附属設備の減価償却方法は、定額法である。",
        "choice2": "役員退職給与を損金の額に算入するためには、所定の時期に確定額を支給する旨の定めの内容に関する届出書をあらかじめ税務署長に提出しなければならない。",
        "choice3": "参加者１人当たり10,000円以下の得意先との接待飲食費は、必要とされる書類を保存していれば、その２分の１の額を損金の額に算入することができる。",
        "choice4": "損金の額に算入される租税公課のうち、事業税については、原則として、その事業税に係る納税申告書を提出した日の属する事業年度の損金の額に算入することができない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1037,
        "shikenId": 20,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "消費税の簡易課税制度に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "簡易課税制度の適用を受けることができるのは、基準期間における課税売上高が１億円以下の事業者である。",
        "choice2": "新たに事業を開始した事業者は、事業を開始した日の属する課税期間内に、「消費税簡易課税制度選択届出書」を所轄税務署長に提出することで、当該課税期間から簡易課税制度の適用を受けることができる。",
        "choice3": "簡易課税制度を選択した事業者は、事業を廃止した場合を除き、原則として、５年間は簡易課税制度の適用を継続しなければならない。",
        "choice4": "簡易課税制度の選択を取りやめる場合、原則として、その適用を取りやめようとする課税期間の初日から３ヵ月以内に「消費税簡易課税制度選択不適用届出書」を所轄税務署長に提出しなければならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1038,
        "shikenId": 20,
        "parentNo": 1,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "役員が会社に無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が、その役員の雑所得の収入金額に算入される。",
        "choice2": "会社が所有する建物を適正な時価よりも高い価額で役員に譲渡した場合、その会社の所得の金額の計算上、適正な時価と譲渡対価の差額は、益金の額に算入される。",
        "choice3": "会社が役員の所有する土地を時価未満の価額で譲り受けた場合、時価と譲受対価の差額相当額は、その会社の所得金額の計算上、益金の額に算入される。",
        "choice4": "役員が会社の所有する社宅に無償で居住している場合、原則として、通常の賃料相当額が、その役員の給与所得の収入金額に算入される。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1039,
        "shikenId": 20,
        "parentNo": 1,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "決算書の分析に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "当座比率（％）は、「当座資産÷流動負債×100」の算式で計算される。",
        "choice2": "固定比率（％）は、「固定資産÷自己資本×100」の算式で計算される。",
        "choice3": "自己資本比率（％）は、「自己資本÷総資産×100」の算式で計算される。",
        "choice4": "流動比率（％）は、「流動資産÷総資産×100」の算式で計算される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1040,
        "shikenId": 20,
        "parentNo": 1,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産鑑定評価基準における不動産の価格を求める鑑定評価の手法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "収益還元法は、文化財の指定を受けた建造物等の一般的に市場性を有しない不動産や賃貸の用に供されていない自用の不動産の価格を求める際には、基本的に適用してはならないとされている。",
        "choice2": "収益還元法のうち直接還元法は、対象不動産の一期間の純収益を還元利回りで還元して対象不動産の価格を求める手法である。",
        "choice3": "原価法は、価格時点における対象不動産の再調達原価を求め、この再調達原価について増価修正を行って対象不動産の価格を求める手法である。",
        "choice4": "取引事例比較法では、取引事例の取引時点が価格時点と異なり、その間に価格水準の変動があると認められる場合であっても、当該取引事例の価格は取引時点の価格から修正する必要はないとされている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1041,
        "shikenId": 20,
        "parentNo": 1,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "土地の価格に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "地価公示法による公示価格は、毎年１月１日を標準地の価格判定の基準日としている。",
        "choice2": "都道府県地価調査の基準地の標準価格は、毎年７月１日を価格判定の基準日としている。",
        "choice3": "固定資産税評価額は、原則として、市町村長が固定資産評価基準により決定する。",
        "choice4": "評価替えの基準年度における宅地の固定資産税評価額は、前年の地価公示法による公示価格等の80％を目途として評定されている。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1042,
        "shikenId": 20,
        "parentNo": 1,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も不適切なものはどれか。なお、本問においては、定期借地権等以外の借地権を普通借地権という。",
        "choice1": "普通借地権の設定契約は、公正証書によってしなければならない。",
        "choice2": "普通借地権の存続期間が満了した時点で借地上に建物が存在しない場合は、借地権者が契約の更新を請求しても、従前の契約と同一の条件で契約が更新されたものとはみなされない。",
        "choice3": "借地権者の債務不履行により普通借地権の設定契約が解除された場合、借地権者は、借地権設定者に対し、借地上の建物を時価で買い取るべきことを請求することができない。",
        "choice4": "普通借地権の設定契約において、期間の定めがないときは、存続期間は30年とされる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1043,
        "shikenId": 20,
        "parentNo": 1,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、借地借家法第38条における定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、特約については考慮しないものとする。",
        "choice1": "普通借家契約において、建物の賃借人による建物の賃貸借の解約の申入れは、賃貸人および賃借人が建物の使用を必要とする事情や建物の利用状況などを考慮して、正当の事由があると認められる場合でなければすることができない。",
        "choice2": "定期借家契約は、建物の賃借人が建物の全部または一部を事業の用に供することを目的とする場合、公正証書によってしなければならない。",
        "choice3": "普通借家契約において、存続期間を１年未満とする建物の賃貸借は、期間の定めがない建物の賃貸借とみなされる。",
        "choice4": "定期借家契約は、契約の更新がなく、期間の満了により建物の賃貸借が終了し、再契約をすることはできない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1044,
        "shikenId": 20,
        "parentNo": 1,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "都市計画区域内において、用途地域が定められている区域については、防火地域または準防火地域のいずれかを定めなければならない。",
        "choice2": "三大都市圏の一定の区域や一定の大都市の都市計画区域においては、都市計画に市街化区域と市街化調整区域との区分を定めるものとされている。",
        "choice3": "市街化区域および市街化調整区域については、原則として用途地域を定めるものとされている。",
        "choice4": "市街化区域は、すでに市街地を形成している区域およびおおむね５年以内に優先的かつ計画的に市街化を図るべき区域とされている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1045,
        "shikenId": 20,
        "parentNo": 1,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "区分所有建物のうち、構造上の独立性と利用上の独立性を備えた部分は、区分所有権の目的となる専有部分の対象となり、規約により共用部分とすることはできない。",
        "choice2": "区分所有者は、規約に別段の定めがない限り、集会の決議によって管理者を選任し、または解任することができる。",
        "choice3": "区分所有者は、敷地利用権が数人で有する所有権である場合、原則として、その有する専有部分とその専有部分に係る敷地利用権とを分離して処分することはできない。",
        "choice4": "区分所有者以外の専有部分の占有者は、建物またはその敷地もしくは附属施設の使用方法について、区分所有者が規約または集会の決議に基づいて負う義務と同一の義務を負う。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1046,
        "shikenId": 20,
        "parentNo": 1,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の取得等に係る税金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "所定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、１戸につき最高1,200万円を価格から控除することができる。",
        "choice2": "不動産に抵当権設定登記をする際の登録免許税の課税標準は、債権金額（根抵当権の場合は極度額）である。",
        "choice3": "土地の所有権を等価交換方式による全部譲渡により取得した場合は、原則として、取得者に対して不動産取得税は課されない。",
        "choice4": "不動産の所有権移転登記をする際の登録免許税の税率は、登記原因が贈与による場合の方が相続による場合に比べて高くなる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1047,
        "shikenId": 20,
        "parentNo": 1,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "個人が土地を譲渡した場合の譲渡所得に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "相続人が相続（単純承認）により取得した土地を譲渡した場合、その土地の所有期間を判定する際の取得の日は、相続人が当該相続を登記原因として所有権移転登記をした日である。",
        "choice2": "2026年中に行われた土地の譲渡が短期譲渡所得に区分される場合、課税短期譲渡所得に対して、原則として、所得税（復興特別所得税を含む）15.315％、住民税５％の税率により課税される。",
        "choice3": "土地を譲渡する際に支出した仲介手数料は、譲渡所得の金額の計算上、譲渡費用に含まれない。",
        "choice4": "譲渡所得の金額の計算上、譲渡した土地の取得費が不明な場合には、譲渡収入金額の５％相当額を取得費とすることができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1048,
        "shikenId": 20,
        "parentNo": 1,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "居住用財産を譲渡した場合の3,000万円の特別控除（以下「3,000万円特別控除」という）および居住用財産を譲渡した場合の長期譲渡所得の課税の特例（以下「軽減税率の特例」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "3,000万円特別控除は、居住用財産で居住の用に供さなくなったものを譲渡する場合、居住の用に供さなくなった日から３年を経過した日の属する年の12月31日までに譲渡しなければ、適用を受けることができない。",
        "choice2": "軽減税率の特例は、譲渡した日の属する年の１月１日における居住用財産の所有期間が20年を超えていなければ、適用を受けることができない。",
        "choice3": "3,000万円特別控除は、居住用財産を配偶者に譲渡した場合には適用を受けることができない。",
        "choice4": "3,000万円特別控除と軽減税率の特例は、同一の居住用財産の譲渡について、重複して適用を受けることができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1049,
        "shikenId": 20,
        "parentNo": 1,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の有効活用の手法の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "等価交換方式における全部譲渡方式は、土地所有者がいったん土地の全部をデベロッパーに譲渡し、その対価としてその土地上にデベロッパーが建設した建物およびその土地の一部を譲り受ける方式である。",
        "choice2": "建設協力金方式は、土地所有者が、建設する建物を貸し付ける予定のテナント等に建設資金の全部または一部を貸し付け、当該テナント等がビルや店舗等を建設する方式である。",
        "choice3": "定期借地権方式では、土地所有者が自己の土地上に建設される建物の所有名義人となり、当該土地と建物を一定期間貸し付けることにより地代・賃料収入を得ることができる。",
        "choice4": "事業受託方式は、土地の有効活用の企画、建設会社の選定、建設資金の調達等をデベロッパーに任せ、当該土地上に建設された建物の管理・運営等は土地所有者が行う方式である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1050,
        "shikenId": 20,
        "parentNo": 1,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の贈与に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "書面によらない贈与は、その履行の終わった部分については、各当事者が解除をすることができない。",
        "choice2": "定期贈与とは、贈与者が受贈者に対して定期的に財産を給付することを目的とする贈与をいい、贈与者または受贈者のいずれか一方の死亡によって、その効力を失う。",
        "choice3": "死因贈与では、民法の遺贈に関する規定が準用され、贈与者のみの意思表示により成立し、贈与者の死亡によって効力が生じる。",
        "choice4": "負担付贈与では、受贈者がその負担である義務を履行しない場合において、贈与者が相当の期間を定めてその履行の催告をし、その期間内に履行がない場合、原則として、贈与者は、当該贈与の契約の解除をすることができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1051,
        "shikenId": 20,
        "parentNo": 1,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続人が次の（ア）～（ウ）である場合、民法上、それぞれの場合における被相続人の配偶者の法定相続分の組み合わせとして、最も適切なものはどれか。<br>（ア）被相続人の配偶者および子の合計２人<br>（イ）被相続人の配偶者および母の合計２人<br>（ウ）被相続人の配偶者および兄の合計２人",
        "choice1": "（ア）１／２   （イ）１／３   （ウ）１／４",
        "choice2": "（ア）１／２   （イ）２／３   （ウ）３／４",
        "choice3": "（ア）３／４   （イ）２／３   （ウ）１／２",
        "choice4": "（ア）１／３   （イ）２／３   （ウ）３／４",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1052,
        "shikenId": 20,
        "parentNo": 1,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "贈与税の申告と納付に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "国税電子申告・納税システム（e-Tax）は、贈与税の申告には対応していない。",
        "choice2": "贈与税の申告書は、原則として、贈与を受けた年の翌年２月１日から３月15日までの間に、受贈者の納税地の所轄税務署長に提出しなければならない。",
        "choice3": "贈与税を納期限までに納付することが困難である場合、その納付を困難とする金額を限度として延納を申請することができる。",
        "choice4": "贈与税の納付について認められる延納期間は、最長５年である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1053,
        "shikenId": 20,
        "parentNo": 1,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の相続人等に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。",
        "choice1": "特別養子縁組による養子は、実方の父母の相続人とならない。",
        "choice2": "被相続人の子が廃除により相続権を失った場合、その者に被相続人の直系卑属である子がいるときは、その子（被相続人の孫）は代襲相続人となる。",
        "choice3": "離婚した元配偶者との間に出生した被相続人の子が当該元配偶者のみの親権に服している場合、その子は相続人とならない。",
        "choice4": "被相続人と婚姻の届出をしておらず、被相続人といわゆる内縁関係にあった者は、被相続人の配偶者とはみなされず相続人とならない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1054,
        "shikenId": 20,
        "parentNo": 1,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法に規定する相続の承認および放棄に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "被相続人の子が相続の放棄をした場合、その相続の放棄をした者の子（被相続人の孫）は、代襲相続人とならない。",
        "choice2": "契約者（＝保険料負担者）および被保険者を被相続人とする生命保険契約の死亡保険金受取人に指定されていた相続人が、被相続人の死亡により死亡保険金を受け取った場合、その相続について単純承認をしたものとみなされる。",
        "choice3": "単純承認とは、相続人が受け継いだ資産（積極財産）の範囲内で負債（消極財産）を支払い、積極財産を超える消極財産については責任を負わないという相続の方法をいう。",
        "choice4": "相続の放棄をしようとする者は、原則として、相続の開始があったことを知った時から１ヵ月以内に、家庭裁判所に相続の放棄をする旨を申述しなければならない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1055,
        "shikenId": 20,
        "parentNo": 1,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税における宅地の評価に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "二方面に路線がある角地を路線価方式によって評価する場合、それぞれの路線価に奥行価格補正率を乗じた価額を比較し、高い方の路線価が正面路線価となる。",
        "choice2": "宅地の価額は、その宅地が登記上は２筆の宅地であっても一体として利用している場合は、その２筆の宅地全体を１画地として評価する。",
        "choice3": "宅地の評価方法には、路線価方式と倍率方式とがあり、いずれを採用するかについては、宅地の所在地により各国税局長が指定している。",
        "choice4": "倍率方式によって評価する宅地が不整形地である場合の価額は、原則として、その宅地の固定資産税評価額に一定倍率を乗じた価額に宅地の形状に応じた補正率を乗じて算出する。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1056,
        "shikenId": 20,
        "parentNo": 1,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "小規模宅地等についての相続税の課税価格の計算の特例に関する次の空欄（ア）～（エ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、宅地等の適用面積の調整は考慮しないものとする。<br><br><img src='/img/20_57_1780886328566032_5.png'>",
        "choice1": "（ア）50％   （イ）330㎡   （ウ）400㎡   （エ）50％",
        "choice2": "（ア）50％   （イ）400㎡   （ウ）200㎡   （エ）80％",
        "choice3": "（ア）80％   （イ）330㎡   （ウ）400㎡   （エ）50％",
        "choice4": "（ア）80％   （イ）400㎡   （ウ）200㎡   （エ）80％",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1057,
        "shikenId": 20,
        "parentNo": 1,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税の特例（以下「本特例」という）に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "受贈者の配偶者の父母（義父母）から住宅取得資金の贈与を受けた場合、本特例の適用を受けることができる。",
        "choice2": "住宅取得資金の贈与者が死亡した場合において、その相続人が贈与を受けた住宅取得資金のうち、本特例の適用を受けて贈与税が非課税とされた金額については、その贈与が暦年課税または相続時精算課税のいずれの適用を受けていたとしても、相続税の課税価格に加算されない。",
        "choice3": "受贈者が自己の居住の用に供する家屋とともにその敷地の用に供される土地を取得する場合において、その土地の取得の対価に充てるための金銭については、本特例の適用を受けることができない。",
        "choice4": "新築した家屋が店舗併用住宅である場合、その家屋の新築の対価に充てるための金銭については、本特例の適用を受けることができない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1058,
        "shikenId": 20,
        "parentNo": 1,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "Ａさんの相続が開始した場合の相続税額の計算における土地の評価に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "Ａさんが、自己が所有する土地の上に自宅を建築して居住していた場合、この土地は自用地として評価する。",
        "choice2": "Ａさんが、自己が所有する土地に建物の所有を目的とする賃借権を設定し、借地人がこの土地の上に自宅を建築して居住していた場合、この土地は貸宅地として評価する。",
        "choice3": "Ａさんの子が、Ａさんが所有する土地を使用貸借で借り受け、自宅を建築して居住していた場合、この土地は貸宅地として評価する。",
        "choice4": "Ａさんが、自己が所有する土地の上に店舗用建物を建築し、当該建物を第三者に賃貸していた場合、この土地は貸家建付地として評価する。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1059,
        "shikenId": 20,
        "parentNo": 1,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人成り等に関する次の記述の空欄（ア）～（ウ）にあてはまる数値の組み合わせとして、最も適切なものはどれか。<br><br><br><div style=\"padding: 0.5em; border:solid 1px #333\"><br>個人事業の場合、通常、利益は事業所得として他の所得と合算されて最高（ ア ）％の超過累進税率による所得税の課税対象となるが、個人事業の法人成りにより、法人に課される法人税は、原則として、比例税率となる。なお、資本金の額が１億円以下の法人（適用除外事業者を除く）に対する法人税の税率は、軽減措置が適用される。年800万円以下の所得金額からなる部分の金額については原則として（ イ ）％とされ（その事業年度の所得金額が10億円を超える場合を除く）、年800万円超の所得金額からなる部分の金額については（ ウ ）％とされる。</div>",
        "choice1": "（ア）50   （イ）19.0   （ウ）15.0",
        "choice2": "（ア）50   （イ）15.0   （ウ）19.0",
        "choice3": "（ア）45   （イ）23.2   （ウ）15.0",
        "choice4": "（ア）45   （イ）15.0   （ウ）23.2",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1101,
        "shikenId": 20,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、遺族基礎年金について説明した。Ｍさんが説明した以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>Ⅰ<br>「遺族基礎年金を受給することができる遺族の範囲は、死亡した被保険者によって生計を維持されていた『子のある配偶者』または『子』です。『子』とは、□□□末日までの間にあるか、（ ① ）で障害等級１級または２級に該当する障害の状態にあり、かつ、現に婚姻していない子を指します」<br>Ⅱ<br>「子のある配偶者が受給する遺族基礎年金の額（2026年度価額）は『（ ② ）円＋子の加算』の計算式により算出され、子の加算は第１子・第２子までは１人につき□□□円、第３子以降は１人につき（ ③ ）円となります。したがって、仮に、Ａさんが現時点（2026年９月１日）で死亡した場合、妻Ｂさんが受給することができる遺族基礎年金の額は、年額（ ④ ）円です」<br><img src=\"/img/question/20_1_1780886646241355_1.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ハ,ト,ホ,ル",
        "score": "1,1,1,1",
        "image": "2q-kojin-a-1.png"
    },
    {
        "id": 1102,
        "shikenId": 20,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、遺族厚生年金について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な数値を入力しなさい。なお、年金額は2026年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。<br><br>Ⅰ<br>「Ａさんが厚生年金保険の被保険者期間中に死亡した場合、遺族厚生年金の額は、原則として、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の４分の３相当額になります。ただし、その計算の基礎となる被保険者期間の月数が（ ① ）月に満たないときは、（ ① ）月とみなして年金額が計算されます。Ａさんが現時点（2026年９月１日）で死亡した場合、《設例》の〈Ａさんとその家族に関する資料〉および下記＜資料＞の計算式により、妻Ｂさんが受給することができる遺族厚生年金の額は、年額（ ② ）円です」<br><br>Ⅱ<br>「長女Ｄさんが遺族基礎年金および遺族厚生年金に係る年齢要件を満たさなくなり、妻Ｂさんの有する遺族基礎年金の受給権が消滅したときは、妻Ｂさんが（ ③ ）歳に達するまでの間、妻Ｂさんに支給される遺族厚生年金に中高齢寡婦加算が加算されます」<br><br><img src=\"/img/question/20_2_1780886646720872_2.png\" class=\"question-img\" />",
        "choice1": "月",
        "choice2": "円",
        "choice3": "歳",
        "choice4": "",
        "choice5": "",
        "answer": "300,551920,65",
        "score": "1,1,1",
        "image": "2q-kojin-a-1.png"
    },
    {
        "id": 1103,
        "shikenId": 20,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、公的介護保険（以下、「介護保険」という）の保険給付等について説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「仮にＡさんが現時点（2026年９月１日）で介護保険の保険給付を受けた場合、原則として実際にかかった費用（食費、居住費等を除く）の３割を自己負担する必要があります」<br>② 「Ａさんが65歳以後に、年額18万円以上の公的年金を受給している場合の介護保険の保険料の納付は、原則として普通徴収（納付書・口座振替等での納付）の方法によります」<br>③ 「介護保険の保険給付を受けるためには、市区町村から、要介護認定または要支援認定を受ける必要があります。ただし、介護保険の第２号被保険者に該当するＡさんは、要介護状態または要支援状態となった原因が、末期がんや脳血管疾患などの加齢に伴う特定疾患によって生じたものでなければ、保険給付は受けられません」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": "2q-kojin-a-1.png"
    },
    {
        "id": 1104,
        "shikenId": 20,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "《設例》のデータに基づいて算出される次の①、②を求めなさい。〈答〉は表示単位の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br>① Ｘ社のＲＯＥ<br>② Ｘ社のＰＢＲ",
        "choice1": "％",
        "choice2": "倍",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "4.44,1.11",
        "score": "2,2",
        "image": "2q-kojin-a-2.png"
    },
    {
        "id": 1105,
        "shikenId": 20,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、《設例》のデータに基づいて、株式の投資指標等について説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「一般に、ＰＥＲが低い銘柄ほど、株価は割安とみられます。ＰＥＲは、Ｙ社のほうがＸ社よりも低くなっています」<br>② 「一般に、自己資本比率が高いほど、経営の安全性が高いと考えられています。自己資本比率は、Ｙ社のほうがＸ社よりも高くなっています」<br>③ 「株価に対する配当金の割合を示す指標として、配当利回りがあります。配当利回りは、Ｙ社のほうがＸ社よりも高くなっています」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2",
        "score": "1,1,1",
        "image": "2q-kojin-a-2.png"
    },
    {
        "id": 1106,
        "shikenId": 20,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、2024年から始まった新しいＮＩＳＡについて説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「新しいＮＩＳＡでは、つみたて投資枠と成長投資枠があり、年間投資額については、つみたて投資枠が120万円、成長投資枠が240万円となります。なお、非課税保有限度額は、２つの投資枠を併せて1,800万円となります」<br>② 「新しいＮＩＳＡの成長投資枠の投資対象商品は、毎月分配型の投資信託を対象としています」<br>③ 「新しいＮＩＳＡでは、ＮＩＳＡ口座内に生じた譲渡損失は、ほかの特定口座や一般口座で生じた譲渡益と損益通算することができます」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "2q-kojin-a-2.png"
    },
    {
        "id": 1107,
        "shikenId": 20,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "ＡさんがＸ社から受け取った退職金に係る退職所得の金額を計算した下記の計算式の空欄①～③に入る最も適切な数値を入力しなさい。なお、Ａさんは、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/20_7_1780886647459740_3.png\" class=\"question-img\" />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "800,2060,470",
        "score": "1,1,1",
        "image": "2q-kojin-a-3.png"
    },
    {
        "id": 1108,
        "shikenId": 20,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2026年分の所得金額について、次の①、②を求めなさい。なお、総所得金額の計算上、Ａさんが所得金額調整控除の適用対象者に該当している場合、所得金額調整控除額を控除すること。また、〈答〉は万円単位とすること。<br><br>① 総所得金額に算入される一時所得の金額<br>② 総所得金額<br><img src=\"/img/question/20_8_1780886647999516_4.png\" class=\"question-img\" />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "50,540",
        "score": "2,2",
        "image": "2q-kojin-a-3.png"
    },
    {
        "id": 1109,
        "shikenId": 20,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における所得控除に関する次の記述①～③について、適切なものは<br>○を、不適切なものは×を選択しなさい。<br><br>① 「Ａさんが適用を受けることができる配偶者控除の額は、48万円です」<br>② 「Ａさんが適用を受けることができる長男Ｃさんに係る扶養控除の額は、63万円です」<br>③ 「Ａさんが適用を受けることができる母Ｄさんに係る扶養控除の額は、38万円です」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "2q-kojin-a-3.png"
    },
    {
        "id": 1110,
        "shikenId": 20,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "甲土地に準耐火建築物を建築する場合における次の①、②を求めなさい。<br>① 建蔽率の上限となる建築面積<br>② 容積率の上限となる延べ面積",
        "choice1": "㎡",
        "choice2": "㎡",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "320,1200",
        "score": "2,2",
        "image": "2q-kojin-a-4.png"
    },
    {
        "id": 1111,
        "shikenId": 20,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "自己建設方式による甲土地の有効活用に関する次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「Ａさんが融資を受けた場合、借入金の返済には、元金均等返済と元利均等返済の２つの方法があり、元金均等返済の場合、毎年の支払利息は同額になります。そのため、毎年の不動産所得の金額の計算上、一定額の支払利息を必要経費に算入することができます」<br>② 「賃貸マンションの地震リスクに備えるため、火災保険に地震保険を付帯することをお勧めします。地震保険の保険金額は、火災保険の保険金額の30～50％の範囲で設定することができます」<br>③ 「マスターリース契約（特定賃貸借契約）において、賃料が保証されている場合、その契約が定期借家契約でない限り、借地借家法に基づき、ＡさんがＸ社から経済事情等により賃料の減額請求を受けることはありません」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2",
        "score": "1,1,1",
        "image": "2q-kojin-a-4.png"
    },
    {
        "id": 1112,
        "shikenId": 20,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんが甲土地に自己建設方式によって賃貸マンションを建築した場合における賃貸事業開始後の相続税評価額に関する次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「甲土地は、貸家建付地として、『自用地価額×（１－借地権割合×借家権割合×賃貸割合）』の算式により評価されます」<br>② 「甲土地を相続により取得する場合、一定の要件を満たしていれば特定事業用宅地等として、400㎡のすべてが80％減額して評価されます」<br>③ 「対象地の面する道路に付された『150Ｃ』『120Ｃ』の数値は、１㎡当たりの価額を千円単位で表示した相続税路線価です。数値の後に表示されている『Ｃ』の記号（アルファベット）は、借地権割合が70％であることを示しています」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": "2q-kojin-a-4.png"
    },
    {
        "id": 1113,
        "shikenId": 20,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①〜③に入る最も適切な語句を、下記の〈語句群〉のイ〜ヌのなかから選び、その記号を答えなさい。<br><br>Ⅰ<br>「仮に、妻Ｂさんが自宅の敷地および建物を相続により取得し、相続税の申告期限までに自宅の敷地を売却した場合、当該敷地は、特定居住用宅地等として小規模宅地等についての相続税の課税価格の計算の特例の適用を受けることが（ ① ）」<br><br>Ⅱ<br>「仮に、Ａさんが、契約者（＝保険料負担者）および被保険者をＡさん、死亡保険金受取人を長男Ｃさんとする終身保険のみに加入していた場合、長男Ｃさんが受け取る死亡保険金は、相続税法における死亡保険金の非課税金額の規定により、最大（ ② ）が非課税となります」<br><br>Ⅲ<br>「配偶者に対する相続税額の軽減の適用を受けた場合、妻Ｂさんが相続により取得した財産の金額が、配偶者の法定相続分相当額と（ ③ ）とのいずれか多い金額を超えない限り、妻Ｂさんが納付すべき相続税額は算出されません」<br><br><img src=\"/img/question/20_13_1780886648409253_5.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "イ,リ,ホ",
        "score": "1,1,1",
        "image": "2q-kojin-a-5.png"
    },
    {
        "id": 1114,
        "shikenId": 20,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①～④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を答えなさい。<br><br>Ⅰ<br>「Ａさんの相続が開始し、相続人が自宅に保管されていたＡさんの自筆証書遺言を発見した場合、相続人は、遅滞なく、自筆証書遺言を（ ① ）に提出して、その検認を請求しなければなりません」<br>Ⅱ<br>「Ａさんが2026年分の所得税および復興特別所得税について確定申告書を提出しなければならない場合に該当するとき、相続人は、原則として、相続の開始があったことを知った日の翌日から（ ② ）ヵ月以内に準確定申告書を提出しなければなりません」<br>Ⅲ<br>「仮にＡさんが2026年12月22日に死亡した場合、Ａさんに係る相続税の申告書の提出期限は、原則として、2027年（ ③ ）になります。申告書の提出先は、（ ④ ）住所地を所轄する税務署長です」<br><img src=\"/img/question/20_14_1780886648692417_6.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ホ,ロ,チ,ヌ",
        "score": "1,1,1,1",
        "image": "2q-kojin-a-5.png"
    },
    {
        "id": 1115,
        "shikenId": 20,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "現時点（2026年10月１日）において、Ａさんに相続が開始した場合における相続税の総額を試算した下記の表の空欄①～③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は１億6,000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/20_15_1780886649201951_7.png\" class=\"question-img\" /><br><img src=\"/img/question/20_15_1780886649695976_8.png\" class=\"question-img\" />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "4200,1070,2140",
        "score": "1,1,1",
        "image": "2q-kojin-a-5.png"
    },
    {
        "id": 1201,
        "shikenId": 20,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんが、原則として、65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2026年度価額）を計算した次の＜計算の手順＞の空欄①～④に入る最も適切な数値を入力しなさい。計算にあたっては、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>＜計算の手順＞<br>１．老齢基礎年金の年金額（円未満四捨五入）<br>（ ① ）円<br>２．老齢厚生年金の年金額<br>⑴ 報酬比例部分の額（円未満四捨五入）<br>（ ② ）円<br>⑵ 経過的加算額（円未満四捨五入）<br>（ ③ ）円<br>⑶ 基本年金額（上記「⑴＋⑵」の額）<br>□□□円<br>⑷ 加給年金額（要件を満たしている場合のみ加算すること）<br>⑸ 老齢厚生年金の年金額<br>（ ④ ）円<br><img src=\"/img/question/20_1_1780886769903370_1.png\" class=\"question-img\" />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "789048,1126076,354,1126430",
        "score": "1,1,1,1",
        "image": "2q-hoken-a-1.png"
    },
    {
        "id": 1202,
        "shikenId": 20,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさん夫婦に対して、公的年金制度からの老齢給付について説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「Ａさんおよび妻Ｂさんが希望すれば、60歳以後、老齢基礎年金および老齢厚生年金の繰上げ支給の請求をすることができます。仮に、Ａさんが63歳０ヵ月で老齢基礎年金および老齢厚生年金の繰上げ支給の請求をした場合、年金の減額率は12.0％となります」<br>② 「Ａさんおよび妻Ｂさんが希望すれば、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができます。老齢基礎年金および老齢厚生年金の繰下げ時期については、同時に行うこともできますし、別々に選択することもできます」<br>③ 「国民年金の第３号被保険者である妻Ｂさんは、国民年金の付加保険料を納付することができます。仮に、付加保険料を48月納付した場合、65歳から受給する老齢基礎年金の額に付加年金として年額9,600円が上乗せされます」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2",
        "score": "1,1,1",
        "image": "2q-hoken-a-1.png"
    },
    {
        "id": 1203,
        "shikenId": 20,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、定年退職後の社会保険の各種取扱い等について説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「退職して被保険者の資格を失ったときは、所定の手続により、退職日の翌日から２年間、全国健康保険協会管掌健康保険に任意継続被保険者として加入することができます。ただし、２年間の任意継続被保険者である期間中に任意脱退することはできません」<br>② 「Ａさんには国民年金の未納期間がありますが、定年退職後から65歳になるまでの間、その未納期間に相当する月数について、国民年金保険料を納付しようとした場合、納付の時期にかかわらず老齢基礎年金の年金額を増額することができます」<br>③ 「Ａさんが定年退職によって厚生年金保険の被保険者でなくなったときに、妻Ｂさんは、国民年金の第３号被保険者の資格を喪失することになります。したがって、Ａさんが定年退職した日の翌日から14日以内に、第３号被保険者から第１号被保険者への種別変更の届出をしなければなりません」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "2q-hoken-a-1.png"
    },
    {
        "id": 1204,
        "shikenId": 20,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、下記の＜前提＞においてＡさんが死亡した場合、妻Ｂさんが受給することができる公的年金制度からの遺族給付について説明した。Ｍさんが説明した以下の文章の空欄①～③に入る最も適切な語句または数値を、下記の＜語句群＞のなかから選び、その記号を答えなさい。<br><br>＜前提＞<br>・妻Ｂさんは、遺族基礎年金および遺族厚生年金の受給権を取得する。<br>・妻Ｂさんおよび長女Ｃさんは、現在および将来においても、公的年金制度における障害等級に該当する障害の状態にないものとする。<br><br>「現時点において、Ａさんが死亡した場合、妻Ｂさんに対して遺族基礎年金および遺族厚生年金が支給されます。遺族基礎年金を受けられる遺族の範囲は、死亡した被保険者によって生計を維持されていた『子のある配偶者』または『子』です。『子』とは、原則として、18歳到達年度の末日までの間にあり、かつ、現に婚姻していない子等を指します。妻Ｂさんが受け取る遺族基礎年金の額は、『子』が１人のため、（ ① ）円（2026年度価額）になります。<br>遺族厚生年金の額は、原則として、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の（ ② ）相当額になります。ただし、その計算の基礎となる被保険者期間の月数が300月に満たない場合、300月とみなして年金額が計算されます。<br>また、長女Ｃさんについて18歳到達年度の末日が終了し、妻Ｂさんの有する遺族基礎年金の受給権が消滅したときは、妻Ｂさんが65歳に達するまでの間、妻Ｂさんに支給される遺族厚生年金の額に（ ③ ）が加算されます。（ ③ ）の額は、遺族基礎年金の額（子の加算額を除く）の（ ② ）相当額になります」<br><br><img src=\"/img/question/20_4_1780886771297798_2.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ロ,ヘ,リ",
        "score": "1,1,1",
        "image": "2q-hoken-a-2.png"
    },
    {
        "id": 1205,
        "shikenId": 20,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、必要保障額およびＡさんが提案を受けた生命保険の死亡保障の額について説明した。Ｍさんが説明した以下の文章の空欄①、②に入る最も適切な数値を入力しなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>「提案を受けた生命保険に加入する前に、現時点での必要保障額を算出し、準備すべき死亡保障の額を把握しましょう。下記の＜算式＞および＜条件＞を参考にすれば、Ａさんが現時点で死亡した場合の遺族に必要な生活資金等の総額は□□□万円となり、必要保障額は（ ① ）万円となります。<br>仮に、提案を受けた生命保険に加入し、加入した年中にＡさんが死亡（不慮の事故や所定の感染症以外）した場合、妻Ｂさんに支払われる死亡保険金額は（ ② ）万円となります。他方、加入した年中にＡさんが不慮の事故で180日以内に死亡した場合の死亡保険金額は□□□万円となります」<br><br><img src=\"/img/question/20_5_1780886771758956_3.png\" class=\"question-img\" /><br><img src=\"/img/question/20_5_1780886772158614_4.png\" class=\"question-img\" />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "4524,5000",
        "score": "2,1",
        "image": "2q-hoken-a-2.png"
    },
    {
        "id": 1206,
        "shikenId": 20,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、Ａさんが提案を受けた生命保険の保障内容および課税関係について説明した。Ｍさんが説明した次の記述①～④について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「必要保障額は、通常、末子が生まれた時に最小となり、その後、子どもの成長とともに逓増していきます。Ａさんの今後のライフステージの変化に合わせて、保障内容を定期的に見直すことをお勧めします」<br>② 「先進医療の治療を受けた場合、診察料、投薬料等に係る費用、技術料に係る費用はすべて全額自己負担となりますので、先進医療特約の付加をお勧めします」<br>③ 「Ａさんが重い病気等で余命１年以内と判断された場合、リビング・ニーズ特約により所定の範囲内で死亡保険金の全部または一部を生前にＡさんが受け取ることができます」<br>④ 「当該生命保険の支払保険料のうち、傷害特約に係る保険料は生命保険料控除の対象となりませんが、終身保険特約、定期保険特約および逓減定期保険特約は一般の生命保険料控除の対象となり、入院特約および先進医療特約に係る保険料は介護医療保険料控除の対象となります」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,1",
        "score": "1,1,1,1",
        "image": "2q-hoken-a-2.png"
    },
    {
        "id": 1207,
        "shikenId": 20,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "仮に、Ｘ社がＡさんに役員退職金6,500万円を支給した場合、Ａさんが受け取る役員退職金について、次の①、②を答えなさい。〈答〉は万円単位とすること。なお、Ａさんの役員在任期間（勤続年数）を39年９ヵ月とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。<br><br>① 退職所得控除額<br>② 退職所得の金額",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2200,2150",
        "score": "1,2",
        "image": "2q-hoken-a-3.png"
    },
    {
        "id": 1208,
        "shikenId": 20,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、《設例》の＜資料１＞の無配当逓増定期保険について説明した。<br>Ｍさんが説明した次の記述①～④について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「当該生命保険を払済終身保険に変更する場合、Ａさんは改めて健康状態等についての告知または医師の診査を受ける必要はないため、健康状態にかかわらず、払済終身保険に変更することができます」<br>② 「当該生命保険を払済終身保険に変更する場合、その変更時点における解約返戻金相当額とそれまでに支払った保険料の総額との差額を雑収入として益金の額に算入します」<br>③ 「当該生命保険を解約した場合にＸ社が受け取る解約返戻金は、設備投資等の事業資金として活用することができますが、Ａさんに支給する役員退職金の原資として利用することはできません」<br>④ 「当該生命保険の単純返戻率（解約返戻金額÷払込保険料累計額）は、契約締結時が最低であり、その後、保険期間満了時には100％近くに到達します。高いキャッシュバリューを確保するには、保険期間満了時に近いタイミングで解約あるいは払済終身保険への変更を検討してください」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,2",
        "score": "1,1,1,1",
        "image": "2q-hoken-a-3.png"
    },
    {
        "id": 1209,
        "shikenId": 20,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、長男Ｂさんに対して、《設例》の＜資料２＞の無配当低解約返戻金型終身保険について説明した。Ｍさんが説明した次の記述①～③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「当該生命保険の支払保険料は、その全額を資産に計上します。仮に、保険料払込期間満了時に長男Ｂさんが死亡した場合、Ｘ社はそれまで資産計上していた保険料積立金5,000万円を取り崩し、死亡保険金6,000万円との差額1,000万円を雑損失として経理処理します」<br>② 「Ｘ社が保険期間中に資金を必要とした場合、契約者貸付制度を利用することにより、当該生命保険を解約することなく、資金を調達することができます。Ｘ社が契約者貸付金を受け取った場合、当該貸付金を負債として経理処理します」<br>③ 「当該生命保険は低解約返戻金型ではない終身保険に比べて保険料払込期間中の解約返戻金の水準が低く設定されています」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": "2q-hoken-a-3.png"
    },
    {
        "id": 1210,
        "shikenId": 20,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税の課税に関する次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「Ａさんが受け取った一時払養老保険（10年満期）の満期保険金に係る保険差益は、一時所得として総合課税の対象となります」<br>② 「Ａさんの場合、一時所得に係る総収入金額が20万円を超えるため、所得税の確定申告をする必要があります」<br>③ 「Ａさんは、所得金額調整控除の適用を受けることはできません」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": "2q-hoken-a-4.png"
    },
    {
        "id": 1211,
        "shikenId": 20,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における配偶者控除に関する以下の文章の空欄①～③に入る最も適切な数値を、下記の＜数値群＞のなかから選び、その記号を答えなさい。<br><br>Ａさんの合計所得金額は（ ① ）万円以下であるため、Ａさんは（ ② ）万円の配偶者控除の適用を受けることができます。仮に、Ａさんの合計所得金額が（ ① ）万円を超えると、配偶者控除の額は段階的に縮小し、合計所得金額が（ ③ ）万円を超えると、適用を受けることができなくなります。<br><br><img src=\"/img/question/20_11_1780886773062873_5.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ト,イ,チ",
        "score": "1,1,1",
        "image": "2q-hoken-a-4.png"
    },
    {
        "id": 1212,
        "shikenId": 20,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税の算出税額を計算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/20_12_1780886773414170_6.png\" class=\"question-img\" /><br><img src=\"/img/question/20_12_1780886774172892_7.png\" class=\"question-img\" /><br><img src=\"/img/question/20_12_1780886774650210_8.png\" class=\"question-img\" />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "8000000,380000,620000,532500",
        "score": "1,1,1,1",
        "image": "2q-hoken-a-4.png"
    },
    {
        "id": 1213,
        "shikenId": 20,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ｘ社株式に関する以下の文章の空欄①～③に入る最も適切な語句を、下記の＜語句群＞のなかから選び、その記号を答えなさい。<br><br>Ⅰ<br>「Ｘ社株式の相続税評価額は、原則として類似業種比準方式により評価されます。類似業種比準価額は、類似業種の株価ならびに１株当たりの配当金額、１株当たりの利益金額、１株当たりの（ ① ）の３つの比準要素を基に計算されます」<br><br>Ⅱ<br>「長男ＤさんにＸ社株式を移転する方法として、『非上場株式等についての贈与税の納税猶予及び免除の特例』の活用が考えられます。本特例の適用を受けるためには、特例承継計画を策定して2027年９月30日までに（ ② ）に提出し、その確認を受ける必要があります。なお、『非上場株式等についての贈与税の納税猶予及び免除の特例』と相続時精算課税制度との併用は、（ ③ ）」<br><br><img src=\"/img/question/20_13_1780886775342458_9.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ニ,ト,チ",
        "score": "1,1,1",
        "image": "2q-hoken-a-5.png"
    },
    {
        "id": 1214,
        "shikenId": 20,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの相続等に関する次の記述①～③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「妻Ｂさんが相続により取得した自宅の敷地を、相続税の申告期限までに売却した場合であっても、当該敷地は特定居住用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができます」<br>② 「長男ＤさんがＸ社本社敷地を相続により取得し、特定同族会社事業用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、Ｘ社本社敷地は330㎡までを限度面積として、評価額の80％相当額を減額した金額を、相続税の課税価格に算入すべき価額とすることができます」<br>③ 「円滑な遺産分割のための手段として遺言の作成を検討してください。公正証書遺言については、証人２人以上の立会いが必要となります。推定相続人は証人にはなれませんが、長女Ｃさんおよび長男Ｄさんのお子さんは未成年者でなければ、証人になることができます」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "2q-hoken-a-5.png"
    },
    {
        "id": 1215,
        "shikenId": 20,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "現時点（2026年７月１日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①～④に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は４億2,000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/20_15_1780886775878077_10.png\" class=\"question-img\" /><br><img src=\"/img/question/20_15_1780886776339772_11.png\" class=\"question-img\" />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "",
        "answer": "4800,5740,2090,9920",
        "score": "1,1,1,1",
        "image": "2q-hoken-a-5.png"
    },
    {
        "id": 1301,
        "shikenId": 20,
        "parentNo": 2,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "ファイナンシャル・プランナー（以下「ＦＰ」という）が、ファイナンシャル・プランニング業務を行ううえでは「関連業法」を順守することが重要である。ＦＰの行為に関する次の（ア）～（エ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><br>（ア）投資助言・代理業の登録を受けていないＦＰが、特定の顧客に対し、特定企業の公表されている決算報告書を用いて、その特定企業の株式に関する具体的な投資時期等の判断や助言を行った。<br>（イ）生命保険募集人・保険仲立人の登録を受けていないＦＰが、生命保険契約を検討している顧客のライフプランに基づき、具体的な必要保障額を試算し、保険商品について一般的な説明を行った。<br>（ウ）税理士資格を有していないＦＰが、参加費無料の相談会で、相談者が持参した資料に基づき、具体的な納税額を計算した。<br>（エ）社会保険労務士資格を有していないＦＰが、顧客である個人事業主が受ける雇用関係助成金申請の書類を作成して手続きを代行し、顧客から報酬を受け取った。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1302,
        "shikenId": 20,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "「著作権法」および「個人情報の保護に関する法律（個人情報保護法）」に関する次の記述のうち、最も不適切なものはどれか。<br><br>1）公表された他人の著作物を自分の著作物に引用する場合、引用部分が「従」となる内容で、自ら作成する部分が「主」でなければならない。<br>2）法令、条例および通達を自分の著作物に引用する場合、官公庁等の許諾は必要なく、自由に引用することができる。<br>3）個人情報とは、氏名、生年月日、住所など特定の個人を識別できる情報をいい、原則として、生存する人だけでなく、死者に関する情報についても個人情報とされる。<br>4）顧客情報だけでなく、従業員の情報も個人情報とされる。",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1303,
        "shikenId": 20,
        "parentNo": 2,
        "no": 3,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "下記＜資料＞は、東野さん夫婦（一馬さんと雫さん）のＫＭ銀行（日本国内に本店のある普通銀行）における金融資産（時価）の一覧表である。この時点においてＫＭ銀行が破綻した場合に、預金保険制度によって保護される金融資産の金額に関する次の記述の空欄（ア）、（イ）にあてはまる数値を答えなさい。<br><img src=\"/img/question/20_3_1780886457534062_1.png\" class=\"question-img\" /><br>※一馬さんおよび雫さんはともに、ＫＭ銀行からの借入れはない。<br>※普通預金は決済用預金ではない。<br>※預金の利息については考慮しないこととする。<br>※ＫＭ銀行は過去１年以内に他行との合併等を行っていないこととする。<br><br><div style=\"border:solid 1px #333;padding:0.5em\">・一馬さんの金融資産のうち、預金保険制度によって保護される金額は（ ア ）万円である。<br>・雫さんの金融資産のうち、預金保険制度によって保護される金額は（ イ ）万円である。</div>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "900,270",
        "score": "2,2",
        "image": ""
    },
    {
        "id": 1304,
        "shikenId": 20,
        "parentNo": 2,
        "no": 4,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "亀田晴菜さんは、国内の証券会社の特定口座（源泉徴収選択口座）で保有していた利付国債が2026年７月に満期を迎え、償還金を受け取った（下記＜資料＞参照）。この国債の償還金に課される所得税および住民税の合計額を計算しなさい。なお、解答に当たっては、償還の際に支払われる利子については考慮しないこと。また、復興特別所得税については考慮しないこと。<br><img src=\"/img/question/20_4_1780886458166893_2.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "24000",
        "score": "2",
        "image": ""
    },
    {
        "id": 1305,
        "shikenId": 20,
        "parentNo": 2,
        "no": 5,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "下記＜資料＞の債券を取得日から３年後に売却した場合における所有期間利回り（単利・年率）を計算しなさい。なお、手数料や税金等については考慮しないものとし、計算結果については小数点以下第４位を切り捨てること。<br><img src=\"/img/question/20_5_1780886458585465_3.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "％",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "0.533",
        "score": "2",
        "image": ""
    },
    {
        "id": 1306,
        "shikenId": 20,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記＜資料＞に関する次の記述の空欄（ア）、（イ）にあてはまる語句または数値の組み合わせとして、最も適切なものはどれか。<br><img src=\"/img/question/20_6_1780886459023149_4.png\" class=\"question-img\" /><br><div style=\"border:solid 1px #333;padding:0.5em\">・ＭＡ株式のＰＢＲ（株価純資産倍率）は、（ ア ）倍である。<br>・ＭＡ株式とＭＳ株式の配当利回りを比較した場合、（ イ ）株式の方が高い。</div><br><br>1）（ア）1.20  （イ）ＭＳ<br>2）（ア）1.20  （イ）ＭＡ<br>3）（ア）0.83  （イ）ＭＳ<br>4）（ア）0.83  （イ）ＭＡ",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1307,
        "shikenId": 20,
        "parentNo": 2,
        "no": 7,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "志田さんはＴＳ投資信託を新規募集時に1,000万口購入し、特定口座（源泉徴収選択口座）で保有して収益分配金を受け取っている。下記＜資料＞に基づき、志田さんが保有するＴＳ投資信託に関する次の記述の空欄（ア）～（エ）に入る語句として適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/20_7_1780886459454655_5.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は「242,000円」である。<br>（イ）空欄（イ）にあてはまる語句は「普通分配金」である。<br>（ウ）空欄（ウ）にあてはまる語句は「9,200円」である。<br>（エ）空欄（エ）にあてはまる語句は「信託財産留保額」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1308,
        "shikenId": 20,
        "parentNo": 2,
        "no": 8,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "下記＜資料＞は岡村明憲さんが所有する土地の登記事項証明書の一部である。この登記事項証明書に関する次の（ア）～（エ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/20_8_1780886460859596_6.png\" class=\"question-img\" /><br><br>（ア）所有権以外の権利に関する事項が記載されている欄（Ａ）は、権利部の乙区である。<br>（イ）所有権以外の権利に関する事項が記載されている欄（Ａ）には、場合によっては差押えも記載される。<br>（ウ）岡村明憲さんが債務の弁済を怠った場合、株式会社ＡＢＣ銀行は、債権を回収するためにこの土地の競売を裁判所に申し立てることができる。<br>（エ）登記事項証明書は、法務局において手数料を納付することにより、誰でも交付の請求をすることができる。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1309,
        "shikenId": 20,
        "parentNo": 2,
        "no": 9,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "建築基準法に従い、下記＜資料＞の甲土地に建物を建てる場合の建築面積の最高限度を計算しなさい。なお、＜資料＞に記載のない条件については一切考慮しないこととする。<br><img src=\"/img/question/20_9_1780886461601398_7.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "㎡",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "110.4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1310,
        "shikenId": 20,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "公的な土地評価に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src=\"/img/question/20_10_1780886462355339_8.png\" class=\"question-img\" /><br>※問題作成の都合上、一部を「＊＊」としている。<br><br>1）（ア）１月１日  （イ）２年  （ウ）70％<br>2）（ア）１月１日  （イ）３年  （ウ）80％<br>3）（ア）４月１日  （イ）２年  （ウ）80％<br>4）（ア）４月１日  （イ）３年  （ウ）70％",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1311,
        "shikenId": 20,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "田村さんは、居住している自宅の土地および建物を売却する予定である。売却に係る状況が下記＜資料＞のとおりである場合、所得税における次の記述の空欄（ア）、（イ）にあてはまる数値または語句の組み合わせとして、正しいものはどれか。<br><img src=\"/img/question/20_11_1780886462939984_9.png\" class=\"question-img\" /><br><img src=\"/img/question/20_11_1780886463752467_10.png\" class=\"question-img\" /><br><br>1）（ア）6,010  （イ）長期<br>2）（ア）6,010  （イ）短期<br>3）（ア）5,520  （イ）長期<br>4）（ア）5,520  （イ）短期",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1312,
        "shikenId": 20,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記＜資料＞は、堀内さんが購入を検討している投資用マンションの概要である。この物件の表面利回り（年利）と実質利回り（年利）の組み合わせとして、正しいものはどれか。なお、＜資料＞に記載のない事項については一切考慮しないこととする。<br><img src=\"/img/question/20_12_1780886464210940_11.png\" class=\"question-img\" /><br><br>1）表面利回り（年利）：5.50％　　実質利回り（年利）：2.94％<br>2）表面利回り（年利）：5.50％　　実質利回り（年利）：4.08％<br>3）表面利回り（年利）：4.50％　　実質利回り（年利）：2.94％<br>4）表面利回り（年利）：4.50％　　実質利回り（年利）：4.08％",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 1313,
        "shikenId": 20,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "今野達樹さんが2026年中に支払った生命保険の保険料は下記＜資料＞のとおりである。この場合の今野さんの2026年分の所得税の計算における生命保険料控除の金額として最も適切なものはどれか。なお、今野達樹さんには23歳未満の扶養親族はいない。また、生命保険料控除額が最も多くなるように計算すること。<br><img src=\"/img/question/20_13_1780886465891409_12.png\" class=\"question-img\" /><br><br>1）14,000円<br>2）40,000円<br>3）50,000円<br>4）76,500円",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1314,
        "shikenId": 20,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "生命保険の指定代理請求特約の説明に関する下記の記述について、空欄（ア）～（エ）に入る語句の組み合わせとして、正しいものはどれか。なお、契約者と被保険者は別人物であるものとし、被保険者と保険金、給付金の受取人は同一人物であるものとする。<br><img src=\"/img/question/20_14_1780886467929486_13.png\" class=\"question-img\" /><br><br>1）（ア）契約者   （イ）必要です  （ウ）変更できます   （エ）被保険者<br>2）（ア）契約者   （イ）不要です  （ウ）変更できません  （エ）被保険者<br>3）（ア）被保険者  （イ）必要です  （ウ）変更できません  （エ）契約者<br>4）（ア）被保険者  （イ）不要です  （ウ）変更できます   （エ）契約者",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1315,
        "shikenId": 20,
        "parentNo": 2,
        "no": 15,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "麻生宗人さん（37歳）が保険契約者（保険料負担者）および被保険者として加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）～（ウ）にあてはまる数値を答えなさい。なお、保険契約は有効に継続しているものとし、宗人さんはこれまでに＜資料＞の保険から、保険金および給付金を一度も受け取っていないものとする。また、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><img src=\"/img/question/20_15_1780886468701721_14.png\" class=\"question-img\" /><br><img src=\"/img/question/20_15_1780886470647469_15.png\" class=\"question-img\" /><br><div style=\"border:solid 1px #333;padding:0.5em\">・宗人さんが現時点で、慢性肝炎<sup>※</sup>で18日間入院し、退院してから30日後に同じ病気で再度８日間入院した場合（いずれも手術は受けていない）、保険会社から支払われる保険金・給付金の合計は（ ア ）万円である。<br>・宗人さんが現時点で、初めてがん（悪性新生物）と診断され、治療のため40日間入院し、その間に約款所定の手術（給付倍率40倍）を１回受けた場合、保険会社から支払われる保険金・給付金の合計は（ イ ）万円である。<br>・宗人さんが現時点で、交通事故で死亡（入院・手術なし）した場合、保険会社から支払われる保険金・給付金の合計は（ ウ ）万円である。<br>※生活習慣病入院特約の対象外のものとする。</div>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "11,1266,4310",
        "score": "2,2,2",
        "image": ""
    },
    {
        "id": 1316,
        "shikenId": 20,
        "parentNo": 2,
        "no": 16,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "三島和人さん（36歳）が保険契約者（保険料負担者）および被保険者として加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）～（ウ）にあてはまる数値を答えなさい。なお、保険契約は有効に継続しているものとし、和人さんはこれまでに＜資料＞の保険から、保険金および給付金を一度も受け取っていないものとする。また、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><img src=\"/img/question/20_16_1780886471627910_16.png\" class=\"question-img\" /><br><img src=\"/img/question/20_16_1780886472535074_17.png\" class=\"question-img\" /><br><div style=\"border:solid 1px #333;padding:0.5em\">和人さんが現時点（36歳）で、<br>・交通事故で即死した場合、保険会社から支払われる保険金・給付金の合計は（ ア ）万円である。<br>・初めてがん（胃がん・悪性新生物）と診断されて14日間入院し、その間に約款所定の手術（給付倍率40倍）を１回受けた場合、保険会社から支払われる保険金・給付金の合計は（ イ ）万円である。<br>・糖尿病で10日間入院した場合（手術は受けていない）、保険会社から支払われる保険金・給付金の合計は（ ウ ）万円である。</div>",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "110,218,10",
        "score": "2,2,2",
        "image": ""
    },
    {
        "id": 1317,
        "shikenId": 20,
        "parentNo": 2,
        "no": 17,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "水木孝則さんが契約している火災保険（下記＜資料１＞＜資料２＞参照）に関する次の記述の空欄（ア）～（エ）にあてはまる語句として適切なものは○、不適切なものは×を選択しなさい。<br>なお、保険契約の内容は適正であり、かつ有効に継続しているものとし、＜資料＞に記載のない特約等については考慮しないものとする。<br><img src=\"/img/question/20_17_1780886473395039_18.png\" class=\"question-img\" /><br><img src=\"/img/question/20_17_1780886474935119_19.png\" class=\"question-img\" /><br><div style=\"border:solid 1px #333;padding:0.5em\">・水木さんの住宅の屋根が台風の強風により損壊し、100万円の損害を被った場合、補償の対象に（ ア ）。<br>・水木さんの住宅が地震による火災で延床面積の70％が焼失した場合、地震保険の損害の程度は「（ イ ）」に該当する。<br>・水木さんの建物と家財が洪水によって全損となった場合、補償の対象に（ ウ ）。<br>・水木さんの住宅に空き巣が侵入し、時価25万円の骨董品が盗まれた場合、補償の対象に（ エ ）。</div><br><br>（ア）空欄（ア）にあてはまる語句は「なる」である。<br>（イ）空欄（イ）にあてはまる語句は「全損」である。<br>（ウ）空欄（ウ）にあてはまる語句は「なる」である。<br>（エ）空欄（エ）にあてはまる語句は「なる」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1318,
        "shikenId": 20,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "個人事業主の新田さんは、2026年４月に機械装置（新品）を購入し、事業の用に供している。<br>新田さんのこの機械装置の2026年分の所得税における事業所得の金額の計算上、必要経費に算入すべき減価償却費の金額として、正しいものはどれか。なお、機械装置の取得価額は1,200万円、2026年中の事業供用月数は９ヵ月、耐用年数は15年とする。また、新田さんは個人事業を開業して以来、機械装置についての減価償却方法を選択したことはなく、法定償却方法によるものとする。<br><img src=\"/img/question/20_18_1780886476068942_20.png\" class=\"question-img\" /><br><br>1）603,000円<br>2）804,000円<br>3）1,197,000円<br>4）1,596,000円",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 1319,
        "shikenId": 20,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "会社員の村井さんは、2027年３月に勤務先を退職する予定である。村井さんの退職に係るデータが下記＜資料＞のとおりである場合、村井さんの退職一時金に係る所得税額の金額として正しいものはどれか。なお、村井さんは、「退職所得の受給に関する申告書」を適正に提出し、勤務先の役員であったことはなく、退職は障害者になったことに基因するものではないものとする。<br>また、解答に当たっては、所得控除および復興特別所得税については考慮しないこととする。<br><img src=\"/img/question/20_19_1780886476678729_21.png\" class=\"question-img\" /><br><br>1）2,292,000円<br>2）2,061,000円<br>3）732,500円<br>4）662,500円",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 1320,
        "shikenId": 20,
        "parentNo": 2,
        "no": 20,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "五藤さん（68歳）の2026年分の収入および経費は以下のとおりである。五藤さんの2026年分の所得税における総所得金額を計算しなさい。なお、青色申告特別控除額は10万円であるものとする。<br><img src=\"/img/question/20_20_1780886477613427_22.png\" class=\"question-img\" /><br>※五藤さんは、駐車場経営を始めた2020年から青色申告者となっており、帳簿書類の備え付け等の要件は満たしている。なお、この駐車場経営については、その収入は不動産所得に該当するが、事業的規模に該当しない。<br><img src=\"/img/question/20_20_1780886478193662_23.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "68",
        "score": "2",
        "image": ""
    },
    {
        "id": 1321,
        "shikenId": 20,
        "parentNo": 2,
        "no": 21,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "以下の資料は、Ａさん～Ｄさんの2026年の所得である。それぞれの総所得金額として適切なものは○、不適切なものは×を選択しなさい。▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><img src=\"/img/question/20_21_1780886478778165_24.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1322,
        "shikenId": 20,
        "parentNo": 2,
        "no": 22,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "長野さん夫妻は、2026年10月にマイホームとして販売価格4,600万円（うち消費税160万円）のマンションを購入する予定である。長野さん夫妻がマンションを購入する場合の販売価格のうち、土地（敷地の共有持分）の価格を計算しなさい。なお、消費税の税率は10％とし、計算結果については万円未満の端数が生じる場合は四捨五入すること。",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2840",
        "score": "2",
        "image": ""
    },
    {
        "id": 1323,
        "shikenId": 20,
        "parentNo": 2,
        "no": 23,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "山下郁実さん（57歳）は、2026年６月に夫から居住用不動産（財産評価額2,990万円）の贈与を受けた。郁実さんが贈与税の配偶者控除の適用を受けた場合の2026年分の贈与税額はいくらになるか。なお、2026年においては、このほかに郁実さんが受けた贈与はないものとする。また、納付すべき贈与税額が最も少なくなるように計算することとする。<br><img src=\"/img/question/20_23_1780886479726570_25.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "227",
        "score": "2",
        "image": ""
    },
    {
        "id": 1324,
        "shikenId": 20,
        "parentNo": 2,
        "no": 24,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "下記＜親族関係図＞の場合において、民法の規定に基づく法定相続分等に関する次の記述の空欄（ア）～（エ）に入る語句として適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/20_24_1780886480807251_26.png\" class=\"question-img\" /><br><img src=\"/img/question/20_24_1780886481376569_27.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は「１／８」である。<br>（イ）空欄（イ）にあてはまる語句は「なし」である。<br>（ウ）空欄（ウ）にあてはまる語句は「１／16」である。<br>（エ）空欄（エ）にあてはまる語句は「ならない」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1325,
        "shikenId": 20,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "木村加奈子さんが現時点（2026年６月１日）で死亡した場合、加奈子さんの相続に係る相続税の総額として、正しいものはどれか。なお、相続税の課税価格の合計額は２億1,000万円であるものとし、計算に当たっては、下記＜計算過程＞に従って計算すること。また、相続を放棄した者はいないものとする。<br><img src=\"/img/question/20_25_1780886481955532_28.png\" class=\"question-img\" /><br>＜計算過程＞<br>① 相続税の課税価格の合計額から基礎控除額を差し引き、課税遺産総額を算出<br>② 課税遺産総額を各法定相続人が民法の規定に基づく法定相続分に応じて取得したものとして、各法定相続人の取得金額を計算<br>③ 各法定相続人の取得金額に対して＜相続税の速算表＞を適用し、税額を算出<br>④ 上記③で算出された税額を合計し、相続税の総額を算出<br><img src=\"/img/question/20_25_1780886482621967_29.png\" class=\"question-img\" /><br><br>1）1,980万円<br>2）2,400万円<br>3）2,660万円<br>4）3,540万円",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1326,
        "shikenId": 20,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記＜資料＞の宅地（貸家建付地）に係る路線価方式による相続税評価額として、正しいものはどれか。<br><img src=\"/img/question/20_26_1780886483145161_30.png\" class=\"question-img\" /><br><br>1）5,400万円<br>2）4,266万円<br>3）3,780万円<br>4）1,620万円",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 1327,
        "shikenId": 20,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "相続税における「小規模宅地等の評価減の特例」に関する下表の空欄（ア）～（エ）に入る適切な語句または数値の組み合わせとして、正しいものはどれか。<br><img src=\"/img/question/20_27_1780886483803252_31.png\" class=\"question-img\" /><br>※特定事業用宅地等と貸付事業用宅地等については、一定の場合に該当しない限り、相続開始前（ エ ）以内に新たに（貸付）事業の用に供された宅地等を除く。<br><br>1）（ア）280  （イ）60  （ウ）200  （エ）１年<br>2）（ア）280  （イ）80  （ウ）240  （エ）１年<br>3）（ア）400  （イ）60  （ウ）240  （エ）３年<br>4）（ア）400  （イ）80  （ウ）200  （エ）３年",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1328,
        "shikenId": 20,
        "parentNo": 2,
        "no": 28,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "星家のキャッシュフロー表の空欄（ア）に入る数値を計算しなさい。なお、計算過程においては、端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img src=\"/img/question/20_28_1780886484340202_32.png\" class=\"question-img\" /><br>※年齢および金融資産残高は各年12月31日現在のものとし、2026年を基準年とする。<br>※給与収入は可処分所得で記載している。<br>※記載されている数値は正しいものとする。<br>※問題作成の都合上、一部を空欄としている。",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "446",
        "score": "1",
        "image": ""
    },
    {
        "id": 1329,
        "shikenId": 20,
        "parentNo": 2,
        "no": 29,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "星家のキャッシュフロー表の空欄（イ）に入る数値を計算しなさい。なお、計算過程においては、端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img src=\"/img/question/20_29_1780886485205787_33.png\" class=\"question-img\" /><br>※年齢および金融資産残高は各年12月31日現在のものとし、2026年を基準年とする。<br>※給与収入は可処分所得で記載している。<br>※記載されている数値は正しいものとする。<br>※問題作成の都合上、一部を空欄としている。",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "3069",
        "score": "1",
        "image": ""
    },
    {
        "id": 1330,
        "shikenId": 20,
        "parentNo": 2,
        "no": 30,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "日本学生支援機構の奨学金（貸与型）および日本政策金融公庫の教育一般貸付（国の教育ローン）に関する＜資料＞の空欄（ア）～（エ）にあてはまる語句として適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/20_30_1780886486129217_34.png\" class=\"question-img\" /><br>※日本学生支援機構の奨学金（貸与型）の第一種奨学金と第二種奨学金を併用することは（ ウ ）。<br>※日本学生支援機構の奨学金（貸与型）と日本政策金融公庫の教育一般貸付を併用することは（ エ ）。<br><br>（ア）空欄（ア）にあてはまる語句は「学生・生徒本人」である。<br>（イ）空欄（イ）にあてはまる語句は「できる」である。<br>（ウ）空欄（ウ）にあてはまる語句は「できない」である。<br>（エ）空欄（エ）にあてはまる語句は「できない」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1331,
        "shikenId": 20,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "山田さんは、相続により受け取った300万円を運用しようと考えている。これを10年間、年利1.0％で複利運用した場合、10年後の合計額はいくらになるか。なお、税金は一切考慮しないこととする。<br><img src=\"/img/question/20_31_1780886486967932_35.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "3315000",
        "score": "1",
        "image": ""
    },
    {
        "id": 1332,
        "shikenId": 20,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "長岡さんは、老後の生活資金の一部として、毎年年末に300万円を受け取りたいと考えている。<br>受取期間を10年間とし、年利1.0％で複利運用する場合、受取り開始時にいくらの資金があればよいか。<br><img src=\"/img/question/20_32_1780886487829722_36.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "28413000",
        "score": "1",
        "image": ""
    },
    {
        "id": 1333,
        "shikenId": 20,
        "parentNo": 1,
        "no": 33,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "城山さんは、住宅ローンの見直しについてＦＰの内野さんに質問をした。一般的な住宅ローンの見直しに関する内野さんの次の説明のうち、最も不適切なものはどれか。<br><br>1）「より有利な条件の住宅ローンを扱う金融機関に住宅ローンの『借換え』をする場合、抵当権の抹消や設定費用、事務手数料などの諸費用が必要になります。」<br>2）「通常の返済とは別にローンの元金部分の一部を返済する『繰上げ返済』をした場合、その元金に対応する利息部分の支払いがなくなり、総返済額を減らす効果があります。」<br>3）「現在の住宅ローンの借入先の金融機関において、返済期間を延長することで月々の返済額を減額したり、一定期間、月々の返済額を利息の支払いのみにする『条件変更』ができる場合もあります。」<br>4）「固定金利選択型10年で借り入れている場合、現在の固定期間が終了した後は固定金利選択型10年で自動更新され、他の固定金利選択型や変動金利型を選択することはできません。」",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 1334,
        "shikenId": 20,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/20_34_1780886489961018_37.png\" class=\"question-img\" /><br><br>ＦＰの秋田さんは、現時点（2026年４月１日時点）における池本家（幸弘さんと千鶴さん）のバランスシート分析を行うこととした。下表の空欄（ア）に入る数値を計算しなさい。<img src=\"/img/question/20_34_1780886491502356_38.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "6120",
        "score": "2",
        "image": ""
    },
    {
        "id": 1335,
        "shikenId": 20,
        "parentNo": 1,
        "no": 35,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "鷲宮さんは、現在居住している自宅の住宅ローン（全期間固定金利、返済期間35年、元利均等返済、ボーナス返済なし）の繰上げ返済を検討している。鷲宮さんが住宅ローンを120回返済後に、100万円以内で期間短縮型の繰上げ返済をする場合、この繰上げ返済により軽減される返済期間として、正しいものはどれか。なお、計算に当たっては、下記＜資料＞を使用し、繰上げ返済額は100万円を超えない範囲での最大額とすること。また、繰上げ返済に伴う手数料等は考慮しないものとする。<br><img src=\"/img/question/20_35_1780886492252392_39.png\" class=\"question-img\" /><br><br>1）９ヵ月<br>2）１年３ヵ月<br>3）１年４ヵ月<br>4）１年５ヵ月",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 1336,
        "shikenId": 20,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "国内の企業に勤務する梶森文恵（48歳）さんは、2026年４月２日に死亡した会社員の夫（史郎さん）の相続に関することや今後の生活のことなどについて、ＦＰで社会保険労務士でもある松田さんに相談をした。<br>文恵さんの老齢年金の受給について、松田さんの次の説明の空欄（ア）～（ウ）に入る語句として、適切なものは○、不適切なものは×を選択しなさい。なお、文恵さんは、夫の史郎さんの死亡に基づく遺族年金の受給権者であり、また、老齢基礎年金および老齢厚生年金の受給資格期間を満たしているものとする。<br><img src=\"/img/question/20_36_1780886493812675_40.png\" class=\"question-img\" /><br><img src=\"/img/question/20_36_1780886494251212_41.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は「65歳」である。<br>（イ）空欄（イ）にあてはまる語句は「老齢基礎年金に限り」である。<br>（ウ）空欄（ウ）にあてはまる語句は「厚生年金保険の被保険者または70歳以上被用者」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": ""
    },
    {
        "id": 1337,
        "shikenId": 20,
        "parentNo": 2,
        "no": 37,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "国内の企業に勤務する飯島正平さん（50歳）は、自分の老齢年金の受取り方について考えている。正平さんの老齢年金の受給に関する次の（ア）～（エ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><br>（ア）老齢基礎年金または老齢厚生年金の支給の繰下げによる年金額の増額率は、最大で30％となる。<br>（イ）正平さんは、将来の年金を増やす方法として、付加保険料を納付することができる。<br>（ウ）老齢基礎年金と老齢厚生年金の繰上げ請求は、異なる時期に別々に行うことができない。<br>（エ）老齢基礎年金と老齢厚生年金の繰下げ請求は、異なる時期に別々に行うことができない。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1338,
        "shikenId": 20,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "個人型確定拠出年金（ｉＤｅＣｏ）に関する次の記述のうち、最も適切なものはどれか。<br><br>1）老齢給付金を60歳から受給するためには、60歳に達した時点で通算加入者等期間が20年以上なければならない。<br>2）加入者が支払った掛金は、その全額が社会保険料控除として、所得控除の対象となる。<br>3）勤務先において企業型確定拠出年金が導入されており、加入者掛金の拠出（マッチング拠出）を行っている場合は、個人型確定拠出年金（ｉＤｅＣｏ）に加入できない。<br>4）一時金として受け取った老齢給付金は、一時所得となり、老齢給付金の額から特別控除額（最高50万円）を控除することができる。",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 1339,
        "shikenId": 20,
        "parentNo": 2,
        "no": 39,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "労働者災害補償保険（以下「労災保険」という）の概要に関する次の（ア）～（エ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><br>（ア）労災保険における保険料率は、業種にかかわらず一律である。<br>（イ）労働者が業務上の災害により労災指定病院等において療養を受けた場合は、その費用の１割を労働者が負担し、残る部分が療養補償給付となる。<br>（ウ）労災保険が適用される労働者には、在宅勤務労働者も含まれる。<br>（エ）労災保険の保険料は、事業者と労働者が折半して負担する。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 1340,
        "shikenId": 20,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "会社員の増田さんは、自らのスキルアップを図るため2026年８月に34歳で会社を自己都合退職し、再就職までの間、雇用保険の基本手当を受給することを考えている。雇用保険の基本手当に関する次の（ア）～（エ）に入る語句として、適切なものは○、不適切なものは×を選択しなさい。<br>なお、増田さんは、現在の会社に22歳で就職した以後、継続して雇用保険に加入しており、雇用保険の基本手当の受給要件はすべて満たしているものとする。また、増田さんには、この他に雇用保険の加入期間はなく、障害者等の就職困難者には該当しないものとし、延長給付については考慮しないものとする。<br><img src=\"/img/question/20_40_1780886495176309_42.png\" class=\"question-img\" /><br><img src=\"/img/question/20_40_1780886495797615_43.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は、「離職の日の翌日から１年間」である。<br>（イ）空欄（イ）にあてはまる語句は、「210日」である。<br>（ウ）空欄（ウ）にあてはまる語句は、「７日間」である。<br>（エ）空欄（エ）にあてはまる語句は、「２週間」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 10001,
        "shikenId": 2,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "司法書士資格を有しないファイナンシャル・プランナーが、顧客本人の求めに応じ、その顧客の任意後見受任者となることは、司法書士法に抵触しない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10002,
        "shikenId": 2,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "確定拠出年金（個人型）の老齢給付金を一時金で受け取った場合、雑所得として所得税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10003,
        "shikenId": 2,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "雇用保険の基本手当を受給するためには、倒産、解雇、雇止めなどの場合を除き、原則として、離職の日以前２年間に被保険者期間が通算して12ヵ月以上あることなどの要件を満たす必要がある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10004,
        "shikenId": 2,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "住宅金融支援機構と民間金融機関が提携した住宅ローンであるフラット35（買取型）の融資金利は固定金利であり、融資実行時点の金利が適用される。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10005,
        "shikenId": 2,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "70歳未満の厚生年金保険の被保険者に支給される老齢厚生年金は、その者の総報酬月額相当額と基本月額の合計額が40万円を超える場合、年金額の一部または全部が支給停止となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10006,
        "shikenId": 2,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "収入保障保険の死亡保険金を一時金で受け取る場合の受取額は、一般に、年金形式で受け取る場合の受取総額よりも少なくなる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10007,
        "shikenId": 2,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "定期保険特約付終身保険では、定期保険特約の保険金額を同額で自動更新すると、更新後の保険料は、通常、更新前よりも高くなる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10008,
        "shikenId": 2,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "学資保険には、出生前加入特則を付加することにより、被保険者となる子が出生する前から保険に加入することができるものがある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10009,
        "shikenId": 2,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "リビング・ニーズ特約は、被保険者の余命が１年以内と判断された場合に、所定の範囲内で死亡保険金の一部または全部を生前に受け取ることができる特約である。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10010,
        "shikenId": 2,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "国内で事業を行う少額短期保険業者と締結した保険契約は、生命保険契約者保護機構および損害保険契約者保護機構による補償の対象とならない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10011,
        "shikenId": 2,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "マネーストック統計とは、個人、一般法人、地方公共団体などの通貨保有主体が保有する通貨量の残高を集計したものである。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10012,
        "shikenId": 2,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "外貨建て金融商品の取引にかかる為替手数料は、取扱金融機関によって異なることがある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10013,
        "shikenId": 2,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "債券の信用格付とは、債券やその発行体の信用評価を記号等で示したものであり、一般に、ＢＢ（ダブルビー）格相当以下の格付けが付された債券は、投資不適格債とされる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10014,
        "shikenId": 2,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "ゆうちょ銀行においては、通常貯金と定期性貯金を合わせて１人2,600万円が預入限度額となっている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10015,
        "shikenId": 2,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "消費者契約法において、消費者が事業者の一定の行為により誤認または困惑し、それによって消費者契約の申込みまたは承諾の意思表示をしたときは、消費者はこれを取り消すことができるとされている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10016,
        "shikenId": 2,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "給与所得者のうち、その年中に支払を受けるべき給与の収入金額が2,000万円を超える者は、所得税の確定申告をする必要がある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10017,
        "shikenId": 2,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "所得税法における居住者（非永住者を除く）は、原則として、国内で生じた所得についてのみ所得税の納税義務が生じる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10018,
        "shikenId": 2,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "電車・バス等の交通機関を利用して通勤している給与所得者が、勤務先から受ける通勤手当は、所得税法上、月額15万円を限度に非課税とされる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10019,
        "shikenId": 2,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "公的年金等に係る雑所得の金額は、「その年の公的年金等に係る収入金額－公的年金等控除額－50万円」の算式により計算される。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10020,
        "shikenId": 2,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "「ふるさと納税ワンストップ特例制度」の適用を受けるためには、適用を受けようとする年の寄附金の合計額が10万円以下でなければならない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10021,
        "shikenId": 2,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "借地借家法の規定によれば、借地権は、その登記がない場合でも、土地の上に借地権者が登記されている建物を所有するときは、これをもって第三者に対して土地の賃借権を対抗することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10022,
        "shikenId": 2,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "不動産の売買契約において、買主が売主に解約手付を交付した場合、相手方が契約の履行に着手するまでは、買主はその手付を放棄することで、売主は受領した手付と同額を買主に提供することで、それぞれ契約を解除することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10023,
        "shikenId": 2,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "相続により不動産を取得した場合、不動産取得税は課されない。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10024,
        "shikenId": 2,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "土地の売買において、所有権の移転が発生したものの、手続上の要件が備わっていない場合などに、仮登記をすることができるが、この仮登記をすることで、その後に行う本登記の順位は保全され、所有権の移転を第三者に対抗することができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10025,
        "shikenId": 2,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "借地借家法の規定では、定期建物賃貸借契約（定期借家権）を締結する場合においては、存続期間を１年以上としなければならないとされている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10026,
        "shikenId": 2,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "特別養子縁組が成立した場合、養子となった者と実方の父母との法律上の親族関係は終了する。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10027,
        "shikenId": 2,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "成年後見制度には法定後見制度と任意後見制度があり、任意後見制度には本人の判断能力の程度などに応じて「後見」「保佐」「補助」の３つがある。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10028,
        "shikenId": 2,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "父が所有する土地を子が無償で借り受け、その土地の上に建物を建築した場合、父から子へ借地権の贈与があったものとして、贈与税の課税対象となる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10029,
        "shikenId": 2,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "民法において、被相続人の非嫡出子の法定相続分は、嫡出子の２分の１とされている。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10030,
        "shikenId": 2,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章を読んで、正しいものまたは適切なものには○を、誤っているものまたは不適切なものには✕をつけなさい。",
        "question2": "口頭による贈与契約は、その履行前であれば、各当事者は契約の解除をすることができる。",
        "choice1": "○",
        "choice2": "✕",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10031,
        "shikenId": 2,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "後期高齢者医療広域連合の区域内に住所を有する（   ）歳以上の者は、原則として、後期高齢者医療制度の被保険者となる。",
        "choice1": "1）65歳",
        "choice2": "2）70歳",
        "choice3": "3）75歳",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10032,
        "shikenId": 2,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "元金1,000,000円を年率２％で複利運用しながら20年間にわたって毎年均等に取り崩して受け取る場合、毎年の受取金額は、下記の＜資料＞の係数を使用して算出すると、（   ）である。<br><br><img src='/img/2_32_1781051033332987_1.png'>",
        "choice1": "1）14,840円",
        "choice2": "2）61,160円",
        "choice3": "3）82,640円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10033,
        "shikenId": 2,
        "parentNo": 2,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "独立行政法人日本学生支援機構が取り扱う奨学金（貸与型）には、（ ① ）の第一種奨学金と（ ② ）の第二種奨学金がある。",
        "choice1": "1）① 無利息   ② 利息付",
        "choice2": "2）① 利息付   ② 無利息",
        "choice3": "3）① 返済不要  ② 無利息",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10034,
        "shikenId": 2,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "雇用保険の教育訓練給付金のうち、一般教育訓練に係る教育訓練給付金の額は、教育訓練施設に支払った教育訓練費の（ ① ）相当額であるが、その額が（ ② ）を超える場合の支給額は、（ ② ）となる。",
        "choice1": "1）① 10％  ② ５万円",
        "choice2": "2）① 20％  ② 10万円",
        "choice3": "3）① 30％  ② 15万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10035,
        "shikenId": 2,
        "parentNo": 2,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税の計算において、国民年金基金の掛金は、（   ）として所得控除の対象となる。",
        "choice1": "1）小規模企業共済等掛金控除",
        "choice2": "2）生命保険料控除",
        "choice3": "3）社会保険料控除",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10036,
        "shikenId": 2,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "経済価値ベースのソルベンシー比率は、保険会社が保険金等の支払余力をどの程度有するかを示す指標であり、この値が（   ）を下回った場合、監督当局による早期是正措置の対象となる。",
        "choice1": "1）50％",
        "choice2": "2）100％",
        "choice3": "3）200％",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10037,
        "shikenId": 2,
        "parentNo": 2,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "がん保険では、一般に、責任開始日前に約（   ）の免責期間が設けられており、その期間中にがんと診断されたとしても、がん診断給付金は支払われない。",
        "choice1": "1）１ヵ月",
        "choice2": "2）３ヵ月",
        "choice3": "3）６ヵ月",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10038,
        "shikenId": 2,
        "parentNo": 2,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "ホテルを運営する企業が、クロークで預かる顧客の荷物の紛失・盗難リスクの補償に備えるために、（   ）に加入した。",
        "choice1": "1）受託者賠償責任保険",
        "choice2": "2）施設所有者賠償責任保険",
        "choice3": "3）生産物賠償責任保険",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10039,
        "shikenId": 2,
        "parentNo": 2,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "民法および失火の責任に関する法律（失火責任法）において、借家人が軽過失により火事を起こし、借家と隣家を焼失させた場合、借家の家主に対して損害賠償責任を（ ① ）。また、隣家の所有者に対して損害賠償責任を（ ② ）。",
        "choice1": "1）① 負う    ② 負わない",
        "choice2": "2）① 負う    ② 負う",
        "choice3": "3）① 負わない  ② 負う",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10040,
        "shikenId": 2,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、個人が支払う地震保険の保険料に係る地震保険料控除は、原則として、（ ① ）を限度として年間支払保険料の（ ② ）が控除額となる。",
        "choice1": "1）① ５万円  ② ２分の１相当額",
        "choice2": "2）① ５万円  ② 全額",
        "choice3": "3）① 10万円  ② 全額",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10041,
        "shikenId": 2,
        "parentNo": 2,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "個人向け国債（2027年１月発行分からは個人向け国債プラス）は、変動金利の商品である（ ① ）、固定金利の商品である（ ② ）の３種類がある。",
        "choice1": "1）① 変動３年・変動５年 ② 固定１年",
        "choice2": "2）① 変動５年 ② 固定１年・固定３年",
        "choice3": "3）① 変動10年 ② 固定３年・固定５年",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10042,
        "shikenId": 2,
        "parentNo": 2,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "ベンチマークとなる指数の（ ① ）局面において、先物やオプションを利用し、（ ① ）幅の２倍、３倍の投資成果を目指すファンドは、（ ② ）に分類される。",
        "choice1": "1）① 下落  ② ベア型ファンド",
        "choice2": "2）① 下落  ② ブル型ファンド",
        "choice3": "3）① 上昇  ② ベア型ファンド",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10043,
        "shikenId": 2,
        "parentNo": 2,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "外貨預金の預入時に、預金者が円貨を外貨に換える際に適用される為替レートは（ ① ）であり、払戻し時において、預金者が外貨を円貨に換える際に適用される為替レートは（ ② ）である。",
        "choice1": "1）① ＴＴＢ  ② ＴＴＳ",
        "choice2": "2）① ＴＴＭ  ② ＴＴＳ",
        "choice3": "3）① ＴＴＳ  ② ＴＴＢ",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10044,
        "shikenId": 2,
        "parentNo": 2,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "株式投資信託の投資手法のうち、マクロ経済の動向を分析して投資対象とする銘柄を選定する手法を（ ① ）といい、個別銘柄の投資指標の分析や企業業績などのリサーチによって投資対象とする銘柄を選定する手法を（ ② ）という。",
        "choice1": "1）① インデックス・アプローチ  ② アクティブ・アプローチ",
        "choice2": "2）① トップダウン・アプローチ  ② ボトムアップ・アプローチ",
        "choice3": "3）① グロース・アプローチ    ② バリュー・アプローチ",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10045,
        "shikenId": 2,
        "parentNo": 2,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "元金2,000,000円を、年利３％（１年複利）で３年間運用した場合の元利合計金額は、税金や手数料等を考慮しない場合、（   ）である。",
        "choice1": "1）2,083,654円",
        "choice2": "2）2,121,800円",
        "choice3": "3）2,185,454円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10046,
        "shikenId": 2,
        "parentNo": 2,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、控除対象扶養親族のうち、その年の12月31日時点の年齢が（ ① ）である特定扶養親族に係る扶養控除の額は、扶養親族１人につき（ ② ）となる。",
        "choice1": "1）① 16歳以上22歳未満  ② 63万円",
        "choice2": "2）① 19歳以上23歳未満  ② 63万円",
        "choice3": "3）① 19歳以上23歳未満  ② 58万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10047,
        "shikenId": 2,
        "parentNo": 2,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、（   ）は医療費控除の対象とならない。",
        "choice1": "1）治療のための入院中の食事代",
        "choice2": "2）薬局で購入した風邪薬の購入費用",
        "choice3": "3）コンタクトレンズや近視、乱視によるメガネの購入費用",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10048,
        "shikenId": 2,
        "parentNo": 2,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、上場株式の配当について配当控除の適用を受けるためには、その配当所得について（ ① ）を選択する必要があり、その年分の課税総所得金額等が1,000万円以下の場合、配当所得の金額に（ ② ）を乗じた金額を、その年分の所得税額から控除することができる。",
        "choice1": "1）① 総合課税    ② 10％",
        "choice2": "2）① 申告分離課税  ② 15％",
        "choice3": "3）① 源泉分離課税  ② 20.315％",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10049,
        "shikenId": 2,
        "parentNo": 2,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税の計算において、青色申告書を提出した年に生じた純損失の金額は、所定の要件のもと、その損失が生じた年の翌年以降（   ）繰り越すことができる。",
        "choice1": "1）２年間",
        "choice2": "2）３年間",
        "choice3": "3）４年間",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10050,
        "shikenId": 2,
        "parentNo": 2,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "所得税において、（   ）の金額の計算上生じた損失の金額は、一定の場合を除き、他の所得の金額と損益通算することができる。",
        "choice1": "1）不動産所得・事業所得・山林所得・一時所得",
        "choice2": "2）不動産所得・一時所得・雑所得・譲渡所得",
        "choice3": "3）不動産所得・事業所得・山林所得・譲渡所得",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10051,
        "shikenId": 2,
        "parentNo": 2,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "個人が土地・建物を譲渡したことによる譲渡所得の金額の計算において、譲渡した土地・建物の取得費が不明である場合には、譲渡収入金額の（   ）相当額を取得費とすることができる。",
        "choice1": "1）５％",
        "choice2": "2）15％",
        "choice3": "3）20％",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10052,
        "shikenId": 2,
        "parentNo": 2,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "固定資産税における小規模宅地（住宅用地で住宅１戸につき200㎡以下の部分）の課税標準については、当該住宅用地に係る固定資産税の課税標準となるべき価格の（   ）の額とする特例がある。",
        "choice1": "1）２分の１",
        "choice2": "2）３分の１",
        "choice3": "3）６分の１",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10053,
        "shikenId": 2,
        "parentNo": 2,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "都市計画区域内にある幅員４ｍ未満の道で、建築基準法第42条第２項により道路とみなされるものについては、原則として、その道路の中心線から水平距離で（ ① ）後退した線が道路の境界線とみなされ、当該部分は、建蔽率や容積率を算定する際の敷地面積に（ ② ）。",
        "choice1": "1）① 1.5ｍ  ② 算入することができる",
        "choice2": "2）① ２ｍ   ② 算入することができる",
        "choice3": "3）① ２ｍ   ② 算入することができない",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10054,
        "shikenId": 2,
        "parentNo": 2,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "「特定居住用財産の譲渡損失の損益通算及び繰越控除の特例」の適用を受けた場合、損益通算を行っても控除しきれなかった譲渡損失の金額は、譲渡した年の翌年以降（   ）にわたり繰り越して控除を受けることができる。",
        "choice1": "1）１年間",
        "choice2": "2）３年間",
        "choice3": "3）５年間",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10055,
        "shikenId": 2,
        "parentNo": 2,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "農地法によれば、農地を宅地に転用する場合、原則として、都道府県知事等の許可を受けなければならないが、市街化区域内の一定の農地を宅地に転用する場合については、あらかじめ（   ）へ届出を提出すれば、都道府県知事等の許可を受ける必要はない。",
        "choice1": "1）農業委員会",
        "choice2": "2）市区町村長",
        "choice3": "3）国土交通大臣",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 10056,
        "shikenId": 2,
        "parentNo": 2,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "被相続人の業務上の死亡により、相続人が被相続人の雇用主から受け取った弔慰金は、被相続人の死亡時における普通給与の（   ）に相当する金額までは、相続税の課税対象とならない。",
        "choice1": "1）１ヵ月分",
        "choice2": "2）６ヵ月分",
        "choice3": "3）３年分",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10057,
        "shikenId": 2,
        "parentNo": 2,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "遺留分を有する相続人の遺留分に係る侵害額請求権は、当該遺留分権利者が相続の開始および遺留分を侵害する贈与または遺贈があったことを知った時から（ ① ）、または相続開始の時から（ ② ）を経過した時に時効により消滅する。",
        "choice1": "1）① ３ヵ月  ② １年",
        "choice2": "2）① １年   ② 10年",
        "choice3": "3）① ３年   ② ５年",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10058,
        "shikenId": 2,
        "parentNo": 2,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "遺産分割において、共同相続人の１人または数人が、相続により遺産の一部または全部を取得し、その者が他の相続人に対して生じた債務を金銭などの財産で負担する方法を（   ）という。",
        "choice1": "1）換価分割",
        "choice2": "2）代償分割",
        "choice3": "3）現物分割",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10059,
        "shikenId": 2,
        "parentNo": 2,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "相続人が相続の放棄をする場合、自己のために相続の開始があったことを知った時から（ ① ）以内に、（ ② ）で家庭裁判所に申述しなければならない。",
        "choice1": "1）① １ヵ月  ② 相続人全員",
        "choice2": "2）① ３ヵ月  ② １人または数人",
        "choice3": "3）① ６ヵ月  ② 相続人全員",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 10060,
        "shikenId": 2,
        "parentNo": 2,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "次の文章の（　　）内にあてはまる最も適切な文章、語句、数字またはそれらの組合せを１）〜３）のなかから選びなさい。",
        "question2": "公正証書遺言は、作成にあたり証人の立会が（ ① ）であり、遺言者の相続開始時に家庭裁判所における検認手続が（ ② ）である。",
        "choice1": "1）① 必要  ② 必要",
        "choice2": "2）① 不要  ② 必要",
        "choice3": "3）① 必要  ② 不要",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 10061,
        "shikenId": 2,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんが現時点（2026年９月11日）において死亡した場合、妻Ｂさんが受給することができる遺族基礎年金の年金額（2026年度価額）を試算した。Ｍさんが試算した遺族基礎年金の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "847,300円＋81,300円＋81,300円＝1,009,900円",
        "choice2": "847,300円＋243,800円＋81,300円＝1,172,400円",
        "choice3": "847,300円＋243,800円＋243,800円＝1,334,900円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3q-kojin-b-1.png"
    },
    {
        "id": 10062,
        "shikenId": 2,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんが現時点（2026年９月11日）において死亡した場合に、妻Ｂさんに支給される遺族厚生年金の金額等について説明した。ＭさんのＡさんに対する説明として、次のうち最も不適切なものはどれか。",
        "choice1": "「遺族厚生年金の額は、原則として、Ａさんの厚生年金保険の被保険者記録を基礎として計算した老齢厚生年金の報酬比例部分の額の４分の３相当額となります」",
        "choice2": "「Ａさんの場合、遺族厚生年金の計算の基礎となる被保険者期間の月数が240月に満たないため、240月とみなして年金額が計算されます」",
        "choice3": "「二男Ｄさんが18歳に到達し、その年度の末日が終了したことで妻Ｂさんの有する遺族基礎年金の受給権が消滅したときは、妻Ｂさんが65歳に達するまでの間、妻Ｂさんに支給される遺族厚生年金に中高齢寡婦加算が加算されます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-kojin-b-1.png"
    },
    {
        "id": 10063,
        "shikenId": 2,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "最後に、Ｍさんは、公的介護保険（以下、「介護保険」という）について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「介護保険の被保険者が保険給付を受けるためには、都道府県から要介護・要支援認定を受ける必要があります。介護保険の被保険者は、65歳以上の第１号被保険者と40歳以上65歳未満の医療保険加入者である第２号被保険者に区分されます」",
        "choice2": "「介護保険の第２号被保険者は、要介護状態または要支援状態となった原因を問わず、保険給付を受けることができます」",
        "choice3": "「介護保険の第２号被保険者が介護給付を受けた場合、原則として、実際にかかった費用（食費、居住費等を除く）の１割を自己負担する必要があります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-kojin-b-1.png"
    },
    {
        "id": 10064,
        "shikenId": 2,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ｍさんは、Ｘ社株式の投資指標について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「株価の相対的な割高・割安の度合いを判断する指標に、ＰＥＲやＰＢＲがあります。〈Ｘ社に関する資料〉から算出されるＸ社株式のＰＥＲは0.6倍、ＰＢＲは６倍です」",
        "choice2": "「〈Ｘ社に関する資料〉から算出されるＸ社のＲＯＥは３％です。一般に、ＲＯＥが高い会社ほど、自己資本の効率的な活用がなされていると判断されます」",
        "choice3": "「Ｘ社の配当性向は30％です。一般に、配当性向が高いほど、株主への利益還元の度合いが高いと判断できます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3q-kojin-b-2.png"
    },
    {
        "id": 10065,
        "shikenId": 2,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ｍさんは、ＮＩＳＡを利用した投資について説明した。ＭさんのＡさんに対する説明として、<br>次のうち最も適切なものはどれか。",
        "choice1": "「ＮＩＳＡのつみたて投資枠における年間の非課税投資枠は40万円です。購入は累積投資契約に基づく定期かつ継続的な買付けを行う方法に限られており、非課税期間は10年間です」",
        "choice2": "「ＮＩＳＡのつみたて投資枠の対象となる金融商品は、長期の積立・分散投資に適した一定の商品性を有する公募株式投資信託やＥＴＦとされ、上場株式は対象となっていません」",
        "choice3": "「ＮＩＳＡを利用して購入した公募株式投資信託を解約した際に損失が生じた場合、その損失の金額は、特定口座で保有する上場株式等の譲渡益と通算することができます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-kojin-b-2.png"
    },
    {
        "id": 10066,
        "shikenId": 2,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ｙ社債を《設例》の条件で購入した場合の最終利回り（年率・単利）は、次のうちどれか。なお、計算にあたっては税金等を考慮せず、答は％表示における小数点以下第３位を四捨五入している。",
        "choice1": "0.44％",
        "choice2": "1.01％",
        "choice3": "1.95％",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-kojin-b-2.png"
    },
    {
        "id": 10067,
        "shikenId": 2,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における総所得金額は、次のうちどれか。<br><img src=\"/img/question/2_7_1781050748295471_1.png\" class=\"question-img\" />",
        "choice1": "536万円",
        "choice2": "561万円",
        "choice3": "611万円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "3q-kojin-b-3.png"
    },
    {
        "id": 10068,
        "shikenId": 2,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における所得控除に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「妻Ｂさんの合計所得金額が62万円以下であるため、Ａさんは妻Ｂさんに係る配偶者控除の適用を受けることができます」",
        "choice2": "「Ａさんが適用を受けることができる長女Ｃさんに係る扶養控除の額は、38万円です」",
        "choice3": "「長男Ｄさんは、特定扶養親族に該当するため、Ａさんは、長男Ｄさんについて58万円の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-kojin-b-3.png"
    },
    {
        "id": 10069,
        "shikenId": 2,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における医療費控除および確定申告に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「Ａさんは、2026年中に支払った医療費の領収書を勤務先に提出することで、年末調整において医療費控除の適用を受けることができます」",
        "choice2": "「Ａさんが、妻Ｂさんの通院時に自家用車で送迎していた場合、その際にかかったガソリン代や駐車料金は、医療費控除の対象となる医療費の範囲に含まれます」",
        "choice3": "「生命保険契約から支払われた入院給付金や健康保険から支給を受けた高額療養費がある場合は、支払った医療費の総額からそれらの金額を控除する必要があります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-kojin-b-3.png"
    },
    {
        "id": 10070,
        "shikenId": 2,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "甲土地に賃貸マンション（耐火建築物）を建築する場合の①建蔽率の上限となる建築面積と②容積率の上限となる延べ面積の組合せとして、次のうち最も適切なものはどれか。",
        "choice1": "① 240㎡  ② 960㎡",
        "choice2": "① 280㎡  ② 960㎡",
        "choice3": "① 280㎡  ② 1,200㎡",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-kojin-b-4.png"
    },
    {
        "id": 10071,
        "shikenId": 2,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "自宅（建物およびその敷地である甲土地）の譲渡に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「Ａさんがタワーマンションに転居し、その後、居住していない現在の自宅を譲渡した場合に、Ａさんが『居住用財産を譲渡した場合の3,000万円の特別控除の特例』の適用を受けるためには、家屋に自己が居住しなくなった日から３年を経過する日の属する年の12月31日までの譲渡であること等の要件を満たす必要があります」",
        "choice2": "「Ａさんが甲土地を譲渡し、『居住用財産を譲渡した場合の長期譲渡所得の課税の特例』（軽減税率の特例）の適用を受けた場合、課税長期譲渡所得金額が6,000万円以下の部分については、軽減税率が適用されます」",
        "choice3": "「Ａさんが、購入したタワーマンションをその後譲渡し、新たな住居を購入する場合、譲渡した年の１月１日において譲渡した居住用財産の所有期間が５年を超えていること等の要件を満たせば、『特定の居住用財産の買換えの場合の長期譲渡所得の課税の特例』の適用を受けることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-kojin-b-4.png"
    },
    {
        "id": 10072,
        "shikenId": 2,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "自己建設方式による甲土地の有効活用に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/2_12_1781050748548834_2.png\" class=\"question-img\" />",
        "choice1": "① 貸家建付地  ② 200  ③ 50",
        "choice2": "① 貸家建付地  ② 200  ③ 80",
        "choice3": "① 貸宅地    ② 400  ③ 80",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-kojin-b-4.png"
    },
    {
        "id": 10073,
        "shikenId": 2,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの相続等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「遺言により、妻Ｂさんおよび長女Ｃさんが相続財産の大半を取得した場合、二女Ｄさんおよび長男Ｅさんが遺留分侵害額請求権を行使する可能性があります」",
        "choice2": "「『配偶者に対する相続税額の軽減』の適用を受けた場合、妻Ｂさんが相続により取得した財産の金額が、配偶者の法定相続分相当額と１億円のいずれか多い金額を超えない限り、妻Ｂさんが納付すべき相続税額は生じません」",
        "choice3": "「遺産分割をめぐる争いを防ぐ手段として、遺言書の作成をお勧めします。自筆証書遺言は、遺言者が、その全文、日付および氏名、財産目録のすべてを自書する必要があります」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-kojin-b-5.png"
    },
    {
        "id": 10074,
        "shikenId": 2,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "仮に、Ａさんの相続が現時点（2026年５月23日）で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が２億4,000万円であった場合の相続税の総額は、次のうちどれか。<br><img src=\"/img/question/2_14_1781050748766572_3.png\" class=\"question-img\" />",
        "choice1": "4,400万円",
        "choice2": "4,900万円",
        "choice3": "7,200万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-kojin-b-5.png"
    },
    {
        "id": 10075,
        "shikenId": 2,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 2,
        "question1": "",
        "question2": "Ａさんの相続に係る小規模宅地等についての相続税の課税価格の計算の特例（以下、「本特例」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「妻Ｂさんが自宅の敷地を相続により取得し、特定居住用宅地等として本特例の適用を受けた場合、敷地全体について80％の減額が受けられます」",
        "choice2": "「妻Ｂさんが自宅の敷地を相続により取得し、相続税の申告期限までに自宅の敷地を売却した場合であっても、当該敷地は特定居住用宅地等として本特例の適用を受けることができます」",
        "choice3": "「自宅の敷地と賃貸ビルの敷地について、本特例の適用を受けようとする場合、それぞれの宅地等の適用対象の限度面積まで適用を受けることはできず、適用対象面積の調整が必要です」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-kojin-b-5.png"
    },
    {
        "id": 10076,
        "shikenId": 2,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "はじめに、Ｍさんは、老齢基礎年金について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「老齢基礎年金を受給するためには、原則として、国民年金の保険料納付済期間と保険料免除期間を合算した期間が10年必要です。Ａさんは、10年の受給資格期間を満たしていますので、原則として65歳から老齢基礎年金を受給することができます」",
        "choice2": "「Ａさんが希望すれば、60歳以上65歳未満の間に老齢基礎年金の繰上げ支給を請求することができます。仮に、Ａさんが60歳０ヵ月で老齢基礎年金の繰上げ支給を請求した場合の減額率は42％となります」",
        "choice3": "「Ａさんは老後の年金収入を増やすために、所定の手続により、付加保険料を納付することができます。仮に、Ａさんが付加保険料を60月納付し、65歳から老齢基礎年金を受給する場合、年額24,000円の付加年金を受給することができます」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-hoken-b-1.png"
    },
    {
        "id": 10077,
        "shikenId": 2,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんが老齢基礎年金の受給を65歳から開始した場合の年金額（2026年度価額）を試算した。Ｍさんが試算した老齢基礎年金の年金額の計算式として、次のうち最も適切なものはどれか。",
        "choice1": "<img style='margin-top: -25px;margin-bottom: 30px;' src=\"/img/question/2_2_1781050731991540_1.png\" class=\"question-img\" />",
        "choice2": "<img style='margin-top: -24px;margin-bottom: 80px;' src=\"/img/question/2_2_1781050732114720_2.png\" class=\"question-img\" />",
        "choice3": "<img style='margin-top: -78px;' src=\"/img/question/2_2_1781050732186802_3.png\" class=\"question-img\" />",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "4",
        "image": "3q-hoken-b-1.png"
    },
    {
        "id": 10078,
        "shikenId": 2,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "最後に、Ｍさんは、老後の年金収入を増やすことができる各種制度について説明した。Ｍ<br>さんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「国民年金基金は、国民年金の第１号被保険者を対象とした、老齢基礎年金に上乗せする年<br>金を支給する任意加入の年金制度です。国民年金基金の給付には、老齢年金、遺族一時金およ<br>び障害年金があります」",
        "choice2": "「確定拠出年金の個人型年金は、加入者自身が掛金の運用方法を選択し、資産を形成する年<br>金制度です。将来の年金額は、運用実績により変動しますが、拠出した掛金の合計額を下回る<br>ことはありません」",
        "choice3": "「小規模企業共済制度は、個人事業主が廃業等した場合に必要となる資金を準備しておくた<br>めの制度です。毎月の掛金は、1,000円から70,000円までの範囲内（500円単位）で選択でき、<br>支払った掛金は所得控除の対象となります」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-b-1.png"
    },
    {
        "id": 10079,
        "shikenId": 2,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんが個人事業主となった場合の社会保険の取扱いについて説明した。Ｍさんが、Ａさんに対して説明した以下の文章の空欄①～③に入る数値の組合せとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/2_4_1781050732257860_4.png\" class=\"question-img\" />",
        "choice1": "① 14　　② ２　　③ ３",
        "choice2": "① 20　　② ５　　③ １",
        "choice3": "① 20　　② ２　　③ １",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "4",
        "image": "3q-hoken-b-2.png"
    },
    {
        "id": 10080,
        "shikenId": 2,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんに想定されるリスクについて説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「個人事業主が加入する国民健康保険には、高額療養費制度が設けられています。仮に、Ａさんが病気やケガで医師の診察を受け、同年中に医療機関等に支払った医療費の一部負担金等の合計が自己負担限度額を超えた場合、所定の手続により支払った医療費の全額が高額療養費として支払われます」",
        "choice2": "「個人事業主となったＡさんが生活習慣病等で働けなくなった場合、会社員のときよりも収入が減少するリスクが高くなると思われます。そのため、治療費の準備に加えて、働けなくなった場合の所得補償の準備もご検討ください」",
        "choice3": "「Ａさんのような公的介護保険の第２号被保険者は、要介護状態または要支援状態となった原因を問わず、公的介護保険からの保険給付を受けられます」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-hoken-b-2.png"
    },
    {
        "id": 10081,
        "shikenId": 2,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "最後に、Ｍさんは、生命保険の見直しについてアドバイスした。ＭさんのＡさんに対するアドバイスとして、次のうち最も不適切なものはどれか。",
        "choice1": "「最近では、入院１日目から相応の一時金が支払われるタイプや、退院後の通院治療のために給付金が支払われるタイプの保険（特約）が販売されています。保険会社各社の保障内容をよく比較して、見直しを検討しましょう」",
        "choice2": "「現在加入している定期保険特約付終身保険を見直す方法として、契約転換制度の活用が考えられます。ただし、契約転換時の告知や医師の審査が必要である点に注意が必要です」",
        "choice3": "「Ａさんが加入している生命保険には、リビング・ニーズ特約が付加されていますので、Ａさんが余命１年以内と判断された場合、生前給付金を受け取ることができます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-b-2.png"
    },
    {
        "id": 10082,
        "shikenId": 2,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "仮に、将来Ｘ社がＡさんに役員退職金4,500万円を支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額として、次のうち最も適切なものはどれか。なお、Ａさんの役員在任期間（勤続年数）を37年とし、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。",
        "choice1": "955万円",
        "choice2": "1,255万円",
        "choice3": "2,510万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-hoken-b-3.png"
    },
    {
        "id": 10083,
        "shikenId": 2,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ｍさんは《設例》の終身保険について説明した。ＭさんのＡさんに対する説明として、次のうち最も適切なものはどれか。",
        "choice1": "「Ｘ社が契約者貸付制度を利用し、契約者貸付金を受け取った場合、当該終身保険契約は継続しているため、経理処理は必要ありません」",
        "choice2": "「Ａさんが所定の高度障害状態になった場合、高度障害保険金7,000万円がＸ社に支払われます。その後、Ａさんが死亡した場合には、死亡保険金は支払われません」",
        "choice3": "「Ａさんの勇退時に、契約者をＡさん、死亡保険金受取人をＡさんの相続人に名義変更して、当該終身保険契約を役員退職金の一部として現物支給した場合、契約は継続しているため、Ｘ社での経理処理は必要ありません」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": "3q-hoken-b-3.png"
    },
    {
        "id": 10084,
        "shikenId": 2,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "《設例》の終身保険の第１回保険料払込時の経理処理（仕訳）として、次のうち最も適切<br>なものはどれか。",
        "choice1": "<img src=\"/img/question/2_9_1781050732482329_5.png\" class=\"question-img\" />",
        "choice2": "<img src=\"/img/question/2_9_1781050732598290_6.png\" class=\"question-img\" />",
        "choice3": "<img src=\"/img/question/2_9_1781050732734769_7.png\" class=\"question-img\" />",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-b-3.png"
    },
    {
        "id": 10085,
        "shikenId": 2,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における総所得金額は、次のうちどれか。<br><img src=\"/img/question/2_10_1781050732860895_8.png\" class=\"question-img\" />",
        "choice1": "520万円",
        "choice2": "545万円",
        "choice3": "570万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-hoken-b-4.png"
    },
    {
        "id": 10086,
        "shikenId": 2,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における所得控除の控除額に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「母Ｃさんは老人扶養親族の同居老親等に該当するため、Ａさんが適用を受けることができる扶養控除の控除額は、63万円です」",
        "choice2": "「Ａさんが適用を受けることができる基礎控除の控除額は、104万円です」",
        "choice3": "「Ａさんが適用を受けることができる配偶者控除の控除額は、38万円です」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-b-4.png"
    },
    {
        "id": 10087,
        "shikenId": 2,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における生命保険料控除に関する以下の文章の空欄①～③に入る語句または数値の組合せとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/2_12_1781050733050482_9.png\" class=\"question-img\" />",
        "choice1": "① 介護医療  ②  40,000  ③ できます",
        "choice2": "① 介護医療  ② 100,000  ③ できません",
        "choice3": "① 一般生命  ②  40,000  ③ できません",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "3",
        "image": "3q-hoken-b-4.png"
    },
    {
        "id": 10088,
        "shikenId": 2,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "生前贈与に関する以下の文章の空欄①～③に入る語句または数値の組み合わせとして、次のうち最も適切なものはどれか。<br><img src=\"/img/question/2_13_1781050733286131_10.png\" class=\"question-img\" />",
        "choice1": "① 110  ② 3,000  ③ できます",
        "choice2": "① 220  ② 2,500  ③ できません",
        "choice3": "① 110  ② 2,500  ③ できません",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-b-5.png"
    },
    {
        "id": 10089,
        "shikenId": 2,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "Ａさんの相続等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「長女Ｃさんが受け取る一時払終身保険の死亡保険金は、みなし相続財産として相続税の課税対象となりますが、『500万円×法定相続人の数』を限度として、死亡保険金の非課税金額の規定の適用を受けることができます」",
        "choice2": "「妻Ｂさんが自宅の敷地を相続により取得し、特定居住用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けた場合、自宅の敷地について相続税の課税価格に算入すべき価額は1,400万円となります」",
        "choice3": "「円滑な遺産分割のための手段として遺言書の作成をお勧めします。自筆証書遺言は、その遺言の全文および財産目録をパソコンで作成し、日付および氏名を自書して押印することで作成することができます」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "3",
        "image": "3q-hoken-b-5.png"
    },
    {
        "id": 10090,
        "shikenId": 2,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 3,
        "question1": "",
        "question2": "仮に、Ａさんの相続が現時点（2026年５月23日）で開始し、Ａさんの相続に係る課税遺産総額（課税価格の合計額－遺産に係る基礎控除額）が9,000万円であった場合の相続税の総額は、次のうちどれか。<br><img src=\"/img/question/2_15_1781050733608748_11.png\" class=\"question-img\" />",
        "choice1": "1,200万円",
        "choice2": "1,275万円",
        "choice3": "2,000万円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "4",
        "image": "3q-hoken-b-5.png"
    },
    {
        "id": 10200,
        "shikenId": 2,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "ファイナンシャル・プランニング業務を行うに当たっては、関連業法を順守することが重要である。ファイナンシャル・プランナー（以下「ＦＰ」という）の行為に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "生命保険募集人、保険仲立人の登録を受けていないＦＰが、生命保険契約を検討している顧客のライフプランに基づき、必要保障額を具体的に試算し、相談料金を受け取った。",
        "choice2": "投資助言・代理業の登録を受けていないＦＰが、顧客と投資顧問契約を締結し、当該契約に基づいて具体的な投資銘柄と投資タイミングについて有償で助言をした。",
        "choice3": "税理士資格を有していないＦＰが、相続対策を検討している顧客に対し、一般的な相続税制度の仕組みと手順を解説し、相談料金を受け取った。",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 10201,
        "shikenId": 2,
        "parentNo": 1,
        "no": 2,
        "groupId": 2,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記は、服部家のキャッシュフロー表（一部抜粋）である。このキャッシュフロー表の空欄（ア）、（イ）にあてはまる数値の組み合わせとして、正しいものはどれか。なお、計算過程においては端数処理をせず計算し、計算結果については万円未満を四捨五入すること。<br><img src=\"/img/question/2_2_1781051003208961_1.png\" class=\"question-img\" />",
        "choice1": "（ア）405  （イ）1,364",
        "choice2": "（ア）406  （イ）1,373",
        "choice3": "（ア）405  （イ）1,373",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 10202,
        "shikenId": 2,
        "parentNo": 1,
        "no": 3,
        "groupId": 3,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "長谷川家の現時点の資産および負債が下記＜資料＞のとおりである場合、＜資料＞に基づく長谷川家のバランスシートの空欄（ア）にあてはまる金額として、正しいものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img src=\"/img/question/2_3_1781051003814145_2.png\" class=\"question-img\" /><br><img src=\"/img/question/2_3_1781051004066667_3.png\" class=\"question-img\" />",
        "choice1": "1,220（万円）",
        "choice2": "1,920（万円）",
        "choice3": "1,960（万円）",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 10203,
        "shikenId": 2,
        "parentNo": 1,
        "no": 4,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の山田さんは、60歳で定年を迎えた後、公的年金の支給が始まる65歳までの５年間の生活資金に退職一時金の一部を充てようと考えている。仮に、退職一時金のうち800万円を年利1.0％で複利運用しながら５年間で均等に取り崩すこととした場合、毎年の生活資金に充てることができる最大金額として、正しいものはどれか。なお、下記＜資料＞の３つの係数の中から最も適切な係数を選択して計算し、解答に当たっては万円未満を切り捨てること。また、税金や記載のない事項については一切考慮しないこととする。<br><img src=\"/img/question/2_4_1781051004414271_4.png\" class=\"question-img\" />",
        "choice1": "761万円",
        "choice2": "156万円",
        "choice3": "164万円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 10204,
        "shikenId": 2,
        "parentNo": 1,
        "no": 5,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の石戸さんは、通常65歳から支給される老齢基礎年金および老齢厚生年金を繰り下げて受給できることを知り、ＦＰの矢尾さんに質問をした。老齢基礎年金および老齢厚生年金の繰下げ受給に関する次の記述のうち、最も適切なものはどれか。なお、老齢基礎年金および老齢厚生年金の受給要件は満たしているものとする。",
        "choice1": "「老齢基礎年金および老齢厚生年金を繰り下げて受給した場合には、一生涯増額された年金を受給することになります。」",
        "choice2": "「老齢基礎年金および老齢厚生年金を繰り下げて受給した場合の年金額は、繰下げ年数１年当たり0.4％の割合で増額された額となります。」",
        "choice3": "「老齢基礎年金と老齢厚生年金は、どちらか一方のみを繰り下げて受給することはできません。」",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 10205,
        "shikenId": 2,
        "parentNo": 1,
        "no": 6,
        "groupId": 4,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "景気動向指数に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「有効求人倍率や新設住宅着工床面積は、先行系列に採用されています。」",
        "choice2": "「東証株価指数や新規求人数は、一致系列に採用されています。」",
        "choice3": "「完全失業率や消費者物価指数は、遅行系列に採用されています。」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 10206,
        "shikenId": 2,
        "parentNo": 1,
        "no": 7,
        "groupId": 5,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記＜資料＞の外貨定期預金について、満期時の外貨ベースの元利合計額を円転した金額として、正しいものはどれか。なお、計算結果（円転した金額）について円未満の端数が生じる場合は切り捨てること。また、税金については考慮しないこととする。<br><img src=\"/img/question/2_7_1781051004627119_5.png\" class=\"question-img\" />",
        "choice1": "887,229円",
        "choice2": "881,694円",
        "choice3": "877,164円",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 10207,
        "shikenId": 2,
        "parentNo": 1,
        "no": 8,
        "groupId": 5,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "小堀さんは、預金保険制度の対象となるＨＡ銀行の国内支店に下記＜資料＞の預金を預け入れている。<br>仮に、ＨＡ銀行が破たんした場合、預金保険制度によって保護される金額に関する次の記述のうち、最も適切なものはどれか。<br><img src=\"/img/question/2_8_1781051004904861_6.png\" class=\"question-img\" />",
        "choice1": "決済用預金は1,000万円まで保護される。",
        "choice2": "外貨預金は全額保護される。",
        "choice3": "円定期預金および円普通預金は、合算して1,000万円までが保護される。",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 10208,
        "shikenId": 2,
        "parentNo": 1,
        "no": 9,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "公的な土地評価に関する下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src=\"/img/question/2_9_1781051005170221_7.png\" class=\"question-img\" />",
        "choice1": "（ア）総務省    （イ）市町村（東京23区は東京都）  （ウ）70％",
        "choice2": "（ア）国土交通省  （イ）国税庁            （ウ）70％",
        "choice3": "（ア）総務省    （イ）国税庁            （ウ）80％",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 10209,
        "shikenId": 2,
        "parentNo": 1,
        "no": 10,
        "groupId": 6,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下記＜資料＞の甲土地の建築面積の最高限度を算出する基礎となる敷地面積として、正しいものはどれか。なお、この土地の存する区域は特定行政庁が指定する区域に該当しないものとし、その他記載のない条件については一切考慮しないこととする。<br><img src=\"/img/question/2_10_1781051005432652_8.png\" class=\"question-img\" />",
        "choice1": "280㎡",
        "choice2": "290㎡",
        "choice3": "300㎡",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 10210,
        "shikenId": 2,
        "parentNo": 1,
        "no": 11,
        "groupId": 7,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "下表は、定期借地権についてまとめた表である。下表の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src=\"/img/question/2_11_1781051005786717_9.png\" class=\"question-img\" />",
        "choice1": "（ア）制限なし              （イ）30年以上50年未満  （ウ）借地人",
        "choice2": "（ア）公正証書等の書面または電磁的記録  （イ）10年以上50年未満  （ウ）土地所有者",
        "choice3": "（ア）公正証書等の書面または電磁的記録  （イ）50年以上      （ウ）土地所有者",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 10211,
        "shikenId": 2,
        "parentNo": 1,
        "no": 12,
        "groupId": 8,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "皆木慎太朗さんが加入している医療保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）にあてはまる金額として、正しいものはどれか。なお、保険契約は有効に継続しているものとする。また、慎太朗さんはこれまでに＜資料＞の保険から保険金および給付金を一度も受け取っていないものとする。<br><img src=\"/img/question/2_12_1781051006095714_10.png\" class=\"question-img\" /><br><img src=\"/img/question/2_12_1781051006657951_11.png\" class=\"question-img\" />",
        "choice1": "380,000円",
        "choice2": "395,000円",
        "choice3": "400,000円",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 10212,
        "shikenId": 2,
        "parentNo": 1,
        "no": 13,
        "groupId": 9,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "ＦＰの清野さんは相談者の角田さんから地震保険に関する質問を受けた。地震保険に関する清野さんの次の説明のうち、最も不適切なものはどれか。",
        "choice1": "「地震保険は単独で加入することはできず、火災保険等に付帯して加入する必要があります。」",
        "choice2": "「地震保険の割引制度には、『建築年割引』『耐震等級割引』『免震建築物割引』『耐震診断割引』があり、それぞれの割引制度は重複適用が可能です。」",
        "choice3": "「地震による火災により、居住用の建物が全損となった場合、地震保険の補償の対象となります。」",
        "choice4": "",
        "choice5": "",
        "answer": "2",
        "score": "5",
        "image": ""
    },
    {
        "id": 10213,
        "shikenId": 2,
        "parentNo": 1,
        "no": 14,
        "groupId": 9,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "損害保険の用語に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "「保険金とは、保険事故により損害が生じたとき、保険会社が被保険者または保険金受取人に支払う金銭のことです。」",
        "choice2": "「一部保険とは、保険の対象の価額（保険価額）が保険金額を超えている保険のことです。」",
        "choice3": "「再調達価額とは、保険の対象と同等のものを新たに建築または購入するのに必要な金額から、使用による消耗分を差し引いた金額のことです。」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 10214,
        "shikenId": 2,
        "parentNo": 1,
        "no": 15,
        "groupId": 9,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "西住さんは、2026年７月に新築のアパートを購入し、新たに不動産賃貸業を開始した。購入したアパートの建物部分の情報は下記＜資料＞のとおりである。西住さんの2026年分の所得税における不動産所得の金額の計算上、必要経費に算入する減価償却費の金額として、正しいものはどれか。<br><img src=\"/img/question/2_15_1781051006891273_12.png\" class=\"question-img\" /><br><img src=\"/img/question/2_15_1781051007083000_13.png\" class=\"question-img\" />",
        "choice1": "935,000円",
        "choice2": "1,827,500円",
        "choice3": "1,870,000円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 10215,
        "shikenId": 2,
        "parentNo": 1,
        "no": 16,
        "groupId": 10,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "土地と建物の譲渡に係る所得税の計算に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "「土地と建物などの譲渡による所得は、不動産所得として総合課税の対象となります。」",
        "choice2": "「土地を譲渡したことによる譲渡損失の金額は、原則として他の各種所得の金額と損益通算することができます。」",
        "choice3": "「土地と建物などの譲渡による所得の金額は、原則として『譲渡価額－取得費－譲渡費用』として計算します。」",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 10216,
        "shikenId": 2,
        "parentNo": 1,
        "no": 17,
        "groupId": 10,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "会社員の中野望さんが2026年中に支払った医療費等が下記＜資料＞のとおりである場合、望さんの2026年分の所得税の確定申告における医療費控除の金額として、正しいものはどれか。なお、望さんの2026年中の所得は、給与所得800万円のみであり、支払った医療費等はすべて望さんおよび生計を一にする妻のために支払ったものである。また、医療費控除の金額が最も大きくなるよう計算することとし、セルフメディケーション税制（特定一般用医薬品等購入費を支払った場合の医療費控除の特例）については、考慮しないものとする。<br><img src=\"/img/question/2_17_1781051007245468_14.png\" class=\"question-img\" /><br>（※１）人間ドックの結果、重大な疾病は発見されていない。<br>（※２）この入院について、加入中の生命保険から入院給付金が７万円支給された。",
        "choice1": "12万円",
        "choice2": "19万円",
        "choice3": "22万円",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 10217,
        "shikenId": 2,
        "parentNo": 1,
        "no": 18,
        "groupId": 11,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "2026年１月５日に相続が開始された三河太一朗さん（被相続人）の＜親族関係図＞が下記のとおりである場合、民法上の相続人および法定相続分の組み合わせとして、最も適切なものはどれか。なお、記載のない条件については一切考慮しないこととする。<br><img src=\"/img/question/2_18_1781051007511151_15.png\" class=\"question-img\" />",
        "choice1": "美佐子 ２/３  みき １/３",
        "choice2": "美佐子 １/２  みき １/２",
        "choice3": "美佐子 １/２  優佳 １/２",
        "choice4": "",
        "choice5": "",
        "answer": "1",
        "score": "5",
        "image": ""
    },
    {
        "id": 10218,
        "shikenId": 2,
        "parentNo": 1,
        "no": 19,
        "groupId": 11,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "相続開始後の各種手続きにおける下記＜資料＞の空欄（ア）～（ウ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。なお、記載のない事項については一切考慮しないこととする。<br><img src=\"/img/question/2_19_1781051007838615_16.png\" class=\"question-img\" />",
        "choice1": "（ア）10ヵ月  （イ）地方裁判所  （ウ）６ヵ月",
        "choice2": "（ア）３ヵ月  （イ）地方裁判所  （ウ）10ヵ月",
        "choice3": "（ア）３ヵ月  （イ）家庭裁判所  （ウ）10ヵ月",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 10219,
        "shikenId": 2,
        "parentNo": 1,
        "no": 20,
        "groupId": 12,
        "answerType": 4,
        "inputType": 4,
        "question1": "",
        "question2": "姉歯さん（82歳）は、将来発生するであろう自身の相続について、遺産分割等でのトラブルを防ぐために公正証書遺言の作成を検討しており、ＦＰの桐谷さんに相談をした。下記の空欄（ア）～（ウ）にあてはまる語句または数値の組合せとして、最も適切なものはどれか。<br><img src=\"/img/question/2_20_1781051008107928_17.png\" class=\"question-img\" />",
        "choice1": "（ア）１  （イ）不要  （ウ）できます",
        "choice2": "（ア）２  （イ）必要  （ウ）できません",
        "choice3": "（ア）２  （イ）不要  （ウ）できます",
        "choice4": "",
        "choice5": "",
        "answer": "3",
        "score": "5",
        "image": ""
    },
    {
        "id": 11001,
        "shikenId": 21,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ファイナンシャル・プランナー（以下「ＦＰ」という）の顧客に対する行為に関する次の記述のうち、関連法規に照らし、最も不適切なものはどれか。",
        "choice1": "税理士の登録を受けていないＦＰのＡさんは、顧客から「直系尊属から結婚・子育て資金の一括贈与を受けた場合の贈与税の非課税」について相談を受け、関連法令の条文を示しながら、制度の概要を無償で説明した。",
        "choice2": "弁護士の登録を受けていないＦＰのＢさんは、顧客から配偶者居住権について相談を受け、関連法令の条文を示しながら、制度の概要を無償で説明した。",
        "choice3": "金融商品取引業の登録を受けていないＦＰのＣさんは、投資一任契約に基づき、顧客から株式投資に関する必要な権限を有償で委任され、当該顧客の資金を預かって値上がりが期待できる株式の個別銘柄への投資を行った。",
        "choice4": "生命保険募集人の登録を受けていないＦＰのＤさんは、ライフプランの相談に来た顧客に対して、生命保険の一般的な商品内容や目的別の活用方法を有償で説明した。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11002,
        "shikenId": 21,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "雇用保険法に基づく育児休業給付および介護休業給付に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "介護休業給付金は、同一の対象家族について介護休業を分割して取得する場合、休業開始日から休業日数が通算して93日に達するまでに５回を限度として支給される。",
        "choice2": "一般被保険者の配偶者の父母は、介護休業給付金の支給対象となる家族に該当する。",
        "choice3": "育児休業給付金の支給額は、１支給単位期間について、休業開始日から休業日数が通算して300日に達するまでの間は、原則として、休業開始時賃金日額に支給日数を乗じて得た額の67％相当額である。",
        "choice4": "育児休業給付金は、一般被保険者の休業開始日前１年間に、みなし被保険者期間が通算して６ヵ月以上なければ支給されない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11003,
        "shikenId": 21,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的医療保険に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "全国健康保険協会管掌健康保険（協会けんぽ）の一般保険料率は、都道府県ごとに算定され、保険料は、原則として、労使で折半して負担する。",
        "choice2": "自営業者や農林漁業従事者などが被保険者となる国民健康保険は、国が保険者として運営している。",
        "choice3": "退職により健康保険の被保険者資格を喪失した者が、健康保険の任意継続被保険者になるためには、資格喪失日の前日まで継続して１年以上の被保険者期間がなければならない。",
        "choice4": "健康保険や国民健康保険の被保険者は、原則として、70歳に達したときに、その被保険者資格を喪失して後期高齢者医療制度の被保険者となる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11004,
        "shikenId": 21,
        "parentNo": 1,
        "no": 4,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "老齢厚生年金の繰下げ支給に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "老齢厚生年金の受給権者が、老齢厚生年金の繰下げ支給の申出をする場合、老齢基礎年金の繰下げ支給の申出を同時に行わなければならない。",
        "choice2": "老齢厚生年金の受給権者が、老齢厚生年金の受給権を取得したときに遺族厚生年金の受給権者であった場合、老齢厚生年金の繰下げ支給の申出をすることができない。",
        "choice3": "老齢厚生年金の繰下げ支給による年金の増額率は、繰り下げた月数に0.5％を乗じて得た率である。",
        "choice4": "加給年金額が加算される老齢厚生年金について繰下げ支給の申出をする場合、加給年金額についても繰下げ支給による増額の対象となる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11005,
        "shikenId": 21,
        "parentNo": 1,
        "no": 5,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "厚生年金保険の被保険者である夫が死亡し、子のない30歳未満の妻が遺族厚生年金の受給権を取得した場合、その妻に対する遺族厚生年金の支給期間は、最長で５年間である。",
        "choice2": "障害等級１級または２級に該当する程度の障害の状態にある障害厚生年金の受給権者が、18歳未満の子を有する場合、その受給権者には子の加算額が加算された障害厚生年金が支給される。",
        "choice3": "国民年金の保険料納付済期間が10年以上あり、厚生年金保険の被保険者期間を有する者は、原則として、65歳から老齢基礎年金および老齢厚生年金を受給することができる。",
        "choice4": "学生納付特例の承認を受けた期間に係る国民年金保険料のうち、追納することができる保険料は、追納に係る厚生労働大臣の承認を受けた日の属する月前10年以内の期間に係るものに限られる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11006,
        "shikenId": 21,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "確定拠出年金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "企業型年金や確定給付企業年金等を実施していない一定規模以下の中小企業の事業主は、労使の合意かつ従業員の同意を基に、従業員が加入している個人型年金の加入者掛金に事業主掛金を上乗せして納付することができる。",
        "choice2": "個人型年金に加入できるのは、国内に居住する国民年金の被保険者に限られる。",
        "choice3": "個人型年金の加入者が60歳から老齢給付金を受給するためには、通算加入者等期間が10年以上なければならない。",
        "choice4": "企業型年金において、加入者が掛金を拠出することができることを規約で定める場合、加入者掛金の額は、その加入者に係る事業主掛金の額を超える額とすることができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11007,
        "shikenId": 21,
        "parentNo": 1,
        "no": 7,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "公的年金の障害給付に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "同一の事由により、労働者災害補償保険の障害補償年金と障害基礎年金および障害厚生年金が支給される場合、障害基礎年金および障害厚生年金は、所定の割合で減額されて支給される。",
        "choice2": "障害基礎年金の受給権者が新たに所定の要件を満たす子を有するに至った場合、所定の手続きにより、その子を有するに至った日の属する月の翌月から、その子に係る加算額が加算された障害基礎年金が支給される。",
        "choice3": "厚生年金保険の被保険者が病気により障害を負い、その障害の状態が障害認定日においては所定の障害等級に該当していなかったものの、その後病状が悪化して、所定の障害等級に該当するに至った場合、65歳に達する日の前日までに請求することにより、原則として、障害厚生年金の支給を受けることができる。",
        "choice4": "障害厚生年金の額の計算上、その計算の基礎となる被保険者期間の月数が300月に満たない場合、300月として計算する。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11008,
        "shikenId": 21,
        "parentNo": 1,
        "no": 8,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "国民年金基金、小規模企業共済および中小企業退職金共済に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "小規模企業共済では、共済契約の解約時における掛金納付月数が12ヵ月未満である場合、解約事由にかかわらず、解約手当金は支給されない。",
        "choice2": "中小企業退職金共済の掛金は、事業主と従業員の合意に基づき、事業主と従業員が折半して負担することができる。",
        "choice3": "国民年金基金の掛金月額は、選択した給付の型および加入口数に応じて決まり、加入時の年齢や性別による差異はない。",
        "choice4": "小規模企業共済の掛金は、確定拠出年金の個人型年金の掛金との合計で、月額68,000円が限度とされている。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11009,
        "shikenId": 21,
        "parentNo": 1,
        "no": 9,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "リタイアメントプランニング等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "将来、本人の判断能力が不十分になった場合に備えて、あらかじめ本人が選任した者と締結する任意後見契約は、所定の様式の公正証書によってしなければならない。",
        "choice2": "金融機関のリバースモーゲージは、通常、利用者が自宅に住み続けながらその不動産を担保に資金を借り入れ、利用者の死亡後に、その不動産の売却等により借入金を返済する仕組みである。",
        "choice3": "老後生活資金として一定期間、毎年一定額を受け取るために必要な元本を計算する際、毎年受け取りたい金額に乗じる係数は年金現価係数である。",
        "choice4": "定年年齢を75歳未満に定めている事業主は、高年齢者等の雇用の安定等に関する法律に基づき、雇用する高年齢者の75歳までの雇用確保のため、所定の措置を講じるよう努めなければならない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11010,
        "shikenId": 21,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "決算書に基づく経営分析指標に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ＲＯＥは、自己資本に対する当期純利益の割合を示したものであり、一般に、この数値が低い方が経営の効率性が高いと判断される。",
        "choice2": "固定長期適合率は、自己資本に対する固定資産の割合を示したものであり、一般に、この数値が低い方が財務の健全性が高いと判断される。",
        "choice3": "損益分岐点比率は、実際の売上高に対する損益分岐点売上高の割合を示したものであり、一般に、この数値が低い方が企業の収益性が高いと判断される。",
        "choice4": "自己資本比率は、総資本に対する自己資本の割合を示したものであり、一般に、この数値が低い方が財務の健全性が高いと判断される。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11011,
        "shikenId": 21,
        "parentNo": 1,
        "no": 11,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の保険料等の一般的な仕組みに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "所定の利率による運用収益をあらかじめ見込んで保険料を割り引く際に使用する予定利率を低く設定した場合、新規契約の保険料は高くなる。",
        "choice2": "保険料は、大数の法則および収支相等の原則に基づき、予定死亡率、予定利率および予定事業費率の３つの予定基礎率を用いて算定される。",
        "choice3": "保険料は、将来の保険金・給付金等の支払い財源となる純保険料と、保険会社が保険契約を維持・管理していくために必要な経費等の財源となる付加保険料で構成される。",
        "choice4": "保険会社が実際に要した事業費が、保険料を算定する際に見込んでいた事業費よりも多かった場合、費差益が生じる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11012,
        "shikenId": 21,
        "parentNo": 1,
        "no": 12,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
        "choice1": "変額保険（終身型）では、契約時に定めた保険金額（基本保険金額）が保証されており、運用実績にかかわらず、死亡保険金の額は基本保険金額を下回らない。",
        "choice2": "低解約返戻金型終身保険は、保険料払込期間中の一定期間における解約返戻金額および死亡保険金額が他の契約条件が同一で低解約返戻金型ではない終身保険に比べて低く抑えられているため、割安な保険料が設定されている。",
        "choice3": "定期保険特約付終身保険（更新型）は、定期保険特約を同額の保険金額で更新する場合、被保険者の健康状態についての告知や医師の診査が必要であり、その健康状態によっては更新することができない。",
        "choice4": "逓減定期保険は、保険期間の経過に伴い所定の割合で保険料が逓減するが、保険金額は一定である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11013,
        "shikenId": 21,
        "parentNo": 1,
        "no": 13,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "外貨建て生命保険の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。なお、記載のない特約については考慮しないものとする。",
        "choice1": "外貨建て終身保険は、契約時に円換算支払特約を付加すれば、契約時の為替相場で円換算した死亡保険金を受け取ることができる。",
        "choice2": "ＭＶＡ（市場価格調整）機能を有する外貨建て生命保険は、市場金利に応じた運用資産の価格変動に伴い、解約時の解約返戻金額が増減する。",
        "choice3": "外貨建て終身保険は、円貨建ての終身保険と異なり、支払った保険料が生命保険料控除の対象とならない。",
        "choice4": "外貨建て生命保険は、通常、米ドル・豪ドル・ユーロなどの外貨で保険料を払い込んで円貨で保険金等を受け取る保険であり、終身保険のほか、養老保険や個人年金保険などがある。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11014,
        "shikenId": 21,
        "parentNo": 1,
        "no": 14,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "総合福祉団体定期保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、契約者は法人であるものとする。",
        "choice1": "法人が負担した保険料は、その全額を損金の額に算入することができる。",
        "choice2": "契約の締結には、被保険者になることについての加入予定者の同意が必要である。",
        "choice3": "保険期間は、１年から５年の範囲内で、被保険者ごとに設定することができる。",
        "choice4": "ヒューマン・ヴァリュー特約を付加した場合、当該特約の死亡保険金受取人は法人となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11015,
        "shikenId": 21,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "契約者（＝保険料負担者）を法人とする生命保険に係る保険料等の経理処理に関する次の記述のうち、最も不適切なものはどれか。なお、いずれの保険契約も保険料は年払いかつ全期払いで、2026年10月に締結したものとする。",
        "choice1": "被保険者が役員・従業員全員、給付金受取人が法人である医療保険について、法人が受け取った入院給付金および手術給付金は、その全額を益金の額に算入する。",
        "choice2": "被保険者が役員、死亡保険金受取人が法人で、最高解約返戻率が80％である定期保険（保険期間30年）の支払保険料は、保険期間の前半４割相当期間においては、その60％相当額を資産に計上し、残額を損金の額に算入することができる。",
        "choice3": "被保険者が役員、死亡保険金受取人が法人である終身保険の支払保険料は、その全額を資産に計上する。",
        "choice4": "被保険者が役員・従業員全員、死亡保険金受取人が被保険者の遺族、満期保険金受取人が法人である養老保険の支払保険料は、その全額を損金の額に算入することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11016,
        "shikenId": 21,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "任意加入の自動車保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。<br>なお、記載のない事項については考慮しないものとする。",
        "choice1": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って通行人が連れていたペットの犬に接触してケガをさせ、法律上の損害賠償責任を負った場合、対物賠償保険の補償の対象となる。",
        "choice2": "豪雨による洪水で被保険自動車が水没して被った損害は、一般条件の車両保険の補償の対象となる。",
        "choice3": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って車庫入れを誘導していた記名被保険者の配偶者に接触してケガをさせた場合、対人賠償保険の補償の対象となる。",
        "choice4": "記名被保険者が被保険自動車を運転中に、ハンドル操作を誤って衣料品販売店の店舗に衝突した場合、店舗の復旧期間中の休業損害は、対物賠償保険の補償の対象となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11017,
        "shikenId": 21,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "傷害保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。なお、特約および記載のない事項については考慮しないものとする。",
        "choice1": "交通事故傷害保険では、デパートのエスカレーターに搭乗中の事故によりケガをした場合、補償の対象となる。",
        "choice2": "普通傷害保険では、被保険者が自動車を運転中に他の自動車と衝突してケガをした場合、被保険者の過失割合にかかわらず補償の対象となる。",
        "choice3": "普通傷害保険では、海外旅行中に地震により倒壊した建物の下敷きになりケガをした場合、補償の対象となる。",
        "choice4": "国内旅行傷害保険では、被保険者が旅行中の飲食により細菌性食中毒を発症した場合、補償の対象となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11018,
        "shikenId": 21,
        "parentNo": 1,
        "no": 18,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人を契約者（＝保険料負担者）とする損害保険に係る保険料等の経理処理に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "法人が所有する賃貸アパートが台風により損壊し、法人が受け取った火災保険の保険金で原状回復のための修理をした場合、当該保険金を益金の額に算入し、修理費を損金の額に算入することができる。",
        "choice2": "業務中の事故によりケガをするリスクに備えて、法人がすべての従業員を被保険者とする普通傷害保険に加入した場合、支払った保険料は、その２分の１相当額を限度として損金の額に算入することができる。",
        "choice3": "法人が所有する業務用自動車が交通事故で全損となり、受け取った自動車保険の車両保険金で同一事業年度中に代替車両を取得した場合であっても、圧縮記帳は認められない。",
        "choice4": "法人が所有する賃貸アパートを保険の対象として支払った地震保険の保険料は、地震保険料控除として５万円を限度として損金の額に算入することができる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11019,
        "shikenId": 21,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "医療保険の一般的な商品性に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "引受基準緩和型の医療保険と引受基準緩和型ではない一般の医療保険を比較した場合、他の契約条件が同一であれば、保険料は引受基準緩和型の医療保険の方が高くなる。",
        "choice2": "更新型の医療保険では、保険期間中に入院給付金を受け取った場合、保険期間満了時に契約を更新することができない。",
        "choice3": "医療保険では、人間ドック等の治療を目的としない入院をし、異常が発見されなかった場合、入院給付金を受け取ることができない。",
        "choice4": "先進医療特約で先進医療給付金の支払対象とされている先進医療は、療養を受けた日時点において厚生労働大臣によって定められたものである。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11020,
        "shikenId": 21,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "損害保険を活用した家庭のリスク管理に関する次の記述のうち、最も不適切なものはどれか。<br>なお、契約者（＝保険料負担者）は会社員の個人であるものとする。",
        "choice1": "同居の子が原動機付自転車で通学中に、他人に接触してケガをさせて法律上の損害賠償責任を負うリスクに備えて、火災保険加入時に個人賠償責任補償特約を付帯した。",
        "choice2": "所定の病気やケガにより会社の業務にまったく従事することができなくなるリスクに備えて、所得補償保険を契約した。",
        "choice3": "自動車の運転中に誤って単独事故を起こして車両が破損するリスクに備えて、自動車保険の一般条件の車両保険を契約した。",
        "choice4": "海岸近くに新築した自宅が地震による津波で損壊するリスクに備えて、火災保険に地震保険を付帯して契約した。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11021,
        "shikenId": 21,
        "parentNo": 1,
        "no": 21,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "銀行等の金融機関で取り扱う預金商品の一般的な商品性に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "期日指定定期預金は、据置期間経過後から最長預入期日までの間で、任意の日を満期日として指定することができる。",
        "choice2": "決済用預金のうち、当座預金は、個人、法人のいずれも利用することができるが、無利息型普通預金は、法人が利用することはできない。",
        "choice3": "貯蓄預金は、給与、年金等の自動受取口座や公共料金等の自動振替口座に指定することができる。",
        "choice4": "総合口座において、紙の通帳の代わりにオンライン上で入出金の明細や残高を確認することができるサービスを提供しているのは、ネット専業銀行に限られる。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11022,
        "shikenId": 21,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "株式投資信託の一般的な運用手法等に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "ベンチマークの動きに連動して同等の運用収益率を得ることを目指すパッシブ運用は、アクティブ運用に比べて運用コストが低い傾向がある。",
        "choice2": "株価が現在の資産価値や利益水準などから割安と評価される銘柄に投資する手法は、バリュー運用と呼ばれる。",
        "choice3": "割安な銘柄の売建てと割高な銘柄の買建てをそれぞれ同程度の金額で行い、市場の価格変動に左右されない絶対的な収益の確保を目指す手法は、マーケット・ニュートラル運用と呼ばれる。",
        "choice4": "個別企業の業績の調査や財務分析によって投資対象となる銘柄を選定し、その積上げによってポートフォリオを構築する手法は、ボトムアップ・アプローチと呼ばれる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11023,
        "shikenId": 21,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "表面利率が0.5％で、償還までの残存期間が８年の固定利付債券を額面100円当たり101円で購入し、購入から５年後に額面100円当たり100円で売却した場合の所有期間利回り（単利・年率）として、最も適切なものはどれか。なお、手数料、経過利子、税金等については考慮しないものとし、計算結果は表示単位の小数点以下第３位を四捨五入するものとする。",
        "choice1": "0.17％",
        "choice2": "0.30％",
        "choice3": "0.37％",
        "choice4": "0.50％",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11024,
        "shikenId": 21,
        "parentNo": 1,
        "no": 24,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "東京証券取引所の市場区分等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "スタンダード市場の上場会社がプライム市場へ市場区分の変更を申請することはできるが、プライム市場の上場会社がスタンダード市場へ市場区分の変更を申請することはできない。",
        "choice2": "ＪＰＸ日経インデックス400は、プライム市場、スタンダード市場、グロース市場を主市場とする普通株式の中から、ＲＯＥや営業利益等の指標等により選定された400銘柄を対象として算出される。",
        "choice3": "プライム市場の上場維持基準では、新規上場から一定期間経過後の株主数および流通株式数について、新規上場基準よりも高い数値基準が設定されている。",
        "choice4": "プライム市場の新規上場基準では、上場申請会社の直近事業年度におけるＲＯＥの数値基準について、８％以上と定められている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11025,
        "shikenId": 21,
        "parentNo": 1,
        "no": 25,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "債券投資のリスクに関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "債券の価格変動リスクは、表面利率などの他の条件が同一であれば、一般に、残存期間が長いほど高くなる。",
        "choice2": "債券の発行体の所在する国や地域における政治・経済状況の変化等により、債券価格が大きく変動したり、債券の元本や利子の支払不能等が生じたりするリスクを、一般に、カントリーリスクという。",
        "choice3": "債券の信用格付けにおいて、Ｂ（シングルビー）格相当以上の格付けが付された債券は、一般に、投資適格債と呼ばれ、信用リスクが低い債券とされる。",
        "choice4": "外貨建て債券の為替変動リスクを回避または軽減する方法の一つとして、当該債券の購入時に、その償還日にあわせて為替予約を行う為替ヘッジが考えられる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11026,
        "shikenId": 21,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融派生商品に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "コール・オプション、プット・オプションのいずれも、他の条件が同一であれば、満期までの期間が長いほど、プレミアム（オプション料）は高くなる。",
        "choice2": "先物取引によりスペキュレーション取引を行う場合、先物価格が今後上昇すると予測すれば売り建てして、実際に相場が上昇した後に買い戻すことで利益を得ることができる。",
        "choice3": "先物取引における買い手は、最終決済価格が約定価格よりも低い場合、その差額分の利益を得ることができる。",
        "choice4": "クーポンスワップは、異なる通貨間で将来の金利および元本を交換する通貨スワップである。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11027,
        "shikenId": 21,
        "parentNo": 1,
        "no": 27,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "オプション取引の一般的な特徴に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "コール・オプションの買い手の最大利益とプット・オプションの買い手の最大利益は、いずれもプレミアム（オプション料）の額となる。",
        "choice2": "コール・オプションおよびプット・オプションは、他の条件が同一であれば、いずれもボラティリティが上昇するほど、プレミアム（オプション料）は高くなる。",
        "choice3": "権利行使期間中であればいつでも権利行使が可能なものをヨーロピアン・オプションといい、満期日（権利行使日）においてのみ権利行使が可能なものをアメリカン・オプションという。",
        "choice4": "コール・オプションは「原資産を権利行使価格で売る権利」であり、プット・オプションは「原資産を権利行使価格で買う権利」である。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11028,
        "shikenId": 21,
        "parentNo": 1,
        "no": 28,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ポートフォリオ理論に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "ポートフォリオのリスクとは、一般に、組成されたポートフォリオの損失額の大きさを示すのではなく、そのポートフォリオの期待収益率と実際の収益率の乖離の度合いをいう。",
        "choice2": "ポートフォリオのリスクは、組み入れた各資産のリスクを組入比率で加重平均した値以下となる。",
        "choice3": "異なる２資産からなるポートフォリオにおいて、２資産間の相関係数がゼロである場合、ポートフォリオを組成することによる分散投資の効果（リスクの低減効果）は生じない。",
        "choice4": "ポートフォリオの期待収益率は、組み入れた各資産の期待収益率を組入比率で加重平均した値となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11029,
        "shikenId": 21,
        "parentNo": 1,
        "no": 29,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "ＮＩＳＡ（非課税上場株式等管理契約に係る少額投資非課税制度）に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、ＮＩＳＡにより投資収益が非課税となる非課税口座をＮＩＳＡ口座という。",
        "choice1": "ＮＩＳＡ口座で保有する上場株式を売却することで生じた譲渡損失の金額のうち、損益通算してもなお控除しきれない金額は、確定申告を行うことにより、翌年以後３年間にわたって繰り越すことができる。",
        "choice2": "ＮＩＳＡ口座で保有する上場株式を売却することで生じた譲渡損失の金額は、上場株式の配当金の受取方法として株式数比例配分方式を選択した場合、当該口座で保有する上場株式の配当金の金額と通算することができる。",
        "choice3": "特定口座で保有する上場株式をＮＩＳＡ口座に設定される非課税管理勘定に移管することにより、移管後５年以内に生じた当該上場株式の譲渡益は非課税となる。",
        "choice4": "ＮＩＳＡにおいて、年間投資額の上限は、「つみたて投資枠」が120万円であり、「成長投資枠」が240万円である。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11030,
        "shikenId": 21,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "金融商品の取引等に係る各種法令に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、「金融サービスの提供及び利用環境の整備等に関する法律」を金融サービス提供法、「犯罪による収益の移転防止に関する法律」を犯罪収益移転防止法という。",
        "choice1": "消費者契約法では、事業者の不適切な行為によって、消費者が誤認や困惑をし、それによって消費者契約の申込みまたはその承諾の意思表示をした場合、消費者は、当該契約によって生じた損害について賠償を請求することができるとされている。",
        "choice2": "犯罪収益移転防止法では、金融機関等の特定事業者が顧客と特定業務に係る取引を行った場合、特定事業者は、原則として、直ちに当該取引に関する記録を作成し、当該取引の行われた日から７年間保存しなければならないとされている。",
        "choice3": "金融商品取引法では、金融商品取引契約を締結しようとする金融商品取引業者等は、あらかじめ顧客（特定投資家を除く）に契約締結前交付書面を交付しなければならないとされているが、顧客から交付を要しない旨の意思表示があった場合、その交付義務は免除される。",
        "choice4": "金融サービス提供法では、金融サービス仲介業の登録を受けた事業者は、銀行、証券、保険、貸金業の分野のサービスを仲介することができるが、特定の金融機関に所属し、その指導および監督を受けなければならないとされている。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11031,
        "shikenId": 21,
        "parentNo": 1,
        "no": 31,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "わが国の税制に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "所得税では、課税対象となる所得を８種類に区分し、それぞれの所得の種類ごとに定められた計算方法により所得の金額を計算する。",
        "choice2": "相続税は直接税に該当し、消費税は間接税に該当する。",
        "choice3": "固定資産税は国税に該当し、登録免許税は地方税に該当する。",
        "choice4": "相続税では、納税者が申告書に記載した被相続人の資産等の内容に基づき、税務署長が納付すべき税額を決定する賦課課税方式を採用している。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11032,
        "shikenId": 21,
        "parentNo": 1,
        "no": 32,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における所得の種類に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "個人年金保険の契約者（＝保険料負担者）である個人が、その保険契約に基づき、年金受給開始後に将来の年金給付の総額に代えて受け取った一時金に係る所得は、退職所得となる。",
        "choice2": "会社の役員が役員退職金を受け取ったことによる所得は、給与所得となる。",
        "choice3": "不動産の貸付けを事業的規模で行ったことにより生じた賃料収入に係る所得は、不動産所得となる。",
        "choice4": "会社員が勤務先から無利息で金銭を借り入れたことにより生じた経済的利益は、雑所得となる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11033,
        "shikenId": 21,
        "parentNo": 1,
        "no": 33,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税の損益通算に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "生命保険の解約返戻金を受け取ったことによる一時所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
        "choice2": "業務用車両を譲渡したことによる譲渡所得の金額の計算上生じた損失の金額は、事業所得の金額と損益通算することができる。",
        "choice3": "不動産所得の金額の計算上生じた損失の金額のうち、不動産所得を生ずべき土地の取得に要した負債の利子の額に相当する部分の金額は、事業所得の金額と損益通算することができる。",
        "choice4": "先物取引に係る雑所得の金額の計算上生じた損失の金額は、不動産所得の金額と損益通算することができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11034,
        "shikenId": 21,
        "parentNo": 1,
        "no": 34,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "所得税における各種所得控除に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "納税者の合計所得金額が2,500万円を超える場合、基礎控除の適用を受けることはできない。",
        "choice2": "納税者の合計所得金額が1,000万円を超える場合、配偶者控除の適用を受けることはできない。",
        "choice3": "納税者の合計所得金額が500万円を超える場合、寡婦控除の適用を受けることはできない。",
        "choice4": "納税者の合計所得金額が1,000万円を超える場合、医療費控除の適用を受けることはできない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11035,
        "shikenId": 21,
        "parentNo": 1,
        "no": 35,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "給与所得者の所得税の確定申告に関する次の記述のうち、最も適切なものはどれか。なお、各選択肢において、記載された所得以外の所得は考慮しないものとする。また、いずれも適切に源泉徴収等がされ、年末調整すべきものは年末調整が済んでいるものとする。",
        "choice1": "Ａ社からの給与の収入金額が800万円で、生命保険の満期保険金に係る一時所得の金額が50万円ある場合、確定申告は不要である。",
        "choice2": "Ｂ社からの給与の収入金額が70万円で、老齢基礎年金および老齢厚生年金の公的年金に係る雑所得の金額が250万円ある場合、確定申告は不要である。",
        "choice3": "Ｃ社からの給与の収入金額が800万円で、アルバイトとして兼業しているＤ社からの給与の収入金額が30万円ある場合、確定申告は不要である。",
        "choice4": "Ｅ社からの給与の収入金額が3,000万円で、Ｆ社からの原稿料収入に係る雑所得の金額が15万円ある場合、確定申告は不要である。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11036,
        "shikenId": 21,
        "parentNo": 1,
        "no": 36,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人税の原則的な取扱いに関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "新設法人が設立事業年度から青色申告の適用を受けようとする場合は、設立の日から１ヵ月以内に「青色申告の承認申請書」を納税地の所轄税務署長に提出し、その承認を受けなければならない。",
        "choice2": "法人税の納税地は、その法人の代表者の住所または居所の所在地である。",
        "choice3": "法人は、法人税の納税地に異動があった場合、異動届出書を異動前および異動後の納税地の所轄税務署長に提出しなければならない。",
        "choice4": "期末資本金の額等が１億円以下の一定の中小法人に対する法人税の税率は、所得金額のうち年800万円以下の部分について軽減税率が適用される。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11037,
        "shikenId": 21,
        "parentNo": 1,
        "no": 37,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "法人税の損金に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "法人が役員に対して定期同額給与を支給した場合、不相当に高額な部分の金額など一定のものを除き、その全額を損金の額に算入することができる。",
        "choice2": "法人が会議に関連して、茶菓、弁当その他これらに類する飲食物を供与するために通常要する費用を支出した場合、その全額を損金の額に算入することができる。",
        "choice3": "法人が減価償却費として損金経理した金額のうち、償却限度額に達するまでの金額は、その全額を損金の額に算入することができる。",
        "choice4": "法人が法人税および法人住民税を納付した場合、その全額を損金の額に算入することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11038,
        "shikenId": 21,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "消費税に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "消費税の課税期間に係る基準期間は、個人事業者についてはその年の前々年である。",
        "choice2": "消費税の課税事業者が行う居住の用に供する家屋の貸付けは、その貸付期間が１ヵ月以上であれば、消費税の課税取引に該当する。",
        "choice3": "消費税の課税事業者である個人は、原則として、消費税の確定申告書をその年の翌年３月15日までに納税地の所轄税務署長に提出しなければならない。",
        "choice4": "簡易課税制度の適用を受けることができるのは、消費税の課税期間に係る基準期間における課税売上高が１億円以下の事業者である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11039,
        "shikenId": 21,
        "parentNo": 1,
        "no": 39,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "会社と役員間の取引に係る所得税・法人税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "会社が役員に対して無利息で金銭の貸付けを行った場合、原則として、通常収受すべき利息に相当する金額が、会社の益金の額に算入される。",
        "choice2": "役員が所有する建物を適正な時価の２分の１以上かつ時価未満の価額で会社に譲渡した場合、役員は、時価相当額を譲渡価額として譲渡所得の計算を行う。",
        "choice3": "会社が役員からの借入金について債務免除を受けた場合、会社はその債務免除を受けた金額を益金の額に算入する。",
        "choice4": "会社が所有する土地を適正な時価よりも低い価額で役員に譲渡した場合、その適正な時価と譲渡価額との差額が役員の給与所得の収入金額に算入される。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11040,
        "shikenId": 21,
        "parentNo": 1,
        "no": 40,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "損益計算書、貸借対照表およびキャッシュフロー計算書の一般的な特徴に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "貸借対照表において、資産の部の合計額と、負債の部および純資産の部の合計額は一致する。",
        "choice2": "キャッシュフロー計算書は、一会計期間における企業の資金の増減を示したものである。",
        "choice3": "損益計算書において、営業利益の額は、売上総利益の額から販売費及び一般管理費の額を差し引いた額である。",
        "choice4": "損益計算書において、経常利益の額は、営業利益の額に特別利益・特別損失の額を加算・減算した額である。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11041,
        "shikenId": 21,
        "parentNo": 1,
        "no": 41,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の登記や調査に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "抵当権の登記事項は、権利部乙区に記録される。",
        "choice2": "登記情報提供サービスでは、登記所が保有する登記情報を、インターネットを使用してパソコン等で確認することができるが、取得した登記情報に係る電子データには登記官の認証文は付されない。",
        "choice3": "新築した建物の所有権を取得した者は、その所有権の取得の日から１ヵ月以内に、所有権保存登記を申請しなければならない。",
        "choice4": "区分建物を除く建物に係る登記記録において、床面積は、壁その他の区画の中心線で囲まれた部分の水平投影面積（壁芯面積）により記録される。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11042,
        "shikenId": 21,
        "parentNo": 1,
        "no": 42,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "宅地建物取引業法に関する次の記述のうち、最も適切なものはどれか。なお、買主は宅地建物取引業者ではないものとする。",
        "choice1": "宅地建物取引業者が、自ら売主となる宅地の売買契約の締結に際して手付を受領したときは、その手付がいかなる性質のものであっても、買主が契約の履行に着手する前であれば、当該宅地建物取引業者はその手付を返還することで、契約の解除をすることができる。",
        "choice2": "アパートやマンションの所有者が、当該建物の賃貸を自ら業として行うためには、あらかじめ宅地建物取引業の免許を取得しなければならない。",
        "choice3": "専任媒介契約を締結した宅地建物取引業者は、依頼者に対し、当該専任媒介契約に係る業務の処理状況を、５日間に１回以上報告しなければならない。",
        "choice4": "宅地建物取引業者は、自ら売主となる宅地の売買契約の締結に際して、代金の額の10分の２を超える額の手付を受領することができない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11043,
        "shikenId": 21,
        "parentNo": 1,
        "no": 43,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第22条の借地権を一般定期借地権といい、第22条から第24条の定期借地権等以外の借地権を普通借地権という。また、記載のない特約については考慮しないものとする。",
        "choice1": "普通借地権の存続期間が満了する場合において、借地権者が契約の更新を請求し、借地権設定者が遅滞なく異議を述べなかったときは、借地上に建物があるかどうかにかかわらず、従前の契約と同一の条件で契約を更新したものとみなされる。",
        "choice2": "一般定期借地権において、契約の更新および建物の築造による存続期間の延長がなく、建物等の買取りの請求をしないこととする旨を定める特約は、公正証書による等書面（電磁的記録による場合を含む）によってしなければならない。",
        "choice3": "事業の用に供する建物の所有を目的として、一般定期借地権を設定することはできない。",
        "choice4": "普通借地権の存続期間は30年とされており、契約でこれより長い期間を定めることはできない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11044,
        "shikenId": 21,
        "parentNo": 1,
        "no": 44,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "都市計画法に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "市街化区域内で行う開発行為は、その規模にかかわらず、都道府県知事等の許可を受ける必要がある。",
        "choice2": "市街化調整区域は、おおむね10年以内に優先的かつ計画的に市街化を図るべき区域とされている。",
        "choice3": "市街化区域については用途地域を定め、市街化調整区域については原則として用途地域を定めないものとされている。",
        "choice4": "すべての都市計画区域において、都市計画に市街化区域と市街化調整区域の区域区分を定めなければならない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11045,
        "shikenId": 21,
        "parentNo": 1,
        "no": 45,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "借地借家法に関する次の記述のうち、最も適切なものはどれか。なお、本問においては、同法第38条における定期建物賃貸借契約を定期借家契約といい、それ以外の建物賃貸借契約を普通借家契約という。また、特約については考慮しないものとする。",
        "choice1": "定期借家契約は、公正証書によってしなければならない。",
        "choice2": "普通借家契約において、賃貸人は、賃貸人および賃借人が建物の使用を必要とする事情や建物の利用状況などを考慮して、正当の事由があると認められる場合でなければ、賃借人に対し、建物の賃貸借の解約の申入れをすることはできない。",
        "choice3": "普通借家契約において、賃貸人が賃借人に対して期間満了の１年前から６ヵ月前までの間に更新をしない旨の通知をしなかったときは、従前の契約と同じ期間で契約を更新したものとみなされる。",
        "choice4": "定期借家契約は、契約当事者間の合意があっても、存続期間を１年未満とすることはできない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11046,
        "shikenId": 21,
        "parentNo": 1,
        "no": 46,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "都市計画区域および準都市計画区域内における建築基準法の規定に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "建築物の高さに係る隣地斜線制限は、第一種低層住居専用地域、第二種低層住居専用地域および田園住居地域には適用されない。",
        "choice2": "第一種住居地域内においては、建築物の高さは10ｍまたは12ｍのうち当該地域に関する都市計画において定められた建築物の高さの限度を超えてはならない。",
        "choice3": "敷地の前面道路の幅員が12ｍ未満である建築物の容積率は、原則として、「都市計画で定められた容積率」と「前面道路の幅員に一定の数値を乗じて得たもの」とのいずれか低い方が上限となる。",
        "choice4": "建築物の敷地は、原則として、建築基準法に規定する道路に２ｍ以上接していなければならない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11047,
        "shikenId": 21,
        "parentNo": 1,
        "no": 47,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "建物の区分所有等に関する法律に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "区分所有建物のうち、構造上の独立性と利用上の独立性を備えた建物の部分は、区分所有権の目的となる専有部分であり、規約によって共用部分とすることはできない。",
        "choice2": "規約の変更により、一部の区分所有者の権利に特別の影響を及ぼすべきときは、当該区分所有者の承諾を得なければならない。",
        "choice3": "共用部分に対する区分所有者の共有持分は、規約に別段の定めがない限り、各共有者が有する専有部分の床面積の割合による。",
        "choice4": "区分所有建物ならびにその敷地および附属施設の管理を行うための区分所有者の団体（管理組合）は、区分所有者全員で構成される。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11048,
        "shikenId": 21,
        "parentNo": 1,
        "no": 48,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の取得に係る税金に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "不動産取得税は、相続により不動産を取得した場合は課されるが、贈与により不動産を取得した場合は課されない。",
        "choice2": "登録免許税は、建物を新築した場合の建物表題登記であっても課される。",
        "choice3": "登録免許税は、贈与により不動産を取得した場合の所有権移転登記では課されない。",
        "choice4": "一定の要件を満たす戸建て住宅（認定長期優良住宅を除く）を新築した場合、不動産取得税の課税標準の算定に当たっては、１戸につき最高1,200万円を価格から控除することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11049,
        "shikenId": 21,
        "parentNo": 1,
        "no": 49,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産賃貸に係る所得税に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "アパート等の貸付けが不動産所得における事業的規模であるかどうかの判定において 、貸与することができる独立した室数がおおむね10以上であれば、特に反証がない限り、事業的規模として取り扱われる。",
        "choice2": "不動産所得に係る総収入金額を計算する場合において、契約により支払日が定められている賃貸料は、原則として、その定められた支払日が収入すべき時期となる。",
        "choice3": "不動産所得の金額の計算上、2026年中に取得した建物を同年中に貸し付けた場合の当該建物の減価償却費の計算においては、定額法または定率法の選択が可能である。",
        "choice4": "不動産所得の金額の計算上、当該不動産所得に係る所得税および住民税の額は必要経費に算入されない。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11050,
        "shikenId": 21,
        "parentNo": 1,
        "no": 50,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "不動産の投資判断の手法等に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "ＮＰＶ法（正味現在価値法）による投資判断においては、対象不動産から得られる収益の現在価値の合計額が投資額を上回っている場合、その投資は有利であると判定することができる。",
        "choice2": "ＤＣＦ法は、対象不動産の一期間の純収益を還元利回りで還元して対象不動産の収益価格を求める手法である。",
        "choice3": "ＤＳＣＲ（借入金償還余裕率）は、対象不動産から得られる収益による借入金の返済余裕度を評価する指標であり、対象不動産に係る当該指標の数値が1.0を下回っている場合は、対象不動産から得られる収益だけで借入金を返済することができる。",
        "choice4": "ＮＯＩ利回り（純利回り）は、対象不動産から得られる年間の総収入額を総投資額で除して算出される利回りであり、不動産の収益性を測る指標である。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11051,
        "shikenId": 21,
        "parentNo": 1,
        "no": 51,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の贈与に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "定期贈与は、贈与者または受贈者のいずれか一方が生存している限り、その効力を失うことはない。",
        "choice2": "書面によらない贈与は、その履行の終わった部分を除き、各当事者が解除をすることができる。",
        "choice3": "死因贈与は、民法の遺贈に関する規定が準用されるため、書面によってしなければならない。",
        "choice4": "贈与は、当事者の一方が、ある財産を無償で相手方に与える意思表示をすることにより効力が生じ、相手方が受諾する必要はない。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11052,
        "shikenId": 21,
        "parentNo": 1,
        "no": 52,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続時精算課税制度（以下「本制度」という）に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "本制度の適用を受けることを選択した場合、その選択をした年分以後、その選択に係る贈与者から贈与により取得した財産については、暦年課税に変更することができない。",
        "choice2": "本制度において、贈与者および受贈者の年齢が適用要件を満たすかどうかは、贈与があった年の１月１日現在の年齢で判定する。",
        "choice3": "本制度の適用を受けた贈与財産に係る贈与税額の計算上、適用される税率は、一律25％である。",
        "choice4": "本制度の選択に係る贈与者が死亡した場合における相続税額の計算上、相続税額からすでに納めた本制度に係る贈与税相当額を控除してもなお控除しきれない金額は、相続税の申告により還付を受けることができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11053,
        "shikenId": 21,
        "parentNo": 1,
        "no": 53,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "贈与税の配偶者控除（以下「本控除」という）に関する次の記述のうち、最も不適切なものはどれか。なお、各選択肢において、ほかに必要とされる要件等はすべて満たしているものとする。",
        "choice1": "配偶者から受けた贈与について、贈与税の配偶者控除の適用を受けたことがある場合、その後、同一の配偶者から贈与を受けても、再び本控除の適用を受けることはできない。",
        "choice2": "本控除の適用を受けるためには、贈与者である配偶者との婚姻期間が贈与を受けた日の属する年の１月１日において20年以上でなければならない。",
        "choice3": "配偶者からの贈与について本控除の適用を受け、その翌年に当該配偶者が死亡した場合、当該配偶者に係る相続税額の計算上、本控除の適用を受けた財産のうち、本控除により控除された金額に相当する部分は相続税の課税価格に加算されない。",
        "choice4": "居住用不動産である家屋およびその敷地のうち、敷地のみの贈与を受けた場合であっても、本控除の適用を受けることができる。",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 11054,
        "shikenId": 21,
        "parentNo": 1,
        "no": 54,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "民法上の相続分に関する次の記述のうち、最も不適切なものはどれか。なお、記載のない事項については考慮しないものとする。",
        "choice1": "共同相続人の１人が遺産の分割前にその相続分を共同相続人以外の第三者に譲り渡した場合、他の共同相続人は、当該第三者に対して一定期間内にその価額および費用を支払うことで、その相続分を譲り受けることができる。",
        "choice2": "養子の法定相続分は、実子の法定相続分と同じである。",
        "choice3": "被相続人の兄弟姉妹が相続人である場合において、当該兄弟姉妹のうち被相続人の相続開始以前に死亡した者がいるときは、その死亡した者の子が代襲して相続人となる。",
        "choice4": "相続人が複数いる場合、各共同相続人は、被相続人の遺言により相続分や遺産分割方法の指定がされていなければ、法定相続分どおりに相続財産を分割しなければならない。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11055,
        "shikenId": 21,
        "parentNo": 1,
        "no": 55,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "遺産分割協議に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "遺産を現物分割する旨の遺産分割協議書を作成する際に、一定の場合を除き、遺産の一部についてのみ定めた遺産分割協議書を作成することができる。",
        "choice2": "遺産分割協議書は、民法で定められた形式に従って作成し、かつ、共同相続人全員が署名・捺印していなければ無効となる。",
        "choice3": "遺産分割協議書は、相続人が相続の開始があったことを知った日の翌日から10ヵ月以内に作成し、家庭裁判所に提出しなければならない。",
        "choice4": "適法に成立した遺産分割協議については、共同相続人全員の合意があったとしても、当該協議を解除し、再度、遺産分割協議を行うことはできない。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11056,
        "shikenId": 21,
        "parentNo": 1,
        "no": 56,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税における取引相場のない株式の評価に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "同族株主のいる会社において、同族株主以外の株主が取得した株式は、その会社規模にかかわらず、原則として、配当還元方式によって評価する。",
        "choice2": "会社規模が小会社である会社の株式の価額は、純資産価額方式によって評価し、類似業種比準方式と純資産価額方式の併用方式によって評価することはできない。",
        "choice3": "会社規模が中会社である会社の株式の価額は、類似業種比準方式、または純資産価額方式のいずれかによって評価する。",
        "choice4": "同族株主が取得した土地保有特定会社に該当する会社の株式は、原則として、類似業種比準方式によって評価する。",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 11057,
        "shikenId": 21,
        "parentNo": 1,
        "no": 57,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "相続税の計算に関する次の記述のうち、最も適切なものはどれか。なお、本問において、相続の放棄をした者はいないものとする。",
        "choice1": "遺産に係る基礎控除額の計算上、法定相続人の数に含めることができる養子（実子とみなされる者を除く）の数は、実子がいる場合、２人に制限される。",
        "choice2": "相続人となるべき被相続人の子がすでに死亡しているため、その死亡した子を代襲して相続人となった被相続人の孫は、相続税額の２割加算の対象者となる。",
        "choice3": "相続人が被相続人の配偶者のみである場合、「配偶者に対する相続税額の軽減」の適用を受けた配偶者については、相続により取得した遺産額の多寡にかかわらず、納付すべき相続税額が生じない。",
        "choice4": "「配偶者に対する相続税額の軽減」の適用を受けることができる配偶者は、被相続人と法律上の婚姻の届出をした者に限られず、いわゆる内縁の配偶者も含まれる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11058,
        "shikenId": 21,
        "parentNo": 1,
        "no": 58,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "宅地および宅地の上に存する権利の相続税における評価に関する次の記述のうち、最も不適切なものはどれか。なお、評価の対象となる宅地は、借地権（建物等の所有を目的とする地上権または土地の賃借権）の設定に際し、その設定の対価として通常権利金その他の一時金を支払う「借地権の取引慣行のある地域」にあるものとする。また、宅地の上に存する権利は、定期借地権および一時使用目的の借地権等を除くものとする。",
        "choice1": "Ａさんが、所有する宅地の上にアパートを建築して賃貸の用に供していた場合において、Ａさんの相続が開始したときは、相続税額の計算上、その宅地の価額は貸家建付地として評価する。",
        "choice2": "Ｂさんが、借地権の設定に際して通常の権利金を支払って賃借した宅地の上にＢさん名義の自宅を建築して居住の用に供していた場合において、Ｂさんの相続が開始したときは、相続税額の計算上、その宅地の上に存するＢさんの権利の価額は、借地権として評価する。",
        "choice3": "Ｃさんが、借地権の設定に際して通常の権利金を支払って賃借した宅地の上にＣさん名義のアパートを建築して賃貸の用に供していた場合において、Ｃさんの相続が開始したときは、相続税額の計算上、その宅地の上に存するＣさんの権利の価額は、貸家建付借地権として評価する。",
        "choice4": "Ｄさんが、従前宅地であった土地を車庫などの施設がない青空駐車場（月極駐車場）の用に供していた場合において、Ｄさんの相続が開始したときは、相続税額の計算上、その土地の価額は貸宅地として評価する。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11059,
        "shikenId": 21,
        "parentNo": 1,
        "no": 59,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "遺言に関する次の記述のうち、最も適切なものはどれか。",
        "choice1": "共同相続人のうち一部の者についてのみ相続分を指定する内容の遺言は無効となる。",
        "choice2": "遺言執行者を指定する内容の遺言は無効となる。",
        "choice3": "共同相続人の遺留分を侵害する内容の遺言は無効となる。",
        "choice4": "被相続人は、遺言で、遺産分割の方法を定めることを第三者に委託することができる。",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 11060,
        "shikenId": 21,
        "parentNo": 1,
        "no": 60,
        "groupId": 1,
        "answerType": 1,
        "inputType": 1,
        "question1": "",
        "question2": "会社法に関する次の記述のうち、最も不適切なものはどれか。",
        "choice1": "定時株主総会は、毎事業年度終了後一定の時期に招集しなければならないが、臨時株主総会は、必要がある場合にいつでも招集することができる。",
        "choice2": "株式会社において株主は、その有する株式の引受価額を限度として責任を負う。",
        "choice3": "すべての株式会社は、取締役会を置かなければならない。",
        "choice4": "取締役は、いつでも、株主総会の決議によって解任することができる。",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 11061,
        "shikenId": 21,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、Ａさんが受給することができる公的年金制度からの老齢給付について説明した。Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な数値を入力しなさい。計算にあたっては、《設例》の＜Ａさんとその家族に関する資料＞および下記の＜資料＞に基づくこと。なお、年金額は2026年度価額に基づいて計算し、年金額の端数処理は円未満を四捨五入すること。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>Ⅰ<br>「Ａさんが65歳に達すると、老齢基礎年金および老齢厚生年金の受給権が発生します。Ａさんが65歳から受給することができる老齢基礎年金の額は（ ① ）円となります」<br><br>Ⅱ<br>「Ａさんが65歳から受給することができる老齢厚生年金の額は（ ② ）円となります。なお、老齢厚生年金の額に加算される配偶者に係る加給年金額は、受給権者の厚生年金保険の被保険者期間が（ ③ ）年以上あること等が要件です」<br><br><img src=\"/img/question/21_1_1781050765970367_1.png\" class=\"question-img\" />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "年",
        "choice4": "",
        "choice5": "",
        "answer": "783753,1036248,20",
        "score": "1,1,1",
        "image": "2q-kojin-b-1.png"
    },
    {
        "id": 11062,
        "shikenId": 21,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、公的年金制度等の各種取扱いについて説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「Ａさんは、老齢基礎年金および老齢厚生年金の繰下げ支給の申出をすることができますが、老齢厚生年金の繰下げ支給の申出をする場合は、老齢基礎年金の繰下げ支給の申出も同時にしなければなりません」<br>② 「Ａさんが老後の収入を増やすために、個人事業主となった後に国民年金基金に加入した場合、掛金は小規模企業共済等掛金控除として所得控除の対象となります」<br>③ 「Ａさんが老後の収入を増やすために、個人事業主となった後に確定拠出年金の個人型年金に加入した場合でも、小規模企業共済制度と併用することができます」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": "2q-kojin-b-1.png"
    },
    {
        "id": 11063,
        "shikenId": 21,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、老後の収入を増やすための各種制度について説明した。Ｍさんが説明した以下の文章の空欄①〜④に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選びなさい。<br><br>Ⅰ<br>「国民年金の第１号被保険者になる予定のＡさんは、所定の手続により、国民年金の定額保険料に加えて、国民年金の付加保険料の（ ① ）円を納付することができます。仮に、Ａさんが付加保険料を178月納付し、65歳から老齢基礎年金を受け取る場合、老齢基礎年金の額に付加年金として（ ② ）円が上乗せされます」<br><br>Ⅱ<br>「国民年金基金は、老齢基礎年金に上乗せする年金を支給する任意加入の年金制度です。国民年金基金への加入は口数制となっており、１口目は保証期間のある終身年金Ａ型、保証期間のない終身年金Ｂ型の２種類のなかからの選択となります。掛金の額は、加入者が選択した給付の型や口数、加入時の年齢等で決まり、2026年12月分以後において、掛金の拠出限度額は月額（ ③ ）円となります。なお、確定拠出年金の個人型年金に加入している場合は、その掛金と合わせて月額（ ③ ）円が上限となります。また、国民年金基金に加入した場合は国民年金の付加保険料を納付することはできません」<br><br>Ⅲ<br>「小規模企業共済制度は、個人事業主が廃業等をした場合に必要となる生活資金などを準備しておくための共済制度です。毎月の掛金は、（ ④ ）円から70,000円の範囲内（500円単位）で選択できます」<br><br><img src=\"/img/question/21_3_1781050766441881_2.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ロ,ホ,ヌ,ニ",
        "score": "1,1,1,1",
        "image": "2q-kojin-b-1.png"
    },
    {
        "id": 11064,
        "shikenId": 21,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "《設例》の＜Ｘ社株式およびＹ社株式の情報＞および＜Ｘ社およびＹ社の財務データ＞に基づいて算出される次の①〜③を求めなさい。〈答〉は表示単位の小数点以下第３位を四捨五入し、小数点以下第２位までを解答すること。<br>① Ｘ社のＲＯＥ<br>② Ｘ社のＰＥＲ<br>③ Ｘ社の配当性向",
        "choice1": "％",
        "choice2": "倍",
        "choice3": "％",
        "choice4": "",
        "choice5": "",
        "answer": "11.32,10,39.17",
        "score": "1,1,1",
        "image": "2q-kojin-b-2.png"
    },
    {
        "id": 11065,
        "shikenId": 21,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、Ｘ社株式の購入について説明した。Ｍさんが説明した以下の文章の空欄①〜④に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。なお、売買委託手数料等は考慮しないものとする。<br><br>Ⅰ<br>「Ａさんが特定口座（源泉徴収選択口座）において、Ｘ社株式を購入し、その配当金を特定口座に受け入れた場合、所得税および復興特別所得税と住民税の合計で、配当金額の（ ① ）％相当額が源泉徴収等されます。ＡさんがＸ社株式の次回の配当金を受け取るためには、権利付き最終日である６月（ ② ）までにＸ社株式を購入する必要があります」<br>Ⅱ<br>「Ａさんが特定口座（源泉徴収選択口座）において、仮にＸ社株式を株価3,000円で100株購入し、同年中に株価4,800円で全株売却した場合、所得税および復興特別所得税と住民税の合計で、譲渡益に対して（ ③ ）円相当額が源泉徴収等されます。また、譲渡損失が生じ、同年中にＸ社株式の配当金を特定口座に受け入れた場合、譲渡損失の金額と配当金額は特定口座内で損益通算されます。なお、控除しきれない上場株式等の譲渡損失の金額については、確定申告をすることにより、翌年以降（ ④ ）年間の繰越控除が可能です」<br><img src=\"/img/question/21_5_1781050766556383_3.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ|ル|ヲ|ワ|カ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ワ,ト,ヌ,ハ",
        "score": "1,1,1,1",
        "image": "2q-kojin-b-2.png"
    },
    {
        "id": 11066,
        "shikenId": 21,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、Ｘ社株式の購入について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「Ｘ社株式のＰＢＲは、約1.13倍です。一般に、ＰＢＲが高いほうが株価は割高と判断されますが、何倍程度が妥当であるかは、同業他社との比較や過去のトレンドを確認するなど、相対的な数値として捉えることが大切です」<br>② 「Ｘ社株式を購入する場合、ＮＩＳＡ（成長投資枠）を利用することができます。2026年中にＮＩＳＡ勘定に受け入れることができる限度額（非課税投資枠）は年間100万円です」<br>③ 「上場株式の注文方法のうち、指値注文では、低い値段の買い注文が高い値段の買い注文に優先し、原則として、同じ値段の注文については、先に出された注文が後に出された注文に優先して売買が成立します」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "2q-kojin-b-2.png"
    },
    {
        "id": 11067,
        "shikenId": 21,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの所得税の確定申告等に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「医療費控除については、給与所得者の場合、年末調整で適用を受けることができるため、医療費控除の適用を受けるために、所得税の確定申告をする必要はありません」<br>② 「Ａさんは不動産所得の金額に損失が生じているため、確定申告をすることによって、純損失の繰越控除を受けることができます」<br>③ 「Ａさんが、『退職所得の受給に関する申告書』を勤務先に提出する場合、退職金の支給の際に退職金の額の20.42％の所得税および復興特別所得税が源泉徴収されますが、確定申告をすることにより、当該税額を精算することができます」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "2q-kojin-b-3.png"
    },
    {
        "id": 11068,
        "shikenId": 21,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんが勤務先から受け取る退職金に係る退職所得の金額を計算した次の〈計算の手順〉の空欄①〜③に入る最も適切な数値を入力しなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>〈計算の手順〉<br>１．退職所得控除額<br>（ ① ）万円＋□□□万円×｛（ ② ）年－20年｝＝□□□万円<br>２．退職所得の金額<br>（2,200万円－□□□万円）×□□□＝（ ③ ）万円",
        "choice1": "万円",
        "choice2": "年",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "800,36,140",
        "score": "1,1,1",
        "image": "2q-kojin-b-3.png"
    },
    {
        "id": 11069,
        "shikenId": 21,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税における課税総所得金額を計算した下記の表の空欄①〜③に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/21_9_1781050766687814_4.png\" class=\"question-img\" /><br><img src=\"/img/question/21_9_1781050766905965_5.png\" class=\"question-img\" /><br><img src=\"/img/question/21_9_1781050767092131_6.png\" class=\"question-img\" /><br><img src=\"/img/question/21_9_1781050767307429_7.png\" class=\"question-img\" />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "",
        "choice5": "",
        "answer": "5770000,380000,1210000",
        "score": "2,1,1",
        "image": "2q-kojin-b-3.png"
    },
    {
        "id": 11070,
        "shikenId": 21,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "甲土地上に建物を建てる場合の建築基準法上の規制に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「防火地域内においては、原則として、地階を含む階数が３以上または延べ面積が100㎡を超える建築物は耐火建築物等としなければならないとされています」<br>② 「建て替える賃貸アパートの最大延べ面積は、3,750㎡です」<br>③ 「建て替える賃貸アパートが耐火建築物である場合、当該建築物の最大建築面積は750㎡です」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "2,1,1",
        "image": "2q-kojin-b-4.png"
    },
    {
        "id": 11071,
        "shikenId": 21,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 2,
        "inputType": 7,
        "question1": "",
        "question2": "甲土地の有効活用に関する以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。<br><br>Ⅰ<br>「Ａさんが甲土地に賃貸マンションを建設した場合、相続税額の計算上、甲土地は貸家建付地として評価されます。仮に、甲土地の自用地価額を１億円、借地権割合70％、借家権割合30％、賃貸割合100％とした場合の相続税評価額は（ ① ）万円となります。また、当該敷地が貸付事業用宅地等に該当すれば、貸家建付地としての評価額に対して、『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができます。貸付事業用宅地等は、200㎡までの部分について（ ② ）％の減額が受けられますが、相続開始前３年以内に新たに貸付事業の用に供された宅地等は対象外となっています」<br><br>Ⅱ<br>「賃貸マンションを建設する方法として（ ③ ）方式という手法があります。この方式は、Ａさんが所有する甲土地の上に、事業者が建設資金を負担してマンション等を建設し、完成した区分所有建物とその敷地の共有持分をＡさんと事業者がそれぞれの出資割合に応じて取得する手法です。Ａさんとしては自己資金を使わず、収益物件を取得できるという点にメリットがあります」<br><br><img src=\"/img/question/21_11_1781050767581495_8.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ|リ|ヌ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ト,イ,ヌ",
        "score": "1,1,1",
        "image": "2q-kojin-b-4.png"
    },
    {
        "id": 11072,
        "shikenId": 21,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "借地借家法の事業用定期借地権等に係る借地契約に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「事業用定期借地権等は、事業用に限定して土地を定期で貸し出す方式で、居住の用に供する賃貸マンションの事業運営を目的とする設定契約を締結することができます」<br>② 「事業用定期借地権等は、存続期間が10年以上20年未満の事業用借地権と、20年以上50年未満の事業用定期借地権に区別されます」<br>③ 「事業用定期借地権等の設定契約は、公正証書で行う必要があります」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": "2q-kojin-b-4.png"
    },
    {
        "id": 11073,
        "shikenId": 21,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "「直系尊属から住宅取得等資金の贈与を受けた場合の贈与税の非課税」（以下、「本特例」という）に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「本特例は、暦年課税の基礎控除または相続時精算課税制度の特別控除と併用して適用を受けることができます」<br>② 「2026年中に長女Ｄさんが本特例の適用を受ける場合、贈与を受けた年分の長女Ｄさんの合計所得金額が1,000万円以下であるときは、取得する住宅用家屋の床面積の要件は、40㎡以上240㎡以下となります」<br>③ 「住宅用家屋の取得等に係る契約の締結日が2026年１月１日から2026年12月31日であり、消費税率10％により住宅用家屋を取得し所定の要件を満たした場合、本特例の非課税限度額は省エネ等住宅で最高1,200万円、一般住宅で最高700万円となります」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2",
        "score": "1,1,1",
        "image": "2q-kojin-b-5.png"
    },
    {
        "id": 11074,
        "shikenId": 21,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 2,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの相続等に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「遺言により、相続財産の大半を妻Ｂさんおよび長男Ｃさんが相続した場合、長女Ｄさんの遺留分を侵害するおそれがあります。仮に、遺留分算定の基礎となる財産を３億5,000万円とした場合、長女Ｄさんの遺留分の金額は4,375万円となります」<br>② 「遺産分割をめぐる争いを防ぐ手段として、遺言書の作成をお勧めします。公正証書遺言は、証人２人以上の立会いのもと、遺言者が遺言の趣旨を公証人に口授し、公証人が作成しますが、相続開始後遅滞なく検認を行う必要があります」<br>③ 「妻Ｂさんが『配偶者に対する相続税額の軽減』の適用を受けた場合、妻Ｂさんが相続により取得した財産の合計額が、法定相続分または１億6,000万円とのいずれか少ない金額までであれば、相続税額は算出されません」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2",
        "score": "1,1,1",
        "image": "2q-kojin-b-5.png"
    },
    {
        "id": 11075,
        "shikenId": 21,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 2,
        "inputType": 5,
        "question1": "",
        "question2": "現時点（2026年９月１日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①〜③に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は３億5,000万円とし、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/21_15_1781050767706282_9.png\" class=\"question-img\" /><br><img src=\"/img/question/21_15_1781050767897577_10.png\" class=\"question-img\" />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "4800,1565,7470",
        "score": "1,1,2",
        "image": "2q-kojin-b-5.png"
    },
    {
        "id": 11076,
        "shikenId": 21,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "はじめに、Ｍさんは、Ａさんに対して、公的年金保険料の納付および受給について説明した。<br>Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。<br>「2003年３月以前に、Ａさんが納付した厚生年金保険料の平均標準報酬月額は、その間に支給された賞与の額を（ ① ）平均月収の額となります。<br>Ａさんが65歳から公的年金の老齢給付の受給をするにあたり、年金の支払いは、原則として（ ② ）の（ ③ ）日にそれぞれ前２ヵ月分が支払われます。」<br><img src=\"/img/question/21_1_1781050843612298_1.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ロ,ハ,ヘ",
        "score": "1,1,1",
        "image": "2q-hoken-b-1.png"
    },
    {
        "id": 11077,
        "shikenId": 21,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんに対して、定年退職後の社会保険の各種取扱い等について説明した。<br>Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「Ａさんは、国民健康保険に加入する以外に、所定の手続により、退職日の翌日から最長で２年間、全国健康保険協会管掌健康保険に任意継続被保険者として加入することができ、退職前と同様に保険料の負担割合はＸ社とＡさんの折半になります」<br>② 「Ａさんが定年退職後に高年齢求職者給付金の受給要件を満たしている場合、高年齢求職者給付金の額は、基本手当日額の50日分となります」<br>③ 「Ａさんが定年退職によって厚生年金保険の被保険者でなくなった場合、妻Ｂさんは、国民年金の第３号被保険者から第１号被保険者への種別変更の届出を行い、国民年金の保険料を納付することになります」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": "2q-hoken-b-1.png"
    },
    {
        "id": 11078,
        "shikenId": 21,
        "parentNo": 1,
        "no": 3,
        "groupId": 1,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "最後に、Ｍさんは、Ａさんに対して、Ａさんが65歳以後に受給することができる公的年金制度からの老齢給付の額について計算した。Ａさんが、原則として65歳から受給することができる老齢基礎年金および老齢厚生年金の年金額（2026年度価額）を計算した次の〈計算の手順〉の空欄①〜④に入る最も適切な数値を入力しなさい。なお、計算にあたっては、《設例》の＜Ａさん夫妻に関する資料＞および下記の＜資料＞に基づくこと。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/21_3_1781050843806764_2.png\" class=\"question-img\" /><br><img src=\"/img/question/21_3_1781050844099845_3.png\" class=\"question-img\" />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "785518,1239786,62162,1725648",
        "score": "1,1,1,1",
        "image": "2q-hoken-b-1.png"
    },
    {
        "id": 11079,
        "shikenId": 21,
        "parentNo": 1,
        "no": 4,
        "groupId": 2,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "はじめに、Ｍさんは、《設例》の＜資料１＞および＜資料２＞の生命保険の保障内容等について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「Ａさんが病気やケガ等で重度の障害状態となって働けなくなった場合、通常の生活費に加え、療養費等の出費もかさみ、支出が収入を上回る可能性があります。就業不能サポート特約は、就業不能時の収入減少に備えることができる保険であるため、加入することは検討に値します」<br>② 「先進医療特約では、契約を締結した時点において厚生労働大臣により定められている先進医療が給付の対象となります」<br>③ 「提案を受けている無配当終身介護保障保険の保険料払込期間を有期払込にすると、毎月の保険料負担は増加します。毎月の保険料負担を軽減するためには、終身払込を選択することをお勧めします」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1",
        "score": "1,1,1",
        "image": "2q-hoken-b-2.png"
    },
    {
        "id": 11080,
        "shikenId": 21,
        "parentNo": 1,
        "no": 5,
        "groupId": 2,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "次に、Ｍさんは、Ａさんに対して、公的介護保険（以下、「介護保険」という）について説明した。Ｍさんが説明した次の記述①〜④について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「介護保険の被保険者は、65歳以上の第１号被保険者と35歳以上65歳未満の医療保険加入者である第２号被保険者に区分されます。保険給付を受けるためには、市町村（特別区を含む）から要介護認定または要支援認定を受ける必要があります」<br>② 「介護保険の第２号被保険者が、保険給付を受けた場合の自己負担割合は、原則として１割となりますが、一定以上の所得を有する第２号被保険者については２割もしくは３割負担となります」<br>③ 「介護保険の第１号被保険者が、公的年金制度から年額18万円以上の老齢年金を受給している場合、介護保険料は原則として公的年金から特別徴収されます」<br>④ 「介護保険の第１号被保険者は、要介護状態となった原因が交通事故であった場合、介護給付または予防給付を受けることができません」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "image": "2q-hoken-b-2.png"
    },
    {
        "id": 11081,
        "shikenId": 21,
        "parentNo": 1,
        "no": 6,
        "groupId": 2,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "最後に、Ｍさんは、《設例》の＜資料１＞の生命保険の課税関係について説明した。Ｍさんが説明した以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>「＜資料１＞の５年ごと配当付終身保険の支払保険料のうち、終身保険に係る保険料は（ ① ）控除の対象となり、就業不能サポート特約、総合医療特約および先進医療特約に係る保険料は（ ② ）控除の対象となります。それぞれの控除限度額は、所得税で（ ③ ）円、住民税で□□□円です」<br><br><img src=\"/img/question/21_6_1781050844670827_4.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "ヘ,ト,ハ",
        "score": "1,1,1",
        "image": "2q-hoken-b-2.png"
    },
    {
        "id": 11082,
        "shikenId": 21,
        "parentNo": 1,
        "no": 7,
        "groupId": 3,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "仮に、Ａさんが役員在任期間（勤続年数）37年４ヵ月でＸ社を退任し、Ｘ社が役員退職金として5,000万円支給した場合、Ａさんが受け取る役員退職金に係る退職所得の金額を計算した下記の計算式の空欄①〜④に入る最も適切な数値を入力しなさい。なお、Ａさんは、これ以外に退職手当等の収入はなく、障害者になったことが退職の直接の原因ではないものとする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/21_7_1781050844851864_5.png\" class=\"question-img\" />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "",
        "answer": "800,70,2060,1470",
        "score": "1,1,1,1",
        "image": "2q-hoken-b-3.png"
    },
    {
        "id": 11083,
        "shikenId": 21,
        "parentNo": 1,
        "no": 8,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、法人契約による定期保険の保険料に係る経理処理について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「2019年６月28日に発遣された『定期保険等の保険料に相当多額の前払部分の保険料が含まれる場合の取扱い』に関する通達（以下、「当該通達」という）によると、最高解約返戻率が50％超70％以下の契約については、保険期間の前半４割に相当する期間に、当期分支払保険料の40％を資産に計上します」<br>② 「当該通達によると、最高解約返戻率が85％を超える契約については『当期分支払保険料×最高解約返戻率×70％（保険期間開始日から10年を経過する日までは90％）』の算式により、資産計上額が決定されます」<br>③ 「Ａさんが現在加入している無配当逓増定期保険の2026年９月に支払う保険料について、当該通達の規定は適用されません」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,1",
        "score": "1,1,1",
        "image": "2q-hoken-b-3.png"
    },
    {
        "id": 11084,
        "shikenId": 21,
        "parentNo": 1,
        "no": 9,
        "groupId": 3,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ｍさんは、Ａさんに対して、＜資料１＞の無配当逓増定期保険について説明した。Ｍさんが説明した次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「当該生命保険の単純返戻率（解約返戻金額÷払込保険料累計額）は、保険期間中は継続して上昇し、保険期間満了時にピークを迎えます」<br>② 「仮に、現時点で当該生命保険を解約した場合、保険期間のうち当初６割期間内での解約であるため、解約時の資産計上額である3,200万円との差額である600万円を雑損失として経理処理します」<br>③ 「勇退時に当該生命保険を払済終身保険に変更し、契約者および死亡保険金受取人をＡさんの配偶者等に名義変更することで、終身保険契約を役員退職金の一部として現物支給することができます」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": "2q-hoken-b-3.png"
    },
    {
        "id": 11085,
        "shikenId": 21,
        "parentNo": 1,
        "no": 10,
        "groupId": 4,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税の計算における所得控除等に関する以下の文章の空欄①および②に入る最も適切な数値を、下記の〈数値群〉のなかから選び、その記号を選びなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><br>Ⅰ<br>「妻Ｂさんの合計所得金額は62万円以下となりますので、Ａさんは配偶者控除の適用を受けることができます。Ａさんが適用を受けることができる配偶者控除の控除額は（ ① ）万円となります」<br><br>Ⅱ<br>「Ａさんのように給与等の収入金額が（ ② ）万円を超え、23歳未満の扶養親族がいる場合、総所得金額の計算上、給与等の収入金額（1,000万円を超える場合は1,000万円）から（ ② ）万円を控除した金額の□□□％相当額を給与所得の金額から控除することができます」<br><br><img src=\"/img/question/21_10_1781050845030988_6.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "イ,ホ",
        "score": "1,1",
        "image": "2q-hoken-b-4.png"
    },
    {
        "id": 11086,
        "shikenId": 21,
        "parentNo": 1,
        "no": 11,
        "groupId": 4,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税の課税等に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選択しなさい。<br><br>① 「仮にＡさんが2026年２月に死亡し、養老保険の死亡保険金を妻Ｂさんが受け取った場合、当該死亡保険金は贈与税の課税対象となります」<br>② 「Ａさんが受け取った一時払終身保険の解約返戻金は、契約から５年以内の解約ですが、金融類似商品に該当せず、総合課税の対象となります」<br>③ 「ふるさと納税による所得税の寄附金控除の適用を受けるためには、原則として確定申告が必要ですが、１年間の寄附先が５自治体以下などの一定の要件を満たすことにより、確定申告をしなくても寄附金控除の適用を受けられるワンストップ特例制度があります」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": "2q-hoken-b-4.png"
    },
    {
        "id": 11087,
        "shikenId": 21,
        "parentNo": 1,
        "no": 12,
        "groupId": 4,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "Ａさんの2026年分の所得税の算出税額を計算した下記の表の空欄①〜④に入る最も適切な数値を求めなさい。なお、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/21_12_1781050845198966_7.png\" class=\"question-img\" /><br><img src=\"/img/question/21_12_1781050845536572_8.png\" class=\"question-img\" /><br><img src=\"/img/question/21_12_1781050845795307_9.png\" class=\"question-img\" />",
        "choice1": "円",
        "choice2": "円",
        "choice3": "円",
        "choice4": "円",
        "choice5": "",
        "answer": "250000,1010000,620000,512500",
        "score": "1,1,1,2",
        "image": "2q-hoken-b-4.png"
    },
    {
        "id": 11088,
        "shikenId": 21,
        "parentNo": 1,
        "no": 13,
        "groupId": 5,
        "answerType": 3,
        "inputType": 5,
        "question1": "",
        "question2": "現時点（2026年９月１日）において、Ａさんの相続が開始した場合における相続税の総額を試算した下記の表の空欄①〜④に入る最も適切な数値を求めなさい。なお、相続税の課税価格の合計額は４億4,000万円とする。また、問題の性質上、明らかにできない部分は「□□□」で示してある。<br><img src=\"/img/question/21_13_1781050846066864_10.png\" class=\"question-img\" /><br><img src=\"/img/question/21_13_1781050846354688_11.png\" class=\"question-img\" />",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "万円",
        "choice5": "",
        "answer": "4800,6140,2240,10620",
        "score": "1,1,1,1",
        "image": "2q-hoken-b-5.png"
    },
    {
        "id": 11089,
        "shikenId": 21,
        "parentNo": 1,
        "no": 14,
        "groupId": 5,
        "answerType": 3,
        "inputType": 6,
        "question1": "",
        "question2": "「非上場株式等についての贈与税の納税猶予及び免除の特例」（以下、「本特例」という）に関する次の記述①〜③について、適切なものは○を、不適切なものは×を選びなさい。<br><br>① 「本特例の適用を受けた場合、本特例の対象となる非上場株式等の贈与に係る贈与税額の80％が猶予されます」<br>② 「本特例の対象となる贈与者は代表権を有しているＡさんに限られますので、長男ＣさんがＡさんおよび妻ＢさんからＸ社株式の贈与を受けた場合、妻Ｂさんから贈与を受けたＸ社株式は本特例の適用の対象となりません」<br>③ 「長男ＣさんがＡさんからＸ社株式の贈与を受けた場合、本特例による納税猶予の対象となる株式は、長男Ｃさんがその受贈前から既に保有していたＸ社株式を含めて、発行済議決権株式総数の３分の２に達するまでの部分に限られます」",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2",
        "score": "1,1,1",
        "image": "2q-hoken-b-5.png"
    },
    {
        "id": 11090,
        "shikenId": 21,
        "parentNo": 1,
        "no": 15,
        "groupId": 5,
        "answerType": 3,
        "inputType": 7,
        "question1": "",
        "question2": "Ａさんの相続等に関する以下の文章の空欄①〜③に入る最も適切な語句または数値を、下記の〈語句群〉のなかから選び、その記号を選びなさい。<br><br>Ⅰ<br>「円滑な遺産分割のための手段として遺言書の作成が考えられます。公正証書遺言は遺言の紛失や改ざんのおそれがありません。公正証書遺言を作成する場合、後継者の長男Ｃさんは証人になることが（ ① ）」<br><br>Ⅱ<br>「自宅の敷地および建物を妻Ｂさんが相続により取得した場合、自宅の敷地は特定居住用宅地等として『小規模宅地等についての相続税の課税価格の計算の特例』の適用を受けることができます。特定居住用宅地等の対象となる限度面積は（ ② ）㎡です」<br><br>Ⅲ<br>「Ａさんが加入している一時払終身保険の死亡保険金は、みなし相続財産として相続税の課税対象となります。Ａさんの相続開始後、長男Ｃさんが受け取る死亡保険金5,000万円のうち、相続税の課税価格に算入される金額は（ ③ ）万円となります」<br><br><img src=\"/img/question/21_15_1781050846695397_12.png\" class=\"question-img\" />",
        "choice1": "イ|ロ|ハ|ニ|ホ|ヘ|ト|チ",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "チ,ホ,ロ",
        "score": "1,1,1",
        "image": "2q-hoken-b-5.png"
    },
    {
        "id": 12000,
        "shikenId": 21,
        "parentNo": 1,
        "no": 1,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "ファイナンシャル・プランニングのプロセスに従い、次の（ア）〜（カ）を６つのステップの順番に並べ替えたものとして、最も適切なものはどれか。<br><br>（ア）顧客の目標を達成するために必要なプランを作成し、顧客に提案書を提示して説明を行う。<br>（イ）顧客の家族構成などの環境の変化、税制や法律改正の内容を考慮し、定期的にプランの見直しを行う。<br>（ウ）顧客にファイナンシャル・プランニングで提供するサービス内容や報酬体系などを説明し、了解を得る。<br>（エ）作成したプランに従い、顧客が行う金融商品の購入、不動産売却等の実行を支援する。<br>（オ）面談やヒアリングシートにより顧客および家族の情報、財政的な情報等を収集し、顧客の財政的な目標を明確化する。<br>（カ）顧客のキャッシュフロー表などを作成し、将来の財政状況の予測・分析等を行う。<br><br>1）（ウ）→（オ）→（カ）→（ア）→（エ）→（イ）<br>2）（ウ）→（オ）→（カ）→（エ）→（ア）→（イ）<br>3）（オ）→（カ）→（ウ）→（ア）→（エ）→（イ）<br>4）（オ）→（カ）→（ウ）→（エ）→（ア）→（イ）",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 12001,
        "shikenId": 21,
        "parentNo": 1,
        "no": 2,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "「消費者契約法」に関する次の記述のうち、最も適切なものはどれか。<br><br>1）事業者が消費者に重要事項について事実と異なることを告げた場合であっても、消費者がそれを事実と信じて結んだ契約は、取り消すことができない。<br>2）消費者契約の申込み等に係る取消権は、原則として消費者が追認をすることができる時から１年間行わないとき、または契約締結の時から10年を経過したときは、時効によって消滅すると定められている。<br>3）事業者の債務不履行等により生じた、消費者の解除権を放棄させる条項は、不当性が高い条項として無効となる。<br>4）消費者契約法では、個人が事業として、または事業のために契約の当事者となる場合も保護の対象となる消費者と定められている。",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 12002,
        "shikenId": 21,
        "parentNo": 2,
        "no": 3,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "経済指標に関する下表の空欄（ア）、（イ）に関する次の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_3_1781050951421953_1.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は「消費者物価指数」である。<br>（イ）空欄（イ）にあてはまる語句は「実質」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1",
        "score": "1,1",
        "image": ""
    },
    {
        "id": 12003,
        "shikenId": 21,
        "parentNo": 2,
        "no": 4,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "個人向け国債（2027年１月発行分以降は個人向け国債プラス）に関する下表の（ア）〜（エ）にあてはまる語句または数値に関する次の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_4_1781050951768276_2.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は、「変動」である。<br>（イ）空欄（イ）にあてはまる語句は、「半年」である。<br>（ウ）空欄（ウ）にあてはまる数値は、「0.01」である。<br>（エ）空欄（エ）にあてはまる語句は、「２年」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12004,
        "shikenId": 21,
        "parentNo": 2,
        "no": 5,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "下記＜資料＞の外貨定期預金について、満期時の外貨ベースの元利合計額を円転した金額を計算しなさい。なお、計算結果（円転した金額）について円未満の端数が生じる場合は切り捨てること。<br><img src=\"/img/question/21_5_1781050952111230_3.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "816956",
        "score": "3",
        "image": ""
    },
    {
        "id": 12005,
        "shikenId": 21,
        "parentNo": 1,
        "no": 6,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記＜資料＞について、この企業の株価が1,880円である場合、2027年３月期通期の業績における次の記述の空欄（ア）、（イ）にあてはまる数値の組み合わせとして正しいものはどれか。なお、解答に当たっては、小数点以下第３位を四捨五入すること。<br><img src=\"/img/question/21_6_1781050952498906_4.png\" class=\"question-img\" /><br><img src=\"/img/question/21_6_1781050952975762_5.png\" class=\"question-img\" /><br><br>1）（ア）22.92  （イ）4.36<br>2）（ア）22.92  （イ）1.86<br>3）（ア） 0.87  （イ）1.86<br>4）（ア） 0.87  （イ）4.36",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 12006,
        "shikenId": 21,
        "parentNo": 2,
        "no": 7,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "藤木さんは、保有しているＧＲ投資信託（追加型国内公募株式投資信託）の収益分配金を2026年８月に受け取った。ＧＲ投資信託の運用状況が下記＜資料＞のとおりである場合、空欄（ア）、（イ）に関する次の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_7_1781050953169201_6.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は「普通分配金」である。<br>（イ）空欄（イ）にあてはまる数値は「12,520」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1",
        "score": "1,2",
        "image": ""
    },
    {
        "id": 12007,
        "shikenId": 21,
        "parentNo": 2,
        "no": 8,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "下記＜資料＞は、木下さんが購入を検討している中古マンションのインターネット上の広告（抜粋）である。この広告の内容等に関する次の（ア）〜（エ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_8_1781050953544349_7.png\" class=\"question-img\" /><br><br>（ア）この広告の物件を購入する場合、現在の区分所有者が管理費を滞納していると、新たな区分所有者となる木下さんは、滞納分の管理費の支払い義務を引き継ぐ。<br>（イ）この広告の物件の専有面積として記載されている壁芯面積は、登記簿上の内法面積より大きい。<br>（ウ）この物件を購入した場合、木下さんは管理組合の構成員になるかどうかを選択できる。<br>（エ）この物件のように、建物の敷地が２つの用途地域にまたがる場合、制限のより厳しい用途地域における用途制限が適用される。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,1,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12008,
        "shikenId": 21,
        "parentNo": 2,
        "no": 9,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "不動産取得税に関する下記の説明の空欄（ア）〜（エ）に関する次の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_9_1781050953899356_8.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は「市区町村」である。<br>（イ）空欄（イ）にあてはまる語句は「相続税評価額」である。<br>（ウ）空欄（ウ）にあてはまる語句は「相続」である。<br>（エ）空欄（エ）にあてはまる語句は「1,300万円」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12009,
        "shikenId": 21,
        "parentNo": 1,
        "no": 10,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "固定資産税に関する次の記述の空欄（ア）〜（エ）に入る語句の組み合わせとして、適切なものはどれか。<br><img src=\"/img/question/21_10_1781050954205424_9.png\" class=\"question-img\" /><br><br>1）（ア）市町村（東京23区は都）  （イ）１月１日  （ウ）200㎡  （エ）６分の１<br>2）（ア）市町村（東京23区は都）  （イ）７月１日  （ウ）240㎡  （エ）３分の１<br>3）（ア）都道府県         （イ）７月１日  （ウ）200㎡  （エ）６分の１<br>4）（ア）都道府県         （イ）１月１日  （ウ）240㎡  （エ）３分の１",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "1",
        "score": "1",
        "image": ""
    },
    {
        "id": 12010,
        "shikenId": 21,
        "parentNo": 2,
        "no": 11,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "建築基準法に従い、下記＜資料＞の土地に建築物を建てる場合の延べ面積（床面積の合計）の最高限度を計算しなさい。なお、記載のない条件は一切考慮しないものとする。<br><img src=\"/img/question/21_11_1781050954518523_10.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "㎡",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "900",
        "score": "3",
        "image": ""
    },
    {
        "id": 12011,
        "shikenId": 21,
        "parentNo": 2,
        "no": 12,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "被相続人の居住用財産（空き家）に係る譲渡所得の特別控除の特例（以下、「本特例」という）に関する以下の説明の空欄（ア）〜（ウ）に関する次の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_12_1781050954806818_11.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる数値は「4,000」である。<br>（イ）空欄（イ）にあてはまる数値は「３」である。<br>（ウ）空欄（ウ）にあてはまる数値は「１」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,1,1",
        "score": "1,1,1",
        "image": ""
    },
    {
        "id": 12012,
        "shikenId": 21,
        "parentNo": 2,
        "no": 13,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "横井浩二さん（41歳）が保険契約者（保険料負担者）および被保険者として加入している生命保険（下記＜資料＞参照）の保障内容に関する次の記述の空欄（ア）〜（ウ）にあてはまる数値を計算しなさい。なお、保険契約は有効に継続しているものとし、浩二さんはこれまでに＜資料＞の保険から、保険金および給付金を一度も受け取っていないものとする。また、各々の記述はそれぞれ独立した問題であり、相互に影響を与えないものとする。<br><img src=\"/img/question/21_13_1781050955194460_12.png\" class=\"question-img\" /><br><img src=\"/img/question/21_13_1781050955755659_13.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "万円",
        "choice3": "万円",
        "choice4": "",
        "choice5": "",
        "answer": "4,486,1210",
        "score": "2,2,2",
        "image": ""
    },
    {
        "id": 12013,
        "shikenId": 21,
        "parentNo": 2,
        "no": 14,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "庄司剛人さんが2026年中に支払った生命保険の保険料は下記＜資料＞のとおりである。この場合の庄司さんの2026年分の所得税の計算における生命保険料控除の金額を計算しなさい。なお、庄司剛人さんには23歳未満の扶養親族はいないものとし、生命保険料控除額が最も多くなるように計算すること。また、下記＜資料＞の保険について、これまでに契約内容の変更はないものとする。<br><img src=\"/img/question/21_14_1781050956372242_14.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "80000",
        "score": "2",
        "image": ""
    },
    {
        "id": 12014,
        "shikenId": 21,
        "parentNo": 1,
        "no": 15,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "水戸耕司さんが契約している生命保険（下記＜資料＞参照）に関する次の記述のうち、最も適切なものはどれか。なお、水戸耕司さんの法定相続人は、妻のかおりさんと、子の翔太さんの２人であるものとする。<br><img src=\"/img/question/21_15_1781050956903878_15.png\" class=\"question-img\" /><br><br>1）終身保険Ａから水戸かおりさんが死亡保険金を受け取る場合、相続税の非課税限度額の500万円を超える部分が相続税の課税対象となる。<br>2）収入保障保険Ｂから水戸かおりさんが死亡保険金を年金形式で受け取る場合、２年目以降の死亡年金は、所得税（雑所得）の課税対象となる。<br>3）定期保険Ｃから水戸耕司さんが受け取る死亡保険金は、相続税の課税対象となる。<br>4）養老保険Ｄから水戸翔太さんが一時金として受け取る満期保険金は、所得税（一時所得）の課税対象となる。",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 12015,
        "shikenId": 21,
        "parentNo": 1,
        "no": 16,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "リビングニーズ特約の一般的な説明に関する以下の記述について、空欄（ア）〜（エ）に入る語句の組み合わせとして、最も適切なものはどれか。<br><div style=\"border:solid 1px #333; padding:0.5em\">・リビングニーズ特約は、（ ア ）被保険者の余命が（ イ ）以内と医師により診断されたときに、死亡保険金の一部または全部を保険金として受け取ることができる特約です。<br>・請求できる金額は、保険金額の範囲内で１被保険者当たり（ ウ ）が限度となります。<br>・リビングニーズ特約の請求により被保険者が受け取った保険金は、（ エ ）となります。</div><br><br>1）（ア）所定の疾病により  （イ）３ヵ月  （ウ）3,000万円  （エ）所得税の課税対象<br>2）（ア）原因にかかわらず  （イ）６ヵ月  （ウ）3,000万円  （エ）非課税<br>3）（ア）所定の疾病により  （イ）６ヵ月  （ウ）5,000万円  （エ）所得税の課税対象<br>4）（ア）原因にかかわらず  （イ）３ヵ月  （ウ）5,000万円  （エ）非課税",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 12016,
        "shikenId": 21,
        "parentNo": 1,
        "no": 17,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "下記＜資料＞の保険の対象となる住宅建物が火災により500万円の損害を受けた場合、支払われる損害保険金の額として、正しいものはどれか。なお、特約は付帯されていないものとする。<br><img src=\"/img/question/21_17_1781050957205277_16.png\" class=\"question-img\" /><br><img src=\"/img/question/21_17_1781050957571058_17.png\" class=\"question-img\" /><br><br>1）5,000,000円<br>2）4,375,000円<br>3）4,000,000円<br>4）3,585,000円",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "2",
        "image": ""
    },
    {
        "id": 12017,
        "shikenId": 21,
        "parentNo": 2,
        "no": 18,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "国内に住所を有する居住者に対する所得税の仕組みに関する次の（ア）〜（エ）の説明について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_18_1781050958064901_18.png\" class=\"question-img\" /><br><br>（ア）居住者が生計を一にする子の医療費を支払ったことにより受けられる医療費控除は、税額控除として、一定金額を所得税額から差し引くことができる。<br>（イ）居住者がふるさと納税をしたことにより受けられる寄附金控除は、税額控除として、一定金額を所得税額から差し引くことができる。<br>（ウ）居住者が定期保険の保険料を支払ったことにより受けられる生命保険料控除は、所得控除として、一定金額を所得金額から差し引くことができる。<br>（エ）居住者が上場株式の配当における配当所得を総合課税とした場合に受けられる配当控除は、税額控除として、一定金額を所得税額から差し引くことができる。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12018,
        "shikenId": 21,
        "parentNo": 1,
        "no": 19,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "公的年金等に係る所得税の取扱いに関する次の記述のうち、最も不適切なものはどれか。<br><br>1）小規模企業共済の共済金や確定拠出年金の老齢給付金は、年金形式で受け取る場合、公的年金等に係る雑所得の収入金額となる。<br>2）公的年金等に係る雑所得の金額の計算は、「公的年金等の収入金額－公的年金等控除額」により計算するが、公的年金等控除額は、受給者の年齢が70歳以上か70歳未満かにより、控除額が異なる。<br>3）公的年金等以外の総合課税となる雑所得の金額に赤字が生じた場合、その赤字の金額と公的年金等に係る雑所得の金額を通算し、雑所得の金額を計算することができる。<br>4）公的年金等の収入金額が400万円以下であり、かつ、その公的年金等の全部が源泉徴収の対象となる場合において、公的年金等に係る雑所得以外の所得金額の合計が20万円以下であるときは、確定申告は不要である。",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "1",
        "image": ""
    },
    {
        "id": 12019,
        "shikenId": 21,
        "parentNo": 1,
        "no": 20,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "会社員の若田さんの2026年分の所得等が下記＜資料＞のとおりである場合、若田さんが2026年分の所得税の確定申告をする際に、給与所得と損益通算できる損失に関する次の記述のうち、最も適切なものはどれか。なお、▲が付された所得の金額は、その所得に損失が発生していることを意味するものとする。<br><img src=\"/img/question/21_20_1781050958334894_19.png\" class=\"question-img\" /><br><br>1）不動産所得の計算上生じた損失▲120万円と損益通算できる。<br>2）不動産所得の計算上生じた損失▲120万円およびゴルフ会員権の譲渡損失▲190万円と損益通算できる。<br>3）ゴルフ会員権の譲渡損失▲190万円および上場株式の譲渡損失▲50万円と損益通算できる。<br>4）損益通算できる損失はない。",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 12020,
        "shikenId": 21,
        "parentNo": 2,
        "no": 21,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "会社員の徳田さん（48歳）が2026年に支払った保険料等は下記のとおりである。この場合の徳田さんの2026年分の所得税における社会保険料控除額を計算しなさい。なお、記載のない条件については一切考慮しないものとする。<br><img src=\"/img/question/21_21_1781050958679062_20.png\" class=\"question-img\" /><br>（※１）いずれも徳田さんの給与明細および賞与明細に記載された給与および賞与から控除された保険料等の年額であり、会社負担分を含まない。<br>（※２）介護保険法の規定による介護保険料である。",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "55",
        "score": "2",
        "image": ""
    },
    {
        "id": 12021,
        "shikenId": 21,
        "parentNo": 1,
        "no": 22,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "事業所得者である馬場さんは、2026年の事業所得において他の所得と損益通算をしても、なお控除しきれない損失（純損失）が100万円程度発生する見込みである。また、馬場さんの前年度の所得は1,000万円である。この場合における馬場さんの所得税の申告に関する次の記述の空欄（ア）および（イ）にあてはまる語句の組み合わせとして、最も適切なものはどれか。<br><img src=\"/img/question/21_22_1781050958948221_21.png\" class=\"question-img\" /><br><br>1）（ア）繰り戻しによる還付<br>（イ）白色申告書または青色申告書<br>2）（ア）繰越控除<br>（イ）青色申告書<br>3）（ア）繰り戻しによる還付<br>（イ）青色申告書<br>4）（ア）繰越控除<br>（イ）白色申告書または青色申告書",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "1",
        "image": ""
    },
    {
        "id": 12022,
        "shikenId": 21,
        "parentNo": 1,
        "no": 23,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "松田大輔さんは、自分が死亡した場合に備えて、自宅（土地・建物）を妻の朋子さんに生前贈与することを検討している。仮に現時点（2026年９月１日）で大輔さんが保有する自宅（土地・建物）を贈与税の配偶者控除を活用して朋子さんに生前贈与した場合、朋子さんが納付すべき贈与税額として、正しいものはどれか。なお、朋子さんは贈与税の配偶者控除の適用を受けるための要件をすべて満たしており、2026年においてこれ以外に贈与により取得する財産はないものとする。<br><br><img src=\"/img/question/21_23_1781050959171825_22.png\" class=\"question-img\" /><br><br>1）2,270,000円<br>2）1,830,000円<br>3）1,740,000円<br>4）なし（贈与税は発生しない）",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "2",
        "score": "3",
        "image": ""
    },
    {
        "id": 12023,
        "shikenId": 21,
        "parentNo": 2,
        "no": 24,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "下記＜相続関係図＞の場合において、相続人の法定相続分などに関する次の記述の空欄（ア）〜（エ）に関する記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_24_1781050959709176_23.png\" class=\"question-img\" /><br><img src=\"/img/question/21_24_1781050959929882_24.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は「１/２」である。<br>（イ）空欄（イ）にあてはまる語句は「１/８」である。<br>（ウ）空欄（ウ）にあてはまる語句は「１/６」である。<br>（エ）空欄（エ）にあてはまる数値は「4,800」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12024,
        "shikenId": 21,
        "parentNo": 2,
        "no": 25,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "下記の相続事例（2026年４月15日相続開始）における相続税の課税価格の合計額を計算しなさい。なお、記載のない条件については一切考慮しないものとする。<br><img src=\"/img/question/21_25_1781050960174117_25.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "3200",
        "score": "3",
        "image": ""
    },
    {
        "id": 12025,
        "shikenId": 21,
        "parentNo": 1,
        "no": 26,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "相続税において相続財産から控除できる債務等に関する次の記述のうち、最も不適切なものはどれか。<br><br>1）葬式などの前後の出費で、通常葬式に欠かせないお通夜にかかった費用は、葬式費用として相続財産から控除することができる。<br>2）葬式にあたりお寺などに対して読経料などのお礼をした費用は、葬式費用として相続財産から控除することができる。<br>3）被相続人に係る未払いの固定資産税は、相続財産から控除することができる。<br>4）香典返しのためにかかった費用は、葬式費用として相続財産から控除することができる。",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 12026,
        "shikenId": 21,
        "parentNo": 2,
        "no": 27,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "相続に係る原則的な手続きに関する次の（ア）〜（エ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><br>（ア）相続放棄をする場合には、自己のために相続の開始があったことを知った時から、３ヵ月以内に家庭裁判所に申述しなければならない。<br>（イ）限定承認をする場合には、自己のために相続の開始があったことを知った時から、４ヵ月以内に家庭裁判所に申述しなければならない。<br>（ウ）遺産分割協議により遺産分割を行う場合には、相続の開始があったことを知った日から10ヵ月以内に遺産分割協議書を作成し、家庭裁判所に提出しなければならない。<br>（エ）相続税の納税義務がある場合には、相続の開始があったことを知った日の翌日から10ヵ月以内に申告書を提出しなければならない。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,2,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12027,
        "shikenId": 21,
        "parentNo": 2,
        "no": 28,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "野口家のキャッシュフロー表の空欄（ア）に入る数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用し、計算結果については万円未満を四捨五入すること。<br><img src=\"/img/question/21_28_1781050960682654_26.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "318",
        "score": "1",
        "image": ""
    },
    {
        "id": 12028,
        "shikenId": 21,
        "parentNo": 2,
        "no": 29,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "野口家のキャッシュフロー表の空欄（イ）に入る数値を計算しなさい。なお、計算に当たっては、キャッシュフロー表中に記載の整数を使用し、計算結果については万円未満を四捨五入すること。<br><img src=\"/img/question/21_29_1781050961255941_27.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1139",
        "score": "2",
        "image": ""
    },
    {
        "id": 12029,
        "shikenId": 21,
        "parentNo": 1,
        "no": 30,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "日本政策金融公庫の教育一般貸付（以下「国の教育ローン」という）に関する次の記述のうち、<br>最も適切なものはどれか。<br><br>1）貸付金利は、返済期間中の長期金利に連動する変動金利である。<br>2）海外留学資金以外の融資限度額は、学生・生徒１人につき550万円である。<br>3）申込人は、学生本人であり、学生の保護者が申込人となることはできない。<br>4）利用条件として、子どもの人数に応じた世帯年収の上限額が設けられている。",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "1",
        "image": ""
    },
    {
        "id": 12030,
        "shikenId": 21,
        "parentNo": 2,
        "no": 31,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "小田さんは、将来の有料老人ホームへの入居に備え、新たに積立てを開始する予定である。毎年年末に80万円を積み立てるものとし、10年間、年利1.0％で複利運用しながら積み立てた場合、10年後の合計額はいくらになるか。<br><img src=\"/img/question/21_31_1781050961911805_28.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "8369600",
        "score": "1",
        "image": ""
    },
    {
        "id": 12031,
        "shikenId": 21,
        "parentNo": 2,
        "no": 32,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "吉田さんは、マイホームの購入資金の一部として、これから毎年年末に１回ずつ一定金額を積み立てて、10年後に2,000万円を準備したいと考えている。10年間、年利1.0％で複利運用する場合、毎年いくらずつ積み立てればよいか。<br><img src=\"/img/question/21_32_1781050962376289_29.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1920000",
        "score": "1",
        "image": ""
    },
    {
        "id": 12032,
        "shikenId": 21,
        "parentNo": 2,
        "no": 33,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "野澤さんは、マンション取得時の住宅ローンとして、「フラット35（買取型）」に関心がある。<br>「フラット35（買取型）」に関する下表の空欄（ア）～（ウ）に入る語句として、適切なものには○、不適切なものには×を選びなさい。<br><img src=\"/img/question/21_33_1781050962839407_30.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は「8,000万」である。<br>（イ）空欄（イ）にあてはまる語句は「70㎡」である。<br>（ウ）空欄（ウ）にあてはまる語句は「融資実行」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1",
        "score": "1,1,1",
        "image": ""
    },
    {
        "id": 12033,
        "shikenId": 21,
        "parentNo": 2,
        "no": 34,
        "groupId": 1,
        "answerType": 4,
        "inputType": 8,
        "question1": "<img src=\"/img/question/21_34_1781050963187826_31.png\" class=\"question-img\" /><br><br>ＦＰの井上さんは、現時点（2026年９月１日時点）における川口家（大輔さんと美幸さん）のバランスシート分析を行うこととした。下表の空欄（ア）に入る数値を計算しなさい。<br><img src=\"/img/question/21_34_1781050963941694_32.png\" class=\"question-img\" />",
        "question2": "",
        "choice1": "万円",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "5320",
        "score": "3",
        "image": ""
    },
    {
        "id": 12034,
        "shikenId": 21,
        "parentNo": 2,
        "no": 35,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "土屋浩紀さんは、民間企業に勤務する会社員である。<br>浩紀さんと妻の春香さんはマンションの購入を検討しており、夫婦での住宅ローンの借入れについて知りたいと考えている。ＦＰで税理士でもある田野さんが説明した次の（ア）〜（エ）の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_35_1781050964276445_33.png\" class=\"question-img\" /><br><br>（ア）「連帯保証方式である収入合算で住宅ローンを契約した場合、浩紀さんと春香さんは二人とも団体信用生命保険を付保することができます。」<br>（イ）「連帯保証方式である収入合算を利用すると、夫婦の収入を合算して１つの住宅ローンを契約することはできますが、浩紀さんが単独で住宅ローンを契約する場合と比べて、借入金額を増やすことはできません。」<br>（ウ）「ペアローンは夫婦それぞれが住宅ローンを契約するため、一定の要件を満たせば、浩紀さんと春香さんは二人とも住宅借入金等特別控除（住宅ローン控除）の適用を受けることができます。」<br>（エ）「自動車ローンを完済すると、借入可能額が増える可能性があります。」",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,1",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12035,
        "shikenId": 21,
        "parentNo": 2,
        "no": 36,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "相知彩香さんは、民間企業に勤務する会社員である。相知さんは、出産のために仕事を休んだ場合に支給される出産手当金や、産前産後休業中の社会保険料の取扱いについて、ＦＰの山根さんに質問をした。出産手当金および産前産後休業中の社会保険料に関する次の記述について、適切なものは○、不適切なものは×を選択しなさい。なお、相知さんは、会社に就職してから継続して全国健康保険協会管掌健康保険（協会けんぽ）の被保険者であり、かつ厚生年金保険の被保険者であるものとする。<br><img src=\"/img/question/21_36_1781050964544072_34.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる数値は「56」である。<br>（イ）空欄（イ）にあてはまる語句は「４分の３」である。<br>（ウ）空欄（ウ）にあてはまる語句は「被保険者負担分および事業主負担分」である。<br>（エ）空欄（エ）にあてはまる語句は「保険料の未納期間」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "1,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12036,
        "shikenId": 21,
        "parentNo": 2,
        "no": 37,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "老齢年金の繰上げ支給と繰下げ支給に関する次の（ア）〜（エ）の記述のうち、適切なものは○、不適切なものは×を選択しなさい。<br><br>（ア）老齢基礎年金と老齢厚生年金の支給の繰上げは、その両方について同時に請求するほか、どちらか一方のみの請求をすることもできる。<br>（イ）老齢基礎年金の支給の繰上げの請求をしたとき、老齢基礎年金と併せて付加年金が支給される場合、付加年金は老齢基礎年金とは異なり減額されることはない。<br>（ウ）1952年４月２日以降生まれの者の場合、支給の繰下げによる年金額の増額率は最大で30％となる。<br>（エ）支給の繰下げを希望する場合は、65歳に達し受給権を取得した後、速やかに老齢年金の請求を行い、併せて66歳以降の繰下げ受給開始月に申し出なければならない。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,2,2",
        "score": "1,1,1,1",
        "image": ""
    },
    {
        "id": 12037,
        "shikenId": 21,
        "parentNo": 1,
        "no": 38,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "太田さんは、自分が死亡した場合の公的年金の遺族給付について知りたいと考えている。仮に太田さんが、2026年９月に54歳で在職中に死亡した場合に、太田さんの死亡時点において妻の明子さん（54歳）が受け取ることができる公的年金の遺族給付の額として、正しいものはどれか。<br>なお、太田さん夫婦には子（14歳と16歳）がおり、遺族年金の受給要件はすべて満たされているものとする。<br><img src=\"/img/question/21_38_1781050964946409_35.png\" class=\"question-img\" /><br><br>1）1,482,800円<br>2）1,563,100円<br>3）2,034,900円<br>4）2,182,800円",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "3",
        "score": "2",
        "image": ""
    },
    {
        "id": 12038,
        "shikenId": 21,
        "parentNo": 1,
        "no": 39,
        "groupId": 1,
        "answerType": 4,
        "inputType": 4,
        "question1": "本田さんは、2026年８月に病気（私傷病）療養のため休業したことから、健康保険から支給される傷病手当金について知りたいと考えている。本田さんの休業に関する状況は下記＜資料＞のとおりである。＜資料＞に基づき、本田さんに支給される傷病手当金に関する次の記述の（ア）、（イ）に入る適切な語句の組み合わせとして最も適切なものはどれか。なお、本田さんは、全国健康保険協会管掌健康保険（協会けんぽ）の被保険者である。また、記載以外の傷病手当金の受給要件はすべて満たしているものとする。<br><img src=\"/img/question/21_39_1781050965537449_36.png\" class=\"question-img\" /><br><img src=\"/img/question/21_39_1781050965827500_37.png\" class=\"question-img\" /><br><br>1）（ア）19日  （イ）１年<br>2）（ア）19日  （イ）１年６ヵ月<br>3）（ア）24日  （イ）１年<br>4）（ア）24日  （イ）１年６ヵ月",
        "question2": "",
        "choice1": "1",
        "choice2": "2",
        "choice3": "3",
        "choice4": "4",
        "choice5": "",
        "answer": "4",
        "score": "2",
        "image": ""
    },
    {
        "id": 12039,
        "shikenId": 21,
        "parentNo": 2,
        "no": 40,
        "groupId": 1,
        "answerType": 4,
        "inputType": 9,
        "question1": "労働者災害補償保険（以下「労災保険」という）の概要に関する下表の空欄（ア）〜（エ）に関する次の記述について、適切なものは○、不適切なものは×を選択しなさい。<br><img src=\"/img/question/21_40_1781050966045016_38.png\" class=\"question-img\" /><br><br>（ア）空欄（ア）にあてはまる語句は、「アルバイト・パートタイマー等は除かれる」である。<br>（イ）空欄（イ）にあてはまる語句は、「労働者は所得に応じて医療費の１割から３割を負担する」である。<br>（ウ）空欄（ウ）にあてはまる語句は、「事業の種類によって異なる」である。<br>（エ）空欄（エ）にあてはまる語句は、「事業主と労働者が折半して負担する」である。",
        "question2": "",
        "choice1": "",
        "choice2": "",
        "choice3": "",
        "choice4": "",
        "choice5": "",
        "answer": "2,2,1,2",
        "score": "1,1,1,1",
        "image": ""
    }
];
